/* eslint-disable max-len */

export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	bulbasaur: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L40"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			doubleedge: ["9M", "9L45"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			gigadrain: ["9M"],
			growl: ["9L1"],
			growth: ["9L6"],
			leechseed: ["9L9"],
			lightscreen: ["9M"],
			magicalleaf: ["9L30"],
			petaldance: ["9M"],
			poisonpowder: ["9L15"],
			protect: ["9M"],
			razorleaf: ["9L12"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9L15"],
			sludgebomb: ["9M"],
			sludgewave: ["9L42"],
			solarbeam: ["9M", "9L55"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L35"],
			tackle: ["9L1"],
			takedown: ["9L25"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L3"],
			workup: ["9M"],
		},
	},
	ivysaur: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L40"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			doubleedge: ["9M", "9L45"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			gigadrain: ["9M"],
			growl: ["9L1"],
			growth: ["9L6"],
			leechseed: ["9L9"],
			lightscreen: ["9M"],
			magicalleaf: ["9L30"],
			petaldance: ["9M"],
			poisonpowder: ["9L15"],
			protect: ["9M"],
			razorleaf: ["9L12"],
			roar: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9L15"],
			sludgebomb: ["9M"],
			sludgewave: ["9L42"],
			solarbeam: ["9M", "9L55"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L35"],
			tackle: ["9L1"],
			takedown: ["9L25"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L3"],
			workup: ["9M"],
		},
	},
	venusaur: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L40"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			doubleedge: ["9M", "9L45"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			growth: ["9L6"],
			hyperbeam: ["9M"],
			leechseed: ["9L9"],
			lightscreen: ["9M"],
			magicalleaf: ["9L30"],
			outrage: ["9M"],
			petaldance: ["9M"],
			poisonpowder: ["9L15"],
			powerwhip: ["9L0"],
			protect: ["9M"],
			razorleaf: ["9L12"],
			roar: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9L15"],
			sludgebomb: ["9M"],
			sludgewave: ["9L42"],
			solarbeam: ["9M", "9L55"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L35"],
			tackle: ["9L1"],
			takedown: ["9L25"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L3"],
			workup: ["9M"],
		},
	},
	charmander: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L42"],
			ember: ["9L4"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L17"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L30"],
			flareblitz: ["9M", "9L54"],
			focusblast: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			irontail: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L24"],
			smokescreen: ["9L8"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			willowisp: ["9M"],
		},
	},
	charmeleon: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L42"],
			ember: ["9L4"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L17"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L30"],
			flareblitz: ["9M", "9L54"],
			focusblast: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			irontail: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L24"],
			smokescreen: ["9L8"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			willowisp: ["9M"],
		},
	},
	charizard: {
		learnset: {
			airslash: ["9L0"],
			ancientpower: ["9M"],
			blastburn: ["9M"],
			blazekick: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L1"],
			dragonpulse: ["9M"],
			dragonrush: ["9L42"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			ember: ["9L4"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M", "9L0"],
			firefang: ["9M", "9L17"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			fissure: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L30"],
			flareblitz: ["9M", "9L54"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			ominouswind: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			slash: ["9L24"],
			smokescreen: ["9L8"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			willowisp: ["9M"],
		},
	},
	squirtle: {
		learnset: {
			aquajet: ["9L35"],
			aquaring: ["9L30"],
			bite: ["9L12"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L15"],
			chillingwater: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			flipturn: ["9M"],
			headbutt: ["9M"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M", "9L20"],
			irondefense: ["9M", "9L40"],
			ironhead: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M", "9L45"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			waterfall: ["9M"],
			watergun: ["9L3"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	wartortle: {
		learnset: {
			aquajet: ["9L35"],
			aquaring: ["9L30"],
			bite: ["9L12"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L15"],
			chillingwater: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			flipturn: ["9M"],
			headbutt: ["9M"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M", "9L20"],
			irondefense: ["9M", "9L40"],
			ironhead: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M", "9L45"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			waterfall: ["9M"],
			watergun: ["9L3"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	blastoise: {
		learnset: {
			aquajet: ["9L35"],
			aquaring: ["9L30"],
			bite: ["9L12"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L15"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M", "9L0"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M", "9L0"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M", "9L20"],
			irondefense: ["9M", "9L40"],
			ironhead: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M", "9L45"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			waterfall: ["9M"],
			watergun: ["9L3"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	weedle: {
		learnset: {
			electroweb: ["9M"],
			facade: ["9M"],
			poisonsting: ["9L1"],
			stringshot: ["9L1"],
		},
	},
	kakuna: {
		learnset: {
			electroweb: ["9M"],
			facade: ["9M"],
			harden: ["9L7"],
			irondefense: ["9M"],
			poisonsting: ["9L1"],
			stringshot: ["9L1"],
		},
	},
	beedrill: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L20"],
			bugbuzz: ["9L27"],
			doublehit: ["9M"],
			drillrun: ["9L40"],
			dualwingbeat: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusenergy: ["9L15"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L7"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lunge: ["9L33"],
			outrage: ["9M"],
			pinmissile: ["9L0"],
			poisonjab: ["9M", "9L35"],
			poisonsting: ["9L1"],
			protect: ["9M"],
			rocksmash: ["9M"],
			silverwind: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			stringshot: ["9L1"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M", "9L29"],
			uturn: ["9M"],
			xscissor: ["9M", "9L25"],
		},
	},
	pidgey: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L29"],
			airslash: ["9L33"],
			bravebird: ["9L50"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L40"],
			fly: ["9M"],
			growl: ["9L1"],
			gust: ["9L9"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L45"],
			protect: ["9M"],
			quickattack: ["9L13"],
			reflect: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			twister: ["9L17"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L25"],
			wingattack: ["9L21"],
			workup: ["9M"],
		},
	},
	pidgeotto: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L29"],
			airslash: ["9L33"],
			bravebird: ["9L50"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L40"],
			fly: ["9M"],
			growl: ["9L1"],
			gust: ["9L9"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L45"],
			ominouswind: ["9M"],
			protect: ["9M"],
			quickattack: ["9L13"],
			razorwind: ["9M"],
			reflect: ["9M"],
			skyattack: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			twister: ["9L17"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L25"],
			wingattack: ["9L21"],
			workup: ["9M"],
		},
	},
	pidgeot: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L29"],
			airslash: ["9L33"],
			bravebird: ["9L50"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L40"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gust: ["9L9"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L45"],
			hyperbeam: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			quickattack: ["9L13"],
			razorwind: ["9M"],
			reflect: ["9M"],
			skyattack: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			twister: ["9L17"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L25"],
			wingattack: ["9L21"],
			workup: ["9M"],
		},
	},
	ekans: {
		learnset: {
			acidspray: ["9M"],
			bite: ["9L9"],
			bodyslam: ["9M"],
			brutalswing: ["9L15"],
			bulldoze: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigadrain: ["9M"],
			glare: ["9L12"],
			gunkshot: ["9M", "9L49"],
			haze: ["9L41"],
			icefang: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leechlife: ["9L33"],
			leer: ["9L1"],
			mudshot: ["9M"],
			poisonfang: ["9M"],
			poisonjab: ["9M", "9L36"],
			poisonsting: ["9L4"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			thunderfang: ["9M"],
			toxic: ["9M", "9L25"],
			trailblaze: ["9M"],
		},
	},
	arbok: {
		learnset: {
			acidspray: ["9M"],
			bite: ["9L9"],
			bodyslam: ["9M"],
			brutalswing: ["9L15"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L0"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9L12"],
			gunkshot: ["9M", "9L49"],
			haze: ["9L41"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leechlife: ["9L33"],
			leer: ["9L1"],
			mudshot: ["9M"],
			poisonfang: ["9M"],
			poisonjab: ["9M", "9L36"],
			poisonsting: ["9L4"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			thunderfang: ["9M"],
			toxic: ["9M", "9L25"],
			trailblaze: ["9M"],
		},
	},
	pikachu: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			charge: ["9L30"],
			chargebeam: ["9M"],
			charm: ["9L20"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L0"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			growl: ["9L1"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L35"],
			nastyplot: ["9M"],
			nuzzle: ["9L12"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			skullbash: ["9M"],
			spark: ["9L16"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L40"],
			thunderbolt: ["9M", "9L25"],
			thunderpunch: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L4"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9L99"],
			wildcharge: ["9M"],
		},
	},
	raichu: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			charge: ["9L30"],
			chargebeam: ["9M"],
			charm: ["9L20"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L0"],
			drainpunch: ["9M"],
			eerieimpulse: ["9L0"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L35"],
			magnetbomb: ["9M"],
			nastyplot: ["9M"],
			nuzzle: ["9L12"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			skullbash: ["9M"],
			spark: ["9L16"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L40"],
			thunderbolt: ["9M", "9L25"],
			thunderpunch: ["9M", "9L0"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L4"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9L99"],
			wildcharge: ["9M"],
		},
	},
	raichualola: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charge: ["9L30"],
			chargebeam: ["9M"],
			charm: ["9L20"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L0"],
			eerieimpulse: ["9L0"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L35"],
			magnetbomb: ["9M"],
			nastyplot: ["9M"],
			nuzzle: ["9L12"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M", "9L0"],
			psyshock: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			skullbash: ["9M"],
			spark: ["9L16"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L40"],
			thunderbolt: ["9M", "9L25"],
			thunderpunch: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L4"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9L99"],
			wildcharge: ["9M"],
		},
	},
	clefairy: {
		learnset: {
			amnesia: ["9L28"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bubblebeam: ["9L22"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L13"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M", "9L32"],
			dig: ["9M"],
			disarmingvoice: ["9L8"],
			doubleedge: ["9M", "9L55"],
			drainingkiss: ["9L16"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L5"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L18"],
			meteorbeam: ["9M"],
			metronome: ["9M", "9L20"],
			moonblast: ["9L48"],
			moonlight: ["9L24"],
			mysticalfire: ["9L42"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			solarbeam: ["9M"],
			splash: ["9L1"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	clefable: {
		learnset: {
			airslash: ["9L52"],
			amnesia: ["9L28"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bubblebeam: ["9L22"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L13"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M", "9L32"],
			dig: ["9M"],
			disarmingvoice: ["9L8"],
			doubleedge: ["9M", "9L55"],
			drainingkiss: ["9L16"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L5"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L18"],
			meteorbeam: ["9M"],
			metronome: ["9M", "9L20"],
			moonblast: ["9L48"],
			moonlight: ["9L24"],
			mysticalfire: ["9L42"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			solarbeam: ["9M"],
			splash: ["9L1"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	jigglypuff: {
		learnset: {
			blizzard: ["9M"],
			bodyslam: ["9M", "9L24"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charm: ["9L1"],
			chillingwater: ["9M"],
			confusion: ["9L16"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L1"],
			doubleedge: ["9M", "9L44"],
			drainingkiss: ["9L12"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M", "9L18"],
			fakeout: ["9M"],
			faketears: ["9L14"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			headbutt: ["9M"],
			hypervoice: ["9M", "9L36"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L28"],
			moonblast: ["9L53"],
			nastyplot: ["9M"],
			perishsong: ["9L50"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rollout: ["9L10"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sing: ["9M", "9L1"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			triattack: ["9M"],
			waterpulse: ["9M"],
			wildcharge: ["9M"],
			wish: ["9L40"],
			zenheadbutt: ["9M"],
		},
	},
	wigglytuff: {
		learnset: {
			blizzard: ["9M"],
			bodyslam: ["9M", "9L24"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charm: ["9L1"],
			chillingwater: ["9M"],
			confusion: ["9L16"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L1"],
			doubleedge: ["9M", "9L44"],
			drainingkiss: ["9L12"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M", "9L18"],
			fakeout: ["9M"],
			faketears: ["9L14"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M", "9L36"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L28"],
			moonblast: ["9L53"],
			nastyplot: ["9M"],
			perishsong: ["9L50"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rollout: ["9L10"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sing: ["9M", "9L1"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			triattack: ["9M"],
			waterpulse: ["9M"],
			wildcharge: ["9M"],
			wish: ["9L40"],
			zenheadbutt: ["9M"],
		},
	},
	zubat: {
		learnset: {
			absorb: ["9L1"],
			agility: ["9M"],
			airslash: ["9L42"],
			bite: ["9L8"],
			confuseray: ["9L30"],
			crunch: ["9M"],
			curse: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			gigadrain: ["9M"],
			gust: ["9L5"],
			haze: ["9L26"],
			heatwave: ["9M"],
			hypnosis: ["9L22"],
			leechlife: ["9L50"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			poisonfang: ["9M", "9L34"],
			protect: ["9M"],
			quickattack: ["9L15"],
			razorwind: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L1"],
			swagger: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L18"],
			wingattack: ["9L12"],
			zenheadbutt: ["9M"],
		},
	},
	golbat: {
		learnset: {
			absorb: ["9L1"],
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L42"],
			bite: ["9L8"],
			confuseray: ["9L30"],
			crunch: ["9M"],
			curse: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gust: ["9L5"],
			haze: ["9L26"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L22"],
			leechlife: ["9L50"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			poisonfang: ["9M", "9L34"],
			protect: ["9M"],
			quickattack: ["9L15"],
			razorwind: ["9M"],
			screech: ["9L1"],
			shadowball: ["9M"],
			skyattack: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L1"],
			swagger: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			toxic: ["9M"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L18"],
			wingattack: ["9L12"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	meowth: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9L10"],
			bodyslam: ["9M"],
			charm: ["9L37"],
			chillingwater: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L40"],
			falseswipe: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L30"],
			icywind: ["9M"],
			knockoff: ["9M"],
			metronome: ["9M"],
			mimic: ["9M"],
			nastyplot: ["9M", "9L27"],
			payday: ["9M", "9L1"],
			playrough: ["9M", "9L48"],
			powergem: ["9M"],
			protect: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L22"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			takedown: ["9L34"],
			taunt: ["9M", "9L13"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
		},
	},
	meowthalola: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9L10"],
			bodyslam: ["9M"],
			charm: ["9L37"],
			chillingwater: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L40"],
			falseswipe: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L30"],
			icywind: ["9M"],
			knockoff: ["9M"],
			metalclaw: ["9L15"],
			metronome: ["9M"],
			mimic: ["9M"],
			nastyplot: ["9M", "9L27"],
			nightslash: ["9M", "9L22"],
			partingshot: ["9L6"],
			payday: ["9M", "9L1"],
			playrough: ["9M", "9L48"],
			powergem: ["9M"],
			protect: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			snarl: ["9L1"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			takedown: ["9L34"],
			taunt: ["9M", "9L13"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
		},
	},
	meowthgalar: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L10"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			charm: ["9L37"],
			closecombat: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L30"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			metalclaw: ["9L15"],
			metalsound: ["9L40"],
			metronome: ["9M"],
			mimic: ["9M", "9L44"],
			nastyplot: ["9M", "9L27"],
			nightslash: ["9M"],
			outrage: ["9M", "9L48"],
			payday: ["9M", "9L1"],
			playrough: ["9M"],
			protect: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L22"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tailwhip: ["9L6"],
			takedown: ["9L34"],
			taunt: ["9M", "9L13"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
			xscissor: ["9M"],
		},
	},
	persian: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9L10"],
			bodyslam: ["9M"],
			charm: ["9L37"],
			chillingwater: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L40"],
			falseswipe: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L30"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			metalclaw: ["9L15"],
			metronome: ["9M"],
			mimic: ["9M", "9L44"],
			nastyplot: ["9M", "9L27"],
			payday: ["9M", "9L1"],
			playrough: ["9M", "9L48"],
			powergem: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			slash: ["9L22"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			takedown: ["9L34"],
			taunt: ["9M", "9L13"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
		},
	},
	persianalola: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9L10"],
			bodyslam: ["9M"],
			charm: ["9L37"],
			chillingwater: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L40"],
			falseswipe: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L30"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			metalclaw: ["9L15"],
			metronome: ["9M"],
			mimic: ["9M", "9L44"],
			nastyplot: ["9M", "9L27"],
			nightslash: ["9M", "9L22"],
			partingshot: ["9L6"],
			payday: ["9M", "9L1"],
			playrough: ["9M", "9L48"],
			powergem: ["9M", "9L0"],
			protect: ["9M"],
			roar: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			snarl: ["9L1"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			takedown: ["9L34"],
			taunt: ["9M", "9L13"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
		},
	},
	mankey: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L25"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L22"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L44"],
			cometpunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M", "9L28"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L18"],
			leer: ["9L1"],
			lowsweep: ["9M", "9L16"],
			metronome: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M", "9L50"],
			overheat: ["9M"],
			payday: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L10"],
			rockthrow: ["9L8"],
			rocktomb: ["9M"],
			screech: ["9L40"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L13"],
			taunt: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			uturn: ["9M"],
			workup: ["9M"],
		},
	},
	primeape: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L25"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L22"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L44"],
			cometpunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M", "9L28"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L1"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L18"],
			leer: ["9L1"],
			lowsweep: ["9M", "9L16"],
			metronome: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M", "9L50"],
			overheat: ["9M"],
			payday: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			ragefist: ["9L35"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L10"],
			rockthrow: ["9L8"],
			rocktomb: ["9M"],
			screech: ["9L40"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L13"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
		},
	},
	abra: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			teleport: ["9L1"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	kadabra: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L50"],
			chargebeam: ["9M"],
			confusion: ["9L0"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			futuresight: ["9M", "9L45"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			protect: ["9M"],
			psybeam: ["9L1"],
			psychic: ["9M", "9L35"],
			psychocut: ["9L20"],
			psyshock: ["9M", "9L30"],
			recover: ["9L25"],
			reflect: ["9M", "9L10"],
			safeguard: ["9M", "9L40"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			teleport: ["9L1"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	alakazam: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L50"],
			chargebeam: ["9M"],
			confusion: ["9L0"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L45"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			protect: ["9M"],
			psybeam: ["9L1"],
			psychic: ["9M", "9L35"],
			psychocut: ["9L20"],
			psyshock: ["9M", "9L30"],
			recover: ["9L25"],
			reflect: ["9M", "9L10"],
			safeguard: ["9M", "9L40"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			teleport: ["9L1"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	machop: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L25"],
			brutalswing: ["9L14"],
			bulkup: ["9M", "9L20"],
			bulldoze: ["9M", "9L30"],
			bulletpunch: ["9L16"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			detect: ["9L36"],
			dig: ["9M"],
			doubleedge: ["9M", "9L44"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L4"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L18"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L12"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L1"],
			rocktomb: ["9M"],
			substitute: ["9M"],
			thunderpunch: ["9M"],
			workup: ["9M"],
		},
	},
	machoke: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L25"],
			brutalswing: ["9L14"],
			bulkup: ["9M", "9L20"],
			bulldoze: ["9M", "9L30"],
			bulletpunch: ["9L16"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			detect: ["9L36"],
			dig: ["9M"],
			doubleedge: ["9M", "9L44"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L4"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L18"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L12"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L1"],
			rocktomb: ["9M"],
			substitute: ["9M"],
			thunderpunch: ["9M"],
			workup: ["9M"],
		},
	},
	machamp: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L25"],
			brutalswing: ["9L14"],
			bulkup: ["9M", "9L20"],
			bulldoze: ["9M", "9L30"],
			bulletpunch: ["9L16"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			detect: ["9L36"],
			dig: ["9M"],
			doubleedge: ["9M", "9L44"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L4"],
			gigaimpact: ["9M"],
			heavyslam: ["9L40"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L18"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L12"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L1"],
			rocktomb: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			thunderpunch: ["9M"],
			workup: ["9M"],
		},
	},
	bellsprout: {
		learnset: {
			acidspray: ["9M"],
			bulletseed: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growth: ["9L1"],
			infestation: ["9L8"],
			knockoff: ["9M", "9L19"],
			leafstorm: ["9L48"],
			leechlife: ["9L33"],
			magicalleaf: ["9L23"],
			poisonjab: ["9M", "9L30"],
			poisonpowder: ["9L15"],
			powerwhip: ["9L44"],
			protect: ["9M"],
			razorleaf: ["9L10"],
			reflect: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9L13"],
			sludgewave: ["9L40"],
			solarbeam: ["9M"],
			stunspore: ["9L17"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M", "9L26"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
		},
	},
	weepinbell: {
		learnset: {
			acidspray: ["9M"],
			bulletseed: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growth: ["9L1"],
			infestation: ["9L8"],
			knockoff: ["9M", "9L19"],
			leafstorm: ["9L48"],
			leechlife: ["9L33"],
			lunge: ["9L0"],
			magicalleaf: ["9L23"],
			poisonjab: ["9M", "9L30"],
			poisonpowder: ["9L15"],
			powerwhip: ["9L44"],
			protect: ["9M"],
			razorleaf: ["9L10"],
			reflect: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9L13"],
			sludgewave: ["9L40"],
			solarbeam: ["9M"],
			stunspore: ["9L17"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M", "9L26"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
		},
	},
	victreebel: {
		learnset: {
			acidspray: ["9M"],
			bulletseed: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			growth: ["9L1"],
			hyperbeam: ["9M"],
			infestation: ["9L8"],
			knockoff: ["9M", "9L19"],
			leafstorm: ["9L48"],
			leechlife: ["9L33"],
			lunge: ["9L1"],
			magicalleaf: ["9L23"],
			poisonjab: ["9M", "9L30"],
			poisonpowder: ["9L15"],
			powerwhip: ["9L44"],
			protect: ["9M"],
			razorleaf: ["9L10"],
			reflect: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9L13"],
			sludgebomb: ["9M", "9L0"],
			sludgewave: ["9L40"],
			solarbeam: ["9M"],
			stunspore: ["9L17"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M", "9L26"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
		},
	},
	slowpoke: {
		learnset: {
			amnesia: ["9L27"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L1"],
			curse: ["9M", "9L1"],
			dig: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			growl: ["9L3"],
			headbutt: ["9M", "9L21"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L42"],
			psyshock: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L36"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M", "9L18"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	slowpokegalar: {
		learnset: {
			amnesia: ["9L27"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L1"],
			curse: ["9M", "9L1"],
			dig: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			growl: ["9L3"],
			headbutt: ["9M", "9L21"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L42"],
			psyshock: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L36"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M", "9L18"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	slowbro: {
		learnset: {
			amnesia: ["9L27"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L1"],
			curse: ["9M", "9L1"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L45"],
			gigaimpact: ["9M"],
			growl: ["9L3"],
			headbutt: ["9M", "9L21"],
			healblock: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			metronome: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L42"],
			psyshock: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L36"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M", "9L18"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	slowbrogalar: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L27"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L1"],
			curse: ["9M", "9L1"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L45"],
			gigaimpact: ["9M"],
			growl: ["9L3"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L21"],
			healblock: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			metronome: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			poisonjab: ["9M", "9L33"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L42"],
			psyshock: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			sludgebomb: ["9M", "9L40"],
			substitute: ["9M"],
			surf: ["9M", "9L36"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M", "9L18"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	farfetchd: {
		learnset: {
			aerialace: ["9M", "9L16"],
			agility: ["9M", "9L47"],
			airslash: ["9L40"],
			bodyslam: ["9M"],
			bravebird: ["9L55"],
			brutalswing: ["9L24"],
			closecombat: ["9M"],
			curse: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M", "9L25"],
			featherdance: ["9L36"],
			firstimpression: ["9M"],
			fly: ["9M"],
			focusenergy: ["9L27"],
			gust: ["9L10"],
			heatwave: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M", "9L20"],
			leafblade: ["9L42"],
			leer: ["9L1"],
			nightslash: ["9M"],
			peck: ["9L1"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L22"],
			razorwind: ["9M"],
			skyattack: ["9M"],
			slash: ["9L30"],
			solarblade: ["9M"],
			steelwing: ["9L12"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L34"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			workup: ["9M"],
		},
	},
	farfetchdgalar: {
		learnset: {
			aerialace: ["9M", "9L16"],
			agility: ["9M", "9L47"],
			bodyslam: ["9M"],
			bravebird: ["9L55"],
			brickbreak: ["9M", "9L40"],
			brutalswing: ["9L24"],
			closecombat: ["9M"],
			curse: ["9M"],
			detect: ["9L1"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M", "9L25"],
			featherdance: ["9L36"],
			firstimpression: ["9M"],
			fly: ["9M"],
			focusenergy: ["9L27"],
			irontail: ["9M"],
			knockoff: ["9M", "9L20"],
			leafblade: ["9L42"],
			leer: ["9L1"],
			nightslash: ["9M"],
			peck: ["9L1"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L22"],
			razorwind: ["9M"],
			rocksmash: ["9M", "9L10"],
			skyattack: ["9M"],
			slash: ["9L30"],
			solarblade: ["9M"],
			steelwing: ["9L12"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L34"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
		},
	},
	gastly: {
		learnset: {
			acidspray: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L8"],
			curse: ["9M", "9L20"],
			darkpulse: ["9M", "9L36"],
			dazzlinggleam: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gunkshot: ["9M"],
			haze: ["9L24"],
			hypnosis: ["9L4"],
			icywind: ["9M", "9L28"],
			lick: ["9L1"],
			nastyplot: ["9M"],
			perishsong: ["9L50"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowsneak: ["9L12"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			willowisp: ["9M"],
		},
	},
	haunter: {
		learnset: {
			acidspray: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L8"],
			curse: ["9M", "9L20"],
			darkpulse: ["9M", "9L36"],
			dazzlinggleam: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			gigadrain: ["9M"],
			gunkshot: ["9M"],
			haze: ["9L24"],
			hypnosis: ["9L4"],
			icepunch: ["9M"],
			icywind: ["9M", "9L28"],
			lick: ["9L1"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			perishsong: ["9L50"],
			phantomforce: ["9L55"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowclaw: ["9M", "9L16"],
			shadowpunch: ["9M"],
			shadowsneak: ["9L12"],
			sludgebomb: ["9M"],
			sludgewave: ["9L48"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			willowisp: ["9M"],
		},
	},
	gengar: {
		learnset: {
			acidspray: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L8"],
			curse: ["9M", "9L20"],
			darkpulse: ["9M", "9L36"],
			dazzlinggleam: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			haze: ["9L24"],
			hyperbeam: ["9M"],
			hypnosis: ["9L4"],
			icepunch: ["9M"],
			icywind: ["9M", "9L28"],
			lick: ["9L1"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			perishsong: ["9L50"],
			phantomforce: ["9L55"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowclaw: ["9M", "9L16"],
			shadowpunch: ["9M"],
			shadowsneak: ["9L12"],
			sludgebomb: ["9M"],
			sludgewave: ["9L48"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			willowisp: ["9M"],
		},
	},
	onix: {
		learnset: {
			breakingswipe: ["9L22"],
			curse: ["9M", "9L16"],
			dig: ["9M", "9L44"],
			doubleedge: ["9M", "9L56"],
			dragonbreath: ["9L12"],
			dragonpulse: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			harden: ["9L1"],
			headsmash: ["9L62"],
			ironhead: ["9M"],
			irontail: ["9M", "9L48"],
			meteorbeam: ["9M"],
			protect: ["9M"],
			rockblast: ["9L0"],
			rockslide: ["9M", "9L20"],
			rockthrow: ["9L1"],
			rocktomb: ["9M"],
			sandtomb: ["9L28"],
			scorchingsands: ["9M"],
			screech: ["9L24"],
			selfdestruct: ["9M"],
			stealthrock: ["9M", "9L32"],
			stoneedge: ["9M", "9L52"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
		},
	},
	cubone: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bonemerang: ["9L40"],
			brickbreak: ["9M"],
			brutalswing: ["9L29"],
			bulldoze: ["9M", "9L24"],
			curse: ["9M"],
			detect: ["9L18"],
			dig: ["9M"],
			doubleedge: ["9M", "9L48"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M", "9L8"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusenergy: ["9L32"],
			growl: ["9L1"],
			headbutt: ["9M", "9L12"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			leer: ["9L7"],
			perishsong: ["9L55"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L44"],
			tackle: ["9L1"],
			tailwhip: ["9L4"],
			thunderpunch: ["9M"],
		},
	},
	marowak: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bonemerang: ["9L40"],
			brickbreak: ["9M"],
			brutalswing: ["9L29"],
			bulldoze: ["9M", "9L24"],
			curse: ["9M"],
			detect: ["9L18"],
			dig: ["9M"],
			doubleedge: ["9M", "9L48"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M", "9L8"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L32"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M", "9L12"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			leer: ["9L7"],
			outrage: ["9M"],
			perishsong: ["9L55"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L44"],
			tackle: ["9L1"],
			tailwhip: ["9L4"],
			thunderpunch: ["9M"],
		},
	},
	marowakalola: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bonemerang: ["9L40"],
			brickbreak: ["9M"],
			brutalswing: ["9L29"],
			bulldoze: ["9M", "9L24"],
			curse: ["9M"],
			darkpulse: ["9M"],
			detect: ["9L18"],
			dig: ["9M"],
			doubleedge: ["9M", "9L48"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M", "9L8"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			fissure: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flamewheel: ["9L0"],
			flareblitz: ["9M", "9L58"],
			focusblast: ["9M"],
			focusenergy: ["9L32"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M", "9L12"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			leer: ["9L7"],
			outrage: ["9M"],
			perishsong: ["9L55"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			shadowbone: ["9L0"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L44"],
			tackle: ["9L1"],
			tailwhip: ["9L4"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			willowisp: ["9M"],
		},
	},
	kangaskhan: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L12"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			circlethrow: ["9M"],
			cometpunch: ["9M"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doublehit: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M", "9L40"],
			facade: ["9M"],
			fakeout: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L20"],
			gigaimpact: ["9M"],
			growl: ["9L4"],
			headbutt: ["9M", "9L24"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			outrage: ["9M", "9L48"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L32"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	staryu: {
		learnset: {
			aquajet: ["9L12"],
			blizzard: ["9M"],
			bubblebeam: ["9L20"],
			confuseray: ["9L8"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			flipturn: ["9M"],
			harden: ["9L1"],
			hydropump: ["9M", "9L56"],
			icebeam: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M", "9L32"],
			powergem: ["9M", "9L36"],
			protect: ["9M"],
			psybeam: ["9L24"],
			psychic: ["9M", "9L40"],
			recover: ["9L48"],
			reflect: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			selfdestruct: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L44"],
			swift: ["9M", "9L16"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L4"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
		},
	},
	starmie: {
		learnset: {
			agility: ["9M"],
			ancientpower: ["9M"],
			aquajet: ["9L12"],
			blizzard: ["9M"],
			bubblebeam: ["9L20"],
			bulkup: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9L8"],
			dazzlinggleam: ["9M"],
			doubleedge: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hydropump: ["9M", "9L56"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M", "9L32"],
			liquidation: ["9M", "9L42"],
			meteorbeam: ["9M"],
			powergem: ["9M", "9L36"],
			protect: ["9M"],
			psybeam: ["9L24"],
			psychic: ["9M", "9L40"],
			psyshock: ["9M"],
			recover: ["9L48"],
			reflect: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			selfdestruct: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L44"],
			swift: ["9M", "9L16"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			tripleaxel: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L4"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	mrmime: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L8"],
			cometpunch: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L12"],
			dazzlinggleam: ["9M", "9L44"],
			drainpunch: ["9M"],
			dreameater: ["9M", "9L15"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			firstimpression: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L0"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L1"],
			icepunch: ["9M"],
			icywind: ["9M"],
			infestation: ["9L17"],
			irondefense: ["9M"],
			lightscreen: ["9M", "9L36"],
			magnetbomb: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L32"],
			mist: ["9L0"],
			mysticalfire: ["9L40"],
			nastyplot: ["9M"],
			playrough: ["9M"],
			protect: ["9M", "9L20"],
			psybeam: ["9L28"],
			psychic: ["9M", "9L48"],
			psyshock: ["9M"],
			reflect: ["9M", "9L36"],
			safeguard: ["9M", "9L36"],
			shadowball: ["9M"],
			smokescreen: ["9L0"],
			solarbeam: ["9M"],
			stealthrock: ["9M", "9L24"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			tripleaxel: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	mrmimegalar: {
		learnset: {
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			cometpunch: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L12"],
			dazzlinggleam: ["9M", "9L44"],
			drainpunch: ["9M"],
			dreameater: ["9M", "9L15"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firstimpression: ["9M"],
			focusblast: ["9M"],
			freezedry: ["9L40"],
			frostbreath: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L0"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L1"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9L1"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			infestation: ["9L17"],
			irondefense: ["9M"],
			lightscreen: ["9M", "9L36"],
			magnetbomb: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L32"],
			mist: ["9L0"],
			nastyplot: ["9M"],
			protect: ["9M", "9L20"],
			psybeam: ["9L28"],
			psychic: ["9M", "9L48"],
			psyshock: ["9M"],
			reflect: ["9M", "9L36"],
			safeguard: ["9M", "9L36"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			smokescreen: ["9L0"],
			solarbeam: ["9M"],
			stealthrock: ["9M", "9L24"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			tripleaxel: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	scyther: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L36"],
			brickbreak: ["9M"],
			brutalswing: ["9L20"],
			bugbuzz: ["9L34"],
			closecombat: ["9M"],
			doubleedge: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M", "9L16"],
			dualchop: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusenergy: ["9L28"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lunge: ["9L46"],
			nightslash: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			silverwind: ["9M"],
			slash: ["9L24"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L42"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			wingattack: ["9L12"],
			xscissor: ["9M", "9L32"],
		},
	},
	pinsir: {
		learnset: {
			aerialace: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L16"],
			bulkup: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L50"],
			detect: ["9L20"],
			dig: ["9M"],
			doublehit: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L4"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lunge: ["9L36"],
			outrage: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L8"],
			rocktomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L40"],
			tackle: ["9L1"],
			takedown: ["9L24"],
			xscissor: ["9M", "9L32"],
		},
	},
	magikarp: {
		learnset: {
			facade: ["9M"],
			hydropump: ["9M"],
			splash: ["9L1"],
			tackle: ["9L15"],
		},
	},
	gyarados: {
		learnset: {
			bite: ["9L0"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9L40"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L30"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L45"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			hurricane: ["9M", "9L44"],
			hydropump: ["9M", "9L50"],
			hyperbeam: ["9M", "9L55"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M", "9L33"],
			irontail: ["9M"],
			leer: ["9L1"],
			muddywater: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			skullbash: ["9M"],
			splash: ["9L1"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			twister: ["9L1"],
			waterfall: ["9M", "9L24"],
			watergun: ["9L0"],
			waterpulse: ["9M"],
			whirlpool: ["9M", "9L0"],
		},
	},
	eevee: {
		learnset: {
			bite: ["9L25"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9L45"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L50"],
			endure: ["9M"],
			facade: ["9M"],
			growl: ["9L1"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			mimic: ["9M"],
			protect: ["9M"],
			quickattack: ["9L10"],
			roar: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L20"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L40"],
			trailblaze: ["9M"],
			wish: ["9L30"],
		},
	},
	vaporeon: {
		learnset: {
			acidarmor: ["9L45"],
			aquaring: ["9L35"],
			bite: ["9L1"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bubblebeam: ["9L20"],
			calmmind: ["9M"],
			charm: ["9L0"],
			chillingwater: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			haze: ["9L25"],
			headbutt: ["9M"],
			hydropump: ["9M", "9L50"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M", "9L30"],
			irontail: ["9M"],
			liquidation: ["9M"],
			mimic: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			quickattack: ["9L10"],
			roar: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L40"],
			swift: ["9M", "9L0"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L0"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			wish: ["9L0"],
		},
	},
	jolteon: {
		learnset: {
			agility: ["9M"],
			bite: ["9L1"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L0"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			discharge: ["9M"],
			doubleedge: ["9M", "9L0"],
			eerieimpulse: ["9L0"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L45"],
			falseswipe: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M", "9L25"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			mimic: ["9M"],
			pinmissile: ["9L35"],
			protect: ["9M"],
			quickattack: ["9L10"],
			roar: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L0"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			thunder: ["9M", "9L50"],
			thunderbolt: ["9M", "9L40"],
			thunderfang: ["9M", "9L30"],
			thundershock: ["9L0"],
			thunderwave: ["9M", "9L20"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
			wish: ["9L0"],
		},
	},
	flareon: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9L0"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			ember: ["9L0"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L35"],
			firespin: ["9M", "9L30"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flamewheel: ["9L25"],
			flareblitz: ["9M", "9L50"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			lavaplume: ["9L40"],
			mimic: ["9M"],
			protect: ["9M"],
			quickattack: ["9L10"],
			roar: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			smokescreen: ["9L20"],
			substitute: ["9M"],
			swift: ["9M", "9L0"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			wish: ["9L0"],
		},
	},
	porygon: {
		learnset: {
			agility: ["9M", "9L30"],
			blizzard: ["9M"],
			charge: ["9L1"],
			chargebeam: ["9M"],
			confuseray: ["9L1"],
			conversion: ["9L1"],
			conversion2: ["9L25"],
			discharge: ["9M", "9L40"],
			doubleedge: ["9M"],
			eerieimpulse: ["9L10"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			magnetbomb: ["9M"],
			metalsound: ["9L45"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9L35"],
			reflect: ["9M"],
			selfdestruct: ["9M", "9L50"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thundershock: ["9L15"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			voltswitch: ["9M"],
			zapcannon: ["9L55"],
			zenheadbutt: ["9M"],
		},
	},
	aerodactyl: {
		learnset: {
			agility: ["9M"],
			ancientpower: ["9M"],
			bite: ["9L1"],
			crunch: ["9M", "9L30"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dualwingbeat: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M", "9L60"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M", "9L55"],
			icefang: ["9M"],
			ironhead: ["9M", "9L35"],
			irontail: ["9M"],
			meteorbeam: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L25"],
			rockblast: ["9L15"],
			rockslide: ["9M", "9L20"],
			rocktomb: ["9M"],
			skyattack: ["9M"],
			stealthrock: ["9M"],
			steelwing: ["9L1"],
			stoneedge: ["9M", "9L45"],
			substitute: ["9M"],
			supersonic: ["9L5"],
			swagger: ["9M"],
			swift: ["9M"],
			takedown: ["9L40"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			whirlwind: ["9M"],
			wingattack: ["9L10"],
		},
	},
	dratini: {
		learnset: {
			agility: ["9M"],
			blizzard: ["9M"],
			breakingswipe: ["9L20"],
			brutalswing: ["9L25"],
			chillingwater: ["9M"],
			dracometeor: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L30"],
			endure: ["9M"],
			extremespeed: ["9L50"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M", "9L60"],
			icebeam: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			outrage: ["9M", "9L55"],
			protect: ["9M"],
			safeguard: ["9M", "9L40"],
			scaleshot: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L15"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M", "9L10"],
			twister: ["9L5"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
		},
	},
	dragonair: {
		learnset: {
			agility: ["9M"],
			blizzard: ["9M"],
			breakingswipe: ["9L20"],
			brutalswing: ["9L25"],
			chillingwater: ["9M"],
			dracometeor: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L30"],
			endure: ["9M"],
			extremespeed: ["9L50"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M", "9L60"],
			icebeam: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			outrage: ["9M", "9L55"],
			protect: ["9M"],
			safeguard: ["9M", "9L40"],
			scaleshot: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L15"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M", "9L10"],
			twister: ["9L5"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
		},
	},
	dragonite: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L1"],
			blizzard: ["9M"],
			breakingswipe: ["9L20"],
			brickbreak: ["9M"],
			brutalswing: ["9L25"],
			chillingwater: ["9M"],
			dracometeor: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L30"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			extremespeed: ["9L50"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M", "9L0"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L0"],
			hydropump: ["9M"],
			hyperbeam: ["9M", "9L60"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			outrage: ["9M", "9L55"],
			protect: ["9M"],
			razorwind: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M", "9L40"],
			scaleshot: ["9M"],
			skullbash: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L15"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M", "9L0"],
			thunderwave: ["9M", "9L10"],
			twister: ["9L5"],
			vacuumwave: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			whirlwind: ["9M"],
			wingattack: ["9L0"],
		},
	},
	mewtwo: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			amnesia: ["9L32", "9S10"],
			ancientpower: ["9M"],
			aurasphere: ["9L40", "9S10"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			cometpunch: ["9M"],
			confusion: ["9L1"],
			darkpulse: ["9M"],
			discharge: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L88"],
			gigaimpact: ["9M"],
			healblock: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			mist: ["9L64"],
			nastyplot: ["9M"],
			payday: ["9M"],
			poisonjab: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psybeam: ["9L12"],
			psychic: ["9M", "9L48", "9S10"],
			psychocut: ["9L16", "9S10"],
			psyshock: ["9M"],
			psystrike: ["9L72"],
			recover: ["9L80"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M", "9L24"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			solarbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			triattack: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	chikorita: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M", "9L22"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L9"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			headbutt: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leafage: ["9L6"],
			leafstorm: ["9L56"],
			leechseed: ["9L14"],
			lightscreen: ["9M", "9L50"],
			protect: ["9M"],
			razorleaf: ["9L12"],
			reflect: ["9M", "9L27"],
			safeguard: ["9M", "9L36"],
			seedbomb: ["9M"],
			solarbeam: ["9M", "9L45"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L40"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			trailblaze: ["9M"],
			workup: ["9M"],
		},
	},
	bayleef: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M", "9L22"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L9"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M", "9L0"],
			headbutt: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leafage: ["9L6"],
			leafstorm: ["9L56"],
			leechseed: ["9L14"],
			lightscreen: ["9M", "9L50"],
			protect: ["9M"],
			razorleaf: ["9L12"],
			reflect: ["9M", "9L27"],
			rocksmash: ["9M"],
			safeguard: ["9M", "9L36"],
			seedbomb: ["9M"],
			solarbeam: ["9M", "9L45"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L40"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			trailblaze: ["9M"],
			workup: ["9M"],
		},
	},
	meganium: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M", "9L22"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L9"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M", "9L0"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leafage: ["9L6"],
			leafblade: ["9L0"],
			leafstorm: ["9L56"],
			leechseed: ["9L14"],
			lightscreen: ["9M", "9L50"],
			outrage: ["9M"],
			petaldance: ["9M"],
			protect: ["9M"],
			razorleaf: ["9L12"],
			reflect: ["9M", "9L27"],
			rocksmash: ["9M"],
			safeguard: ["9M", "9L36"],
			seedbomb: ["9M"],
			solarbeam: ["9M", "9L45"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L40"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			trailblaze: ["9M"],
			workup: ["9M"],
		},
	},
	totodile: {
		learnset: {
			ancientpower: ["9M"],
			aquajet: ["9L21"],
			bite: ["9L10"],
			blizzard: ["9M"],
			breakingswipe: ["9L26"],
			brickbreak: ["9M"],
			bubblebeam: ["9L15"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M"],
			dragonclaw: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			hydropump: ["9M", "9L50"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			leer: ["9L1"],
			liquidation: ["9M", "9L40"],
			muddywater: ["9M"],
			outrage: ["9M", "9L56"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			screech: ["9L35"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	croconaw: {
		learnset: {
			ancientpower: ["9M"],
			aquajet: ["9L21"],
			bite: ["9L10"],
			blizzard: ["9M"],
			breakingswipe: ["9L26"],
			brickbreak: ["9M"],
			bubblebeam: ["9L15"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M"],
			dragonclaw: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			hydropump: ["9M", "9L50"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			leer: ["9L1"],
			liquidation: ["9M", "9L40"],
			muddywater: ["9M"],
			outrage: ["9M", "9L56"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			screech: ["9L35"],
			slash: ["9L0"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	feraligatr: {
		learnset: {
			agility: ["9M"],
			ancientpower: ["9M"],
			aquajet: ["9L21"],
			bite: ["9L10"],
			blizzard: ["9M"],
			breakingswipe: ["9L26"],
			brickbreak: ["9M"],
			bubblebeam: ["9L15"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L0"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			dragonclaw: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M", "9L50"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			leer: ["9L1"],
			liquidation: ["9M", "9L40"],
			muddywater: ["9M"],
			outrage: ["9M", "9L56"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			razorwind: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L35"],
			slash: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	spinarak: {
		learnset: {
			absorb: ["9L5"],
			acidspray: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			bugbuzz: ["9L35"],
			dig: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			headbutt: ["9M"],
			infestation: ["9L8"],
			knockoff: ["9M"],
			leechlife: ["9L37"],
			lunge: ["9L40"],
			megahorn: ["9L44"],
			pinmissile: ["9L27"],
			poisonjab: ["9M", "9L33"],
			poisonsting: ["9L1"],
			protect: ["9M"],
			psychic: ["9M", "9L30"],
			screech: ["9L21"],
			shadowsneak: ["9L12"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			stickyweb: ["9L24"],
			stringshot: ["9L1"],
			substitute: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			xscissor: ["9M", "9L16"],
		},
	},
	ariados: {
		learnset: {
			absorb: ["9L5"],
			acidspray: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			bugbuzz: ["9L35"],
			dig: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			firstimpression: ["9M"],
			focusenergy: ["9L1"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			infestation: ["9L8"],
			knockoff: ["9M"],
			leechlife: ["9L37"],
			lunge: ["9L40"],
			megahorn: ["9L44"],
			pinmissile: ["9L27"],
			poisonjab: ["9M", "9L33"],
			poisonsting: ["9L1"],
			protect: ["9M"],
			psychic: ["9M", "9L30"],
			screech: ["9L21"],
			shadowsneak: ["9L12"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			stickyweb: ["9L24"],
			stringshot: ["9L1"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L0"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			xscissor: ["9M", "9L16"],
		},
	},
	crobat: {
		learnset: {
			absorb: ["9L1"],
			acidspray: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L42"],
			bite: ["9L8"],
			bravebird: ["9L53"],
			confuseray: ["9L30"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gust: ["9L5"],
			haze: ["9L26"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L22"],
			knockoff: ["9M"],
			leechlife: ["9L50"],
			nastyplot: ["9M"],
			nightslash: ["9M"],
			ominouswind: ["9M"],
			poisonfang: ["9M", "9L34"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9L15"],
			razorwind: ["9M"],
			screech: ["9L1"],
			shadowball: ["9M"],
			skyattack: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L1"],
			swagger: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			toxic: ["9M"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L18"],
			wingattack: ["9L12"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	pichu: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			charge: ["9L30"],
			charm: ["9L20"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			growl: ["9L1"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L35"],
			nastyplot: ["9M"],
			nuzzle: ["9L12"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			spark: ["9L16"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L40"],
			thunderbolt: ["9M", "9L25"],
			thunderpunch: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L4"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9L99"],
			wildcharge: ["9M"],
		},
	},
	cleffa: {
		learnset: {
			amnesia: ["9L28"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bubblebeam: ["9L22"],
			calmmind: ["9M"],
			charm: ["9L13"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L8"],
			doubleedge: ["9M", "9L55"],
			drainingkiss: ["9L16"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L5"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			headbutt: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L18"],
			metronome: ["9M", "9L20"],
			moonblast: ["9L48"],
			moonlight: ["9L24"],
			mysticalfire: ["9L42"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			solarbeam: ["9M"],
			splash: ["9L1"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	igglybuff: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charm: ["9L1"],
			confusion: ["9L16"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L1"],
			doubleedge: ["9M"],
			drainingkiss: ["9L12"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M", "9L18"],
			faketears: ["9L14"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			hypervoice: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			mimic: ["9M", "9L28"],
			nastyplot: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rollout: ["9L10"],
			shadowball: ["9M"],
			sing: ["9M", "9L1"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			wildcharge: ["9M"],
			wish: ["9L40"],
			zenheadbutt: ["9M"],
		},
	},
	mareep: {
		learnset: {
			bodyslam: ["9M"],
			charge: ["9L15"],
			chargebeam: ["9M"],
			confuseray: ["9L17"],
			cottonguard: ["9L28"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			growl: ["9L1"],
			lightscreen: ["9M", "9L40"],
			powergem: ["9M", "9L32"],
			protect: ["9M"],
			reflect: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M", "9L45"],
			thunderbolt: ["9M", "9L36"],
			thundershock: ["9L4"],
			thunderwave: ["9M", "9L8"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	flaaffy: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			charge: ["9L15"],
			chargebeam: ["9M"],
			confuseray: ["9L17"],
			cottonguard: ["9L28"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			growl: ["9L1"],
			icepunch: ["9M"],
			lightscreen: ["9M", "9L40"],
			powergem: ["9M", "9L32"],
			protect: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M", "9L45"],
			thunderbolt: ["9M", "9L36"],
			thundershock: ["9L4"],
			thunderwave: ["9M", "9L8"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	ampharos: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9L42"],
			brickbreak: ["9M"],
			charge: ["9L15"],
			chargebeam: ["9M"],
			cometpunch: ["9M"],
			confuseray: ["9L17"],
			cottonguard: ["9L28"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			dualchop: ["9M"],
			eerieimpulse: ["9L0"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			lightscreen: ["9M", "9L40"],
			meteorbeam: ["9M"],
			outrage: ["9M"],
			powergem: ["9M", "9L32"],
			protect: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M", "9L45"],
			thunderbolt: ["9M", "9L36"],
			thunderpunch: ["9M", "9L0"],
			thundershock: ["9L4"],
			thunderwave: ["9M", "9L8"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
			zapcannon: ["9L50"],
		},
	},
	espeon: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9L0"],
			confusion: ["9L0"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L45"],
			futuresight: ["9M", "9L55"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			healblock: ["9M", "9L35"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			mimic: ["9M"],
			morningsun: ["9L30"],
			powergem: ["9M"],
			protect: ["9M"],
			psybeam: ["9L25"],
			psychic: ["9M", "9L40"],
			psychicfangs: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9L10"],
			reflect: ["9M"],
			roar: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L0"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			wish: ["9L0"],
		},
	},
	umbreon: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9L0"],
			confuseray: ["9L20"],
			crunch: ["9M", "9L50"],
			curse: ["9M"],
			darkpulse: ["9M", "9L40"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M", "9L35"],
			lightscreen: ["9M"],
			mimic: ["9M"],
			moonlight: ["9L30"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			quickattack: ["9L10"],
			razorwind: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			screech: ["9L45"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			snarl: ["9L0"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M", "9L0"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			wish: ["9L0"],
		},
	},
	slowking: {
		learnset: {
			amnesia: ["9L27"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L0"],
			curse: ["9M", "9L1"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L45"],
			gigaimpact: ["9M"],
			growl: ["9L3"],
			headbutt: ["9M", "9L21"],
			healblock: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			metronome: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L1"],
			powergem: ["9M", "9L1"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L42"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L36"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M", "9L18"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	slowkinggalar: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L27"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L0"],
			curse: ["9M", "9L1"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L45"],
			gigaimpact: ["9M"],
			growl: ["9L3"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L21"],
			healblock: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L1"],
			ominouswind: ["9M"],
			poisonjab: ["9M"],
			powergem: ["9M", "9L1"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L42"],
			psyshock: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9L36"],
			substitute: ["9M"],
			surf: ["9M", "9L36"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L0"],
			toxicspikes: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L6"],
			waterpulse: ["9M", "9L18"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	steelix: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9L22"],
			crunch: ["9M", "9L1"],
			curse: ["9M", "9L16"],
			darkpulse: ["9M"],
			dig: ["9M", "9L44"],
			doubleedge: ["9M", "9L56"],
			dragonbreath: ["9L12"],
			dragonpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headsmash: ["9L62"],
			heavyslam: ["9L36"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M", "9L0"],
			meteorbeam: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockblast: ["9L0"],
			rockslide: ["9M", "9L20"],
			rockthrow: ["9L1"],
			rocktomb: ["9M"],
			sandtomb: ["9L28"],
			scorchingsands: ["9M"],
			screech: ["9L24"],
			selfdestruct: ["9M"],
			stealthrock: ["9M", "9L32"],
			steelbeam: ["9M"],
			stoneedge: ["9M", "9L52"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderfang: ["9M"],
		},
	},
	qwilfish: {
		learnset: {
			acidspray: ["9M"],
			agility: ["9M"],
			aquajet: ["9L17"],
			barbbarrage: ["9L28"],
			blizzard: ["9M"],
			bubblebeam: ["9L12"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L50"],
			harden: ["9L4"],
			haze: ["9L15"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			pinmissile: ["9L32"],
			poisonjab: ["9M", "9L30"],
			poisonsting: ["9L1"],
			protect: ["9M"],
			scaleshot: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			spikes: ["9M", "9L20"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L44"],
			toxicspikes: ["9M", "9L36"],
			waterfall: ["9M"],
			watergun: ["9L8"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
		},
	},
	qwilfishhisui: {
		learnset: {
			acidspray: ["9M"],
			agility: ["9M"],
			aquajet: ["9L17"],
			barbbarrage: ["9L28"],
			bite: ["9L1"],
			blizzard: ["9M"],
			bubblebeam: ["9L12"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L46"],
			curse: ["9M"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L50"],
			harden: ["9L4"],
			haze: ["9L15"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			pinmissile: ["9L32"],
			poisonjab: ["9M", "9L30"],
			poisonsting: ["9L1"],
			protect: ["9M"],
			scaleshot: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			spikes: ["9M", "9L20"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L44"],
			toxicspikes: ["9M", "9L36"],
			waterfall: ["9M"],
			watergun: ["9L8"],
			waterpulse: ["9M"],
		},
	},
	scizor: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L36"],
			brickbreak: ["9M"],
			brutalswing: ["9L20"],
			bugbuzz: ["9L34"],
			bulletpunch: ["9L0"],
			closecombat: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M", "9L16"],
			dualchop: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			focusenergy: ["9L28"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L40"],
			ironhead: ["9M", "9L48"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lunge: ["9L46"],
			magnetbomb: ["9M"],
			nightslash: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			safeguard: ["9M"],
			silverwind: ["9M"],
			slash: ["9L24"],
			steelbeam: ["9M"],
			steelwing: ["9L18"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L42"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			wingattack: ["9L12"],
			xscissor: ["9M", "9L32"],
		},
	},
	heracross: {
		learnset: {
			aerialace: ["9M", "9L15"],
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L24"],
			bugbuzz: ["9L30"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L50"],
			curse: ["9M"],
			detect: ["9L13"],
			dig: ["9M"],
			earthquake: ["9M"],
			endure: ["9M", "9L5"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lunge: ["9L32"],
			megahorn: ["9L45"],
			mudshot: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M"],
			pinmissile: ["9L10"],
			protect: ["9M"],
			rockblast: ["9L28"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			silverwind: ["9M"],
			skullbash: ["9M"],
			spikes: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L38"],
			tackle: ["9L1"],
			takedown: ["9L20"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
		},
	},
	delibird: {
		learnset: {
			aerialace: ["9M", "9L18"],
			agility: ["9M"],
			airslash: ["9L28"],
			blizzard: ["9M", "9L40"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			chillingwater: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			featherdance: ["9L32"],
			fly: ["9M"],
			freezedry: ["9L37"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M", "9L35"],
			iceshard: ["9L25"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L15"],
			peck: ["9L1"],
			protect: ["9M"],
			razorwind: ["9M"],
			seedbomb: ["9M"],
			sheercold: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			waterpulse: ["9M"],
		},
	},
	skarmory: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L0"],
			bravebird: ["9L56"],
			curse: ["9M"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			drillrun: ["9L38"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L50"],
			ironhead: ["9M"],
			leer: ["9L1"],
			magnetbomb: ["9M"],
			metalclaw: ["9L12"],
			metalsound: ["9L42"],
			nightslash: ["9M", "9L34"],
			peck: ["9L1"],
			protect: ["9M"],
			razorwind: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L16"],
			scaleshot: ["9M"],
			skullbash: ["9M"],
			skyattack: ["9M"],
			slash: ["9L24"],
			spikes: ["9M", "9L46"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelwing: ["9L28"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			whirlwind: ["9M"],
			wingattack: ["9L20"],
			xscissor: ["9M"],
		},
	},
	houndour: {
		learnset: {
			bite: ["9L16"],
			bodyslam: ["9M"],
			crunch: ["9M", "9L49"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L28"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L44"],
			flareblitz: ["9M"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hypervoice: ["9M"],
			leer: ["9L1"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L52"],
			overheat: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L13"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			tackle: ["9L6"],
			takedown: ["9L24"],
			taunt: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
		},
	},
	houndoom: {
		learnset: {
			bite: ["9L16"],
			bodyslam: ["9M"],
			crunch: ["9M", "9L49"],
			darkpulse: ["9M", "9L34"],
			doubleedge: ["9M"],
			dreameater: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L28"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L44"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			leer: ["9L1"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L1"],
			overheat: ["9M", "9L55"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L13"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			snarl: ["9L21"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L6"],
			takedown: ["9L24"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
		},
	},
	porygon2: {
		learnset: {
			agility: ["9M", "9L30"],
			blizzard: ["9M"],
			charge: ["9L1"],
			chargebeam: ["9M"],
			confuseray: ["9L1"],
			conversion: ["9L1"],
			conversion2: ["9L25"],
			discharge: ["9M", "9L40"],
			doubleedge: ["9M"],
			eerieimpulse: ["9L10"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M", "9L60"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			magnetbomb: ["9M"],
			metalsound: ["9L45"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9L35"],
			reflect: ["9M"],
			selfdestruct: ["9M", "9L50"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thundershock: ["9L15"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			voltswitch: ["9M"],
			zapcannon: ["9L55"],
			zenheadbutt: ["9M"],
		},
	},
	larvitar: {
		learnset: {
			ancientpower: ["9M"],
			bite: ["9L9"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L27"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L33"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M", "9L48"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			mudshot: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			rockblast: ["9L40"],
			rockslide: ["9M", "9L15"],
			rockthrow: ["9L3"],
			rocktomb: ["9M"],
			sandtomb: ["9L12"],
			screech: ["9L21"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L37"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
		},
	},
	pupitar: {
		learnset: {
			aerialace: ["9M"],
			ancientpower: ["9M"],
			bite: ["9L9"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L27"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L33"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M", "9L48"],
			irondefense: ["9M", "9L0"],
			ironhead: ["9M"],
			leer: ["9L1"],
			mudshot: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			rockblast: ["9L40"],
			rockslide: ["9M", "9L15"],
			rockthrow: ["9L3"],
			rocktomb: ["9M"],
			sandtomb: ["9L12"],
			screech: ["9L21"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L37"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
		},
	},
	tyranitar: {
		learnset: {
			aerialace: ["9M"],
			ancientpower: ["9M"],
			bite: ["9L9"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L27"],
			curse: ["9M"],
			darkpulse: ["9M", "9L0"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L33"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M", "9L56"],
			headbutt: ["9M"],
			heavyslam: ["9L53"],
			hydropump: ["9M"],
			hyperbeam: ["9M", "9L48"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L0"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			outrage: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockblast: ["9L40"],
			rockslide: ["9M", "9L15"],
			rockthrow: ["9L3"],
			rocktomb: ["9M"],
			sandtomb: ["9L12"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			screech: ["9L21"],
			shadowclaw: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L37"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
		},
	},
	treecko: {
		learnset: {
			absorb: ["9L9"],
			aerialace: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			crunch: ["9M"],
			detect: ["9L12"],
			dig: ["9M"],
			doubleteam: ["9M", "9L27"],
			dragonbreath: ["9L30"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M", "9L33"],
			facade: ["9M"],
			gigadrain: ["9M", "9L21"],
			irontail: ["9M"],
			leafage: ["9L3"],
			leafstorm: ["9L55"],
			leechseed: ["9L14"],
			leer: ["9L1"],
			nightslash: ["9M"],
			protect: ["9M"],
			quickattack: ["9L6"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			screech: ["9L40"],
			seedbomb: ["9M"],
			slash: ["9L35"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L50"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			workup: ["9M"],
		},
	},
	grovyle: {
		learnset: {
			absorb: ["9L9"],
			aerialace: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			crunch: ["9M"],
			detect: ["9L12"],
			dig: ["9M"],
			doubleteam: ["9M", "9L27"],
			dragonbreath: ["9L30"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L44"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M", "9L33"],
			facade: ["9M"],
			falseswipe: ["9M"],
			gigadrain: ["9M", "9L21"],
			irontail: ["9M"],
			leafage: ["9L3"],
			leafblade: ["9L38"],
			leafstorm: ["9L55"],
			leechseed: ["9L14"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			nightslash: ["9M"],
			protect: ["9M"],
			quickattack: ["9L6"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			screech: ["9L40"],
			seedbomb: ["9M"],
			slash: ["9L35"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L50"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
			xscissor: ["9M", "9L1"],
		},
	},
	sceptile: {
		learnset: {
			absorb: ["9L9"],
			aerialace: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			crunch: ["9M"],
			detect: ["9L12"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M", "9L27"],
			dragonbreath: ["9L30"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9L44"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M", "9L33"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusblast: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M", "9L21"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			leafage: ["9L3"],
			leafblade: ["9L38"],
			leafstorm: ["9L55"],
			leechseed: ["9L14"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			quickattack: ["9L6"],
			razorwind: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L40"],
			seedbomb: ["9M"],
			shedtail: ["9L0"],
			slash: ["9L35"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L50"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
			xscissor: ["9M", "9L1"],
		},
	},
	torchic: {
		learnset: {
			aerialace: ["9M", "9L18"],
			agility: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9L24"],
			curse: ["9M"],
			detect: ["9L12"],
			dig: ["9M"],
			doubleedge: ["9M"],
			ember: ["9L3"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L50"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M", "9L9"],
			flamethrower: ["9M", "9L33"],
			flareblitz: ["9M", "9L55"],
			focusenergy: ["9L27"],
			growl: ["9L1"],
			heatwave: ["9M"],
			nightslash: ["9M"],
			overheat: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L6"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L21"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
		},
	},
	combusken: {
		learnset: {
			aerialace: ["9M", "9L18"],
			agility: ["9M"],
			blazekick: ["9M", "9L44"],
			bodyslam: ["9M"],
			bounce: ["9L24"],
			brickbreak: ["9M"],
			bulkup: ["9M", "9L40"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			curse: ["9M"],
			detect: ["9L12"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dualchop: ["9M"],
			ember: ["9L3"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L50"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M", "9L9"],
			flamethrower: ["9M", "9L33"],
			flareblitz: ["9M", "9L55"],
			focusblast: ["9M"],
			focusenergy: ["9L27"],
			growl: ["9L1"],
			heatwave: ["9M"],
			lowsweep: ["9M"],
			nightslash: ["9M"],
			overheat: ["9M"],
			peck: ["9L1"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			quickattack: ["9L6"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L21"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			thunderpunch: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
		},
	},
	blaziken: {
		learnset: {
			aerialace: ["9M", "9L18"],
			agility: ["9M"],
			blastburn: ["9M"],
			blazekick: ["9M", "9L44"],
			bodyslam: ["9M"],
			bounce: ["9L24"],
			bravebird: ["9L58"],
			brickbreak: ["9M"],
			bulkup: ["9M", "9L40"],
			bulldoze: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			curse: ["9M"],
			detect: ["9L12"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			ember: ["9L3"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L50"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M", "9L9"],
			flamethrower: ["9M", "9L33"],
			flareblitz: ["9M", "9L55"],
			focusblast: ["9M"],
			focusenergy: ["9L27"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			nightslash: ["9M"],
			overheat: ["9M"],
			peck: ["9L1"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			quickattack: ["9L6"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L21"],
			solarbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			thunderpunch: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
		},
	},
	mudkip: {
		learnset: {
			amnesia: ["9L30"],
			ancientpower: ["9M"],
			bite: ["9L1"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bubblebeam: ["9L22"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			growl: ["9L1"],
			hydropump: ["9M", "9L55"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M", "9L46"],
			mudshot: ["9M"],
			protect: ["9M", "9L14"],
			roar: ["9M"],
			rockslide: ["9M", "9L26"],
			rocksmash: ["9M", "9L6"],
			rockthrow: ["9L11"],
			rocktomb: ["9M"],
			scald: ["9M"],
			screech: ["9L38"],
			sludgebomb: ["9M", "9L40"],
			substitute: ["9M"],
			supersonic: ["9L18"],
			surf: ["9M", "9L36"],
			tackle: ["9L1"],
			takedown: ["9L28"],
			waterfall: ["9M"],
			watergun: ["9L3"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	marshtomp: {
		learnset: {
			amnesia: ["9L30"],
			ancientpower: ["9M"],
			aquaring: ["9L33"],
			bite: ["9L1"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L22"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L50"],
			endure: ["9M"],
			facade: ["9M"],
			growl: ["9L1"],
			hydropump: ["9M", "9L55"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M", "9L46"],
			mudshot: ["9M", "9L1"],
			protect: ["9M", "9L14"],
			roar: ["9M"],
			rockslide: ["9M", "9L26"],
			rocksmash: ["9M", "9L6"],
			rockthrow: ["9L11"],
			rocktomb: ["9M"],
			sandtomb: ["9L0"],
			scald: ["9M"],
			screech: ["9L38"],
			sludgebomb: ["9M", "9L40"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L18"],
			surf: ["9M", "9L36"],
			tackle: ["9L1"],
			takedown: ["9L28"],
			waterfall: ["9M"],
			watergun: ["9L3"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	swampert: {
		learnset: {
			amnesia: ["9L30"],
			ancientpower: ["9M"],
			aquaring: ["9L33"],
			bite: ["9L1"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L22"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L50"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hydrocannon: ["9M"],
			hydropump: ["9M", "9L55"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M", "9L46"],
			mudshot: ["9M", "9L0"],
			outrage: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M", "9L14"],
			roar: ["9M"],
			rockslide: ["9M", "9L26"],
			rocksmash: ["9M", "9L6"],
			rockthrow: ["9L11"],
			rocktomb: ["9M"],
			sandtomb: ["9L1"],
			scald: ["9M"],
			screech: ["9L38"],
			sludgebomb: ["9M", "9L40"],
			sludgewave: ["9L60"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L18"],
			surf: ["9M", "9L36"],
			tackle: ["9L1"],
			takedown: ["9L28"],
			waterfall: ["9M"],
			watergun: ["9L3"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	ralts: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L35"],
			chargebeam: ["9M"],
			charm: ["9L28"],
			confuseray: ["9L24"],
			confusion: ["9L6"],
			disarmingvoice: ["9L1"],
			doubleteam: ["9M", "9L30"],
			drainingkiss: ["9L12"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			futuresight: ["9M", "9L58"],
			growl: ["9L1"],
			hypervoice: ["9M"],
			hypnosis: ["9L9"],
			icepunch: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L20"],
			metronome: ["9M"],
			mysticalfire: ["9L44"],
			protect: ["9M"],
			psybeam: ["9L18"],
			psychic: ["9M", "9L38"],
			psyshock: ["9M"],
			reflect: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			teleport: ["9L15"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	kirlia: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L35"],
			chargebeam: ["9M"],
			charm: ["9L28"],
			confuseray: ["9L24"],
			confusion: ["9L6"],
			disarmingvoice: ["9L1"],
			doubleteam: ["9M", "9L30"],
			drainingkiss: ["9L12"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			futuresight: ["9M", "9L58"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L9"],
			icepunch: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L20"],
			metronome: ["9M"],
			mysticalfire: ["9L44"],
			protect: ["9M"],
			psybeam: ["9L18"],
			psychic: ["9M", "9L38"],
			psyshock: ["9M"],
			reflect: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			teleport: ["9L15"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			tripleaxel: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	gardevoir: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L35"],
			chargebeam: ["9M"],
			charm: ["9L28"],
			confuseray: ["9L24"],
			confusion: ["9L6"],
			dazzlinggleam: ["9M", "9L0"],
			disarmingvoice: ["9L1"],
			doubleteam: ["9M", "9L30"],
			drainingkiss: ["9L12"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L58"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L9"],
			icepunch: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L20"],
			metronome: ["9M"],
			mimic: ["9M"],
			moonblast: ["9L49"],
			mysticalfire: ["9L44"],
			protect: ["9M"],
			psybeam: ["9L18"],
			psychic: ["9M", "9L38"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			teleport: ["9L15"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			tripleaxel: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			wish: ["9L32"],
			zenheadbutt: ["9M"],
		},
	},
	sableye: {
		learnset: {
			aerialace: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9L22"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			detect: ["9L18"],
			dig: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L25"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M", "9L33"],
			ominouswind: ["9M"],
			partingshot: ["9L53"],
			phantomforce: ["9L56"],
			poisonjab: ["9M"],
			powergem: ["9M", "9L39"],
			protect: ["9M"],
			psybeam: ["9L28"],
			psychic: ["9M"],
			recover: ["9L50"],
			reflect: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M", "9L45"],
			shadowclaw: ["9M", "9L20"],
			shadowpunch: ["9M"],
			shadowsneak: ["9L9"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L15"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			willowisp: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M", "9L42"],
		},
	},
	mawile: {
		learnset: {
			ancientpower: ["9M"],
			bite: ["9L1"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L20"],
			crunch: ["9M", "9L28"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L22"],
			dynamicpunch: ["9L55"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L1"],
			faketears: ["9L5"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L24"],
			ironhead: ["9M", "9L36"],
			knockoff: ["9M", "9L16"],
			playrough: ["9M", "9L48"],
			poisonfang: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M", "9L40"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
		},
	},
	aron: {
		learnset: {
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L56"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			headsmash: ["9L66"],
			heavyslam: ["9L52"],
			irondefense: ["9M", "9L48"],
			ironhead: ["9M", "9L28"],
			irontail: ["9M", "9L44"],
			metalclaw: ["9L4"],
			metalsound: ["9L33"],
			mudshot: ["9M"],
			protect: ["9M", "9L20"],
			roar: ["9M", "9L12"],
			rockslide: ["9M", "9L24"],
			rocktomb: ["9M", "9L8"],
			screech: ["9L1"],
			shadowclaw: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
		},
	},
	lairon: {
		learnset: {
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L56"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			headsmash: ["9L66"],
			heavyslam: ["9L52"],
			irondefense: ["9M", "9L48"],
			ironhead: ["9M", "9L28"],
			irontail: ["9M", "9L44"],
			metalclaw: ["9L4"],
			metalsound: ["9L33"],
			mudshot: ["9M"],
			protect: ["9M", "9L20"],
			roar: ["9M", "9L12"],
			rockslide: ["9M", "9L24"],
			rocktomb: ["9M", "9L8"],
			screech: ["9L1"],
			shadowclaw: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
		},
	},
	aggron: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L56"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			headsmash: ["9L66"],
			heavyslam: ["9L52"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L48"],
			ironhead: ["9M", "9L28"],
			irontail: ["9M", "9L44"],
			magnetbomb: ["9M"],
			metalclaw: ["9L4"],
			metalsound: ["9L33"],
			meteorbeam: ["9M"],
			mudshot: ["9M"],
			outrage: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M", "9L20"],
			roar: ["9M", "9L12"],
			rockslide: ["9M", "9L24"],
			rocktomb: ["9M", "9L8"],
			scorchingsands: ["9M"],
			screech: ["9L1"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			whirlpool: ["9M"],
		},
	},
	meditite: {
		learnset: {
			aerialace: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulletpunch: ["9L16"],
			calmmind: ["9M", "9L23"],
			closecombat: ["9M"],
			confusion: ["9L1"],
			detect: ["9L9"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L52"],
			endure: ["9M", "9L12"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			icepunch: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9L41"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L14"],
			rocktomb: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			takedown: ["9L30"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			workup: ["9M", "9L1"],
			zenheadbutt: ["9M", "9L25"],
		},
	},
	medicham: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L34"],
			blazekick: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulletpunch: ["9L16"],
			calmmind: ["9M", "9L23"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			confusion: ["9L1"],
			detect: ["9L9"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L52"],
			endure: ["9M", "9L12"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M", "9L0"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M", "9L0"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9L41"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L14"],
			rocktomb: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			takedown: ["9L30"],
			taunt: ["9M"],
			thunderpunch: ["9M", "9L0"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M", "9L1"],
			zenheadbutt: ["9M", "9L25"],
		},
	},
	electrike: {
		learnset: {
			agility: ["9M"],
			bite: ["9L20"],
			bodyslam: ["9M"],
			charge: ["9L36"],
			crunch: ["9M"],
			curse: ["9M"],
			discharge: ["9M"],
			eerieimpulse: ["9L22"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			headbutt: ["9M"],
			icefang: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9L1"],
			roar: ["9M", "9L28"],
			snarl: ["9L30"],
			spark: ["9L16"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M", "9L50"],
			thunderbolt: ["9M", "9L40"],
			thunderfang: ["9M", "9L24"],
			thundershock: ["9L8"],
			thunderwave: ["9M", "9L12"],
			voltswitch: ["9M"],
			wildcharge: ["9M", "9L44"],
		},
	},
	manectric: {
		learnset: {
			agility: ["9M"],
			bite: ["9L20"],
			bodyslam: ["9M"],
			charge: ["9L36"],
			chargebeam: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			discharge: ["9M"],
			eerieimpulse: ["9L22"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M", "9L1"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			roar: ["9M", "9L28"],
			snarl: ["9L30"],
			spark: ["9L16"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M", "9L50"],
			thunderbolt: ["9M", "9L40"],
			thunderfang: ["9M", "9L24"],
			thundershock: ["9L8"],
			thunderwave: ["9M", "9L12"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M", "9L44"],
		},
	},
	roselia: {
		learnset: {
			absorb: ["9L1"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			charm: ["9L1"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M", "9L30"],
			growth: ["9L1"],
			leafstorm: ["9L55"],
			leechseed: ["9L10"],
			magicalleaf: ["9L15"],
			mudshot: ["9M"],
			petaldance: ["9M"],
			pinmissile: ["9L8"],
			poisonjab: ["9M", "9L33"],
			poisonsting: ["9L0"],
			protect: ["9M"],
			razorleaf: ["9L5"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sleeppowder: ["9L18"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			stunspore: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L37"],
			toxic: ["9M", "9L44"],
			toxicspikes: ["9M", "9L22"],
		},
	},
	gulpin: {
		learnset: {
			acidarmor: ["9L15"],
			acidspray: ["9M"],
			amnesia: ["9L12"],
			bodyslam: ["9M", "9L28"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			explosion: ["9L60"],
			facade: ["9M"],
			firepunch: ["9M"],
			gigadrain: ["9M"],
			gunkshot: ["9M", "9L49"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L20"],
			mudshot: ["9M"],
			poisonjab: ["9M", "9L17"],
			protect: ["9M"],
			rollout: ["9L22"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			sludgebomb: ["9M", "9L40"],
			sludgewave: ["9L55"],
			smokescreen: ["9L1"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L14"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L35"],
			toxicspikes: ["9M"],
			waterpulse: ["9M"],
		},
	},
	swalot: {
		learnset: {
			acidarmor: ["9L15"],
			acidspray: ["9M"],
			amnesia: ["9L12"],
			bodyslam: ["9M", "9L28"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9L60"],
			facade: ["9M"],
			firepunch: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L49"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L20"],
			metronome: ["9M"],
			mudshot: ["9M"],
			poisonjab: ["9M", "9L17"],
			protect: ["9M"],
			rollout: ["9L22"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			sludgebomb: ["9M", "9L40"],
			sludgewave: ["9L55"],
			smokescreen: ["9L1"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L14"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L35"],
			toxicspikes: ["9M"],
			waterpulse: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	carvanha: {
		learnset: {
			agility: ["9M"],
			ancientpower: ["9M"],
			aquajet: ["9L1"],
			bite: ["9L16"],
			blizzard: ["9M"],
			bounce: ["9L51"],
			crunch: ["9M", "9L32"],
			darkpulse: ["9M"],
			doubleedge: ["9M", "9L54"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M", "9L20"],
			focusenergy: ["9L8"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			leer: ["9L1"],
			liquidation: ["9M", "9L44"],
			poisonfang: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L24"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			takedown: ["9L40"],
			taunt: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sharpedo: {
		learnset: {
			agility: ["9M", "9L36"],
			ancientpower: ["9M"],
			aquajet: ["9L1"],
			bite: ["9L16"],
			blizzard: ["9M"],
			bounce: ["9L51"],
			closecombat: ["9M"],
			crunch: ["9M", "9L32"],
			darkpulse: ["9M"],
			doubleedge: ["9M", "9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M", "9L20"],
			focusenergy: ["9L8"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			leer: ["9L1"],
			liquidation: ["9M", "9L44"],
			nightslash: ["9M", "9L1"],
			poisonfang: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L24"],
			skullbash: ["9M"],
			slash: ["9L0"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			takedown: ["9L40"],
			taunt: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	numel: {
		learnset: {
			amnesia: ["9L19"],
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M", "9L12"],
			curse: ["9M", "9L29"],
			dig: ["9M"],
			doubleedge: ["9M", "9L51"],
			earthpower: ["9M", "9L26"],
			earthquake: ["9M", "9L40"],
			ember: ["9L5"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L46"],
			flareblitz: ["9M"],
			flashcannon: ["9M"],
			focusenergy: ["9L8"],
			growl: ["9L1"],
			headbutt: ["9M"],
			heatcrash: ["9L55"],
			heatwave: ["9M"],
			ironhead: ["9M"],
			lavaplume: ["9L22"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L31"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	camerupt: {
		learnset: {
			amnesia: ["9L19"],
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M", "9L12"],
			curse: ["9M", "9L29"],
			dig: ["9M"],
			doubleedge: ["9M", "9L51"],
			earthpower: ["9M", "9L26"],
			earthquake: ["9M", "9L40"],
			ember: ["9L5"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			fissure: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L46"],
			flareblitz: ["9M"],
			flashcannon: ["9M"],
			focusenergy: ["9L8"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M"],
			heatcrash: ["9L55"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			lavaplume: ["9L22"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M", "9L0"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L31"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	spoink: {
		learnset: {
			amnesia: ["9L33"],
			bodyslam: ["9M"],
			bounce: ["9L50"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9L22"],
			confusion: ["9L7"],
			dazzlinggleam: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			futuresight: ["9M", "9L55"],
			growl: ["9L10"],
			hypnosis: ["9L18"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			mudshot: ["9M"],
			payday: ["9M"],
			powergem: ["9M", "9L29"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L44"],
			psyshock: ["9M", "9L38"],
			reflect: ["9M"],
			shadowball: ["9M"],
			shadowpunch: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			whirlwind: ["9M", "9L25"],
			zenheadbutt: ["9M"],
		},
	},
	grumpig: {
		learnset: {
			amnesia: ["9L33"],
			bodyslam: ["9M"],
			bounce: ["9L50"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9L22"],
			confusion: ["9L7"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L55"],
			gigaimpact: ["9M"],
			growl: ["9L10"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L18"],
			icepunch: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			payday: ["9M"],
			powergem: ["9M", "9L29"],
			protect: ["9M"],
			psybeam: ["9L14"],
			psychic: ["9M", "9L44"],
			psyshock: ["9M", "9L38"],
			reflect: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowpunch: ["9M"],
			snarl: ["9L27"],
			splash: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			whirlwind: ["9M", "9L25"],
			zenheadbutt: ["9M"],
		},
	},
	swablu: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			bravebird: ["9L50"],
			cottonguard: ["9L32"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L4"],
			dragonbreath: ["9L20"],
			dragonpulse: ["9M"],
			dragonrush: ["9L55"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L44"],
			fly: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			mist: ["9L8"],
			moonblast: ["9L40"],
			outrage: ["9M"],
			peck: ["9L1"],
			perishsong: ["9L60"],
			playrough: ["9M"],
			protect: ["9M"],
			safeguard: ["9M", "9L24"],
			sing: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			takedown: ["9L37"],
			trailblaze: ["9M"],
			twister: ["9L35"],
		},
	},
	altaria: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			bravebird: ["9L50"],
			bulldoze: ["9M"],
			cottonguard: ["9L32"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L4"],
			dracometeor: ["9M"],
			dragonbreath: ["9L20"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L0"],
			dragonrush: ["9L55"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			featherdance: ["9L44"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			mist: ["9L8"],
			moonblast: ["9L40"],
			outrage: ["9M"],
			peck: ["9L1"],
			perishsong: ["9L60"],
			petaldance: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			safeguard: ["9M", "9L24"],
			silverwind: ["9M"],
			sing: ["9M"],
			skyattack: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			takedown: ["9L37"],
			trailblaze: ["9M"],
			twister: ["9L35"],
			willowisp: ["9M"],
		},
	},
	zangoose: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			closecombat: ["9M", "9L50"],
			cometpunch: ["9M"],
			curse: ["9M"],
			detect: ["9L36"],
			dig: ["9M", "9L33"],
			doubleedge: ["9M"],
			doublehit: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			falseswipe: ["9M", "9L29"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			metalclaw: ["9L12"],
			nightslash: ["9M", "9L24"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L5"],
			razorwind: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			slash: ["9L19"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L47"],
			tackle: ["9L1"],
			taunt: ["9M", "9L43"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			workup: ["9M"],
			xscissor: ["9M", "9L40"],
			zenheadbutt: ["9M"],
		},
	},
	seviper: {
		learnset: {
			acidspray: ["9M"],
			bite: ["9L1"],
			bodyslam: ["9M"],
			breakingswipe: ["9L24"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L39"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9L19"],
			gunkshot: ["9M", "9L52"],
			haze: ["9L34"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lick: ["9L6"],
			nightslash: ["9M", "9L28"],
			poisonfang: ["9M", "9L21"],
			poisonjab: ["9M", "9L31"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L14"],
			seedbomb: ["9M"],
			sludgebomb: ["9M", "9L46"],
			snarl: ["9L17"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	feebas: {
		learnset: {
			blizzard: ["9M"],
			chillingwater: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L15"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
		},
	},
	milotic: {
		learnset: {
			aquaring: ["9L12"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9L16"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L4"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			drainingkiss: ["9L20"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L0"],
			hydropump: ["9M", "9L52"],
			hyperbeam: ["9M"],
			hypnosis: ["9L24"],
			icebeam: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mimic: ["9M"],
			mist: ["9L0"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			recover: ["9L28"],
			safeguard: ["9M", "9L36"],
			scald: ["9M"],
			scaleshot: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			surf: ["9M", "9L44"],
			swift: ["9M"],
			tackle: ["9L15"],
			tripleaxel: ["9M"],
			twister: ["9L8"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L0"],
			whirlpool: ["9M", "9L14"],
		},
	},
	kecleon: {
		learnset: {
			aerialace: ["9M"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			chargebeam: ["9M"],
			conversion: ["9L1"],
			conversion2: ["9L42"],
			dig: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firstimpression: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M", "9L14"],
			lick: ["9L1"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			poweruppunch: ["9M"],
			powerwhip: ["9L54"],
			protect: ["9M"],
			psybeam: ["9L18"],
			rockslide: ["9M", "9L21"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L38"],
			shadowball: ["9M"],
			shadowclaw: ["9M", "9L33"],
			shadowsneak: ["9L7"],
			shedtail: ["9L10"],
			slash: ["9L25"],
			solarbeam: ["9M"],
			stealthrock: ["9M", "9L28"],
			substitute: ["9M", "9L1"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			workup: ["9M"],
		},
	},
	shuppet: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9L8"],
			curse: ["9M", "9L26"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gunkshot: ["9M", "9L48"],
			headbutt: ["9M"],
			knockoff: ["9M", "9L12"],
			lick: ["9L1"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			phantomforce: ["9L42"],
			protect: ["9M"],
			psychic: ["9M"],
			screech: ["9L1"],
			shadowball: ["9M", "9L30"],
			shadowclaw: ["9M", "9L23"],
			shadowsneak: ["9L19"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L34"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			willowisp: ["9M", "9L16"],
			zenheadbutt: ["9M"],
		},
	},
	banette: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9L8"],
			curse: ["9M", "9L26"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L48"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			iciclespear: ["9M"],
			knockoff: ["9M", "9L12"],
			lick: ["9L1"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			phantomforce: ["9L42"],
			protect: ["9M"],
			psychic: ["9M"],
			razorwind: ["9M"],
			screech: ["9L1"],
			shadowball: ["9M", "9L30"],
			shadowclaw: ["9M", "9L23"],
			shadowpunch: ["9M"],
			shadowsneak: ["9L19"],
			slash: ["9L1"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M", "9L34"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M", "9L16"],
			zenheadbutt: ["9M"],
		},
	},
	chimecho: {
		learnset: {
			amnesia: ["9L23"],
			boomburst: ["9L48"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confusion: ["9L7"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L10"],
			doubleedge: ["9M", "9L38"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			futuresight: ["9M"],
			growl: ["9L1"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			metalsound: ["9L29"],
			meteorbeam: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psybeam: ["9L0"],
			psychic: ["9M", "9L34"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			screech: ["9L18"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L12"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L15"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			waterpulse: ["9M"],
			wish: ["9L25"],
			zenheadbutt: ["9M"],
		},
	},
	absol: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9L46"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M"],
			confuseray: ["9L1"],
			darkpulse: ["9M"],
			detect: ["9L15"],
			doubleedge: ["9M"],
			doubleteam: ["9M", "9L32"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			focusenergy: ["9L43"],
			futuresight: ["9M", "9L48"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			knockoff: ["9M", "9L10"],
			leer: ["9L1"],
			nightslash: ["9M", "9L27"],
			ominouswind: ["9M"],
			perishsong: ["9L54"],
			phantomforce: ["9L0"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M", "9L40"],
			shadowsneak: ["9L1"],
			slash: ["9L23"],
			snarl: ["9L0"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L20"],
			taunt: ["9M", "9L36"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			willowisp: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	snorunt: {
		learnset: {
			bite: ["9L1"],
			blizzard: ["9M", "9L50"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L45"],
			doubleteam: ["9M", "9L35"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L25"],
			frostbreath: ["9M"],
			headbutt: ["9M", "9L1"],
			icebeam: ["9M"],
			icefang: ["9M", "9L30"],
			iceshard: ["9L10"],
			iciclecrash: ["9L40"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L20"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			protect: ["9M", "9L15"],
			shadowball: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
		},
	},
	glalie: {
		learnset: {
			bite: ["9L1"],
			blizzard: ["9M", "9L50"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L45"],
			darkpulse: ["9M"],
			doubleteam: ["9M", "9L35"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9L55"],
			facade: ["9M"],
			faketears: ["9L25"],
			freezedry: ["9L0"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L1"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M", "9L30"],
			iceshard: ["9L10"],
			iciclecrash: ["9L40"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L20"],
			ironhead: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M", "9L15"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			skullbash: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
		},
	},
	bagon: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M", "9L25"],
			doubleedge: ["9M", "9L55"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonclaw: ["9M", "9L30"],
			dragonpulse: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M", "9L45"],
			focusenergy: ["9L40"],
			headbutt: ["9M", "9L15"],
			hydropump: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			outrage: ["9M", "9L50"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			substitute: ["9M"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M", "9L35"],
		},
	},
	shelgon: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M", "9L25"],
			doubleedge: ["9M", "9L55"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonclaw: ["9M", "9L30"],
			dragonpulse: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M", "9L45"],
			focusenergy: ["9L40"],
			headbutt: ["9M", "9L15"],
			hydropump: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			outrage: ["9M", "9L50"],
			protect: ["9M", "9L0"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			substitute: ["9M"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M", "9L35"],
		},
	},
	salamence: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9L60"],
			bite: ["9L1"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M", "9L25"],
			doubleedge: ["9M", "9L55"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonclaw: ["9M", "9L30"],
			dragonpulse: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L45"],
			fly: ["9M", "9L0"],
			focusenergy: ["9L40"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L15"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			outrage: ["9M", "9L50"],
			protect: ["9M", "9L1"],
			psychicfangs: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M", "9L35"],
		},
	},
	beldum: {
		learnset: {
			agility: ["9M"],
			facade: ["9M"],
			headbutt: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			steelbeam: ["9M"],
			tackle: ["9L1"],
			zenheadbutt: ["9M"],
		},
	},
	metang: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulletpunch: ["9L1"],
			confusion: ["9L0"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M", "9L18"],
			headbutt: ["9M"],
			hyperbeam: ["9M", "9L58"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L54"],
			ironhead: ["9M", "9L50"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			metalclaw: ["9L0"],
			meteorbeam: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psychic: ["9M", "9L42"],
			psychocut: ["9L34"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L26"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M", "9L6"],
		},
	},
	metagross: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L46"],
			bulletpunch: ["9L1"],
			cometpunch: ["9M"],
			confusion: ["9L1"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9L0"],
			facade: ["9M"],
			flashcannon: ["9M", "9L18"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			heavyslam: ["9L0"],
			hyperbeam: ["9M", "9L58"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L54"],
			ironhead: ["9M", "9L50"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			metalclaw: ["9L1"],
			meteorbeam: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psychic: ["9M", "9L42"],
			psychicfangs: ["9M"],
			psychocut: ["9L34"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shadowpunch: ["9M"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L26"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M", "9L6"],
		},
	},
	latias: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L60"],
			aurasphere: ["9L50"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L1"],
			chillingwater: ["9M"],
			confusion: ["9L15"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragonbreath: ["9L25"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L45"],
			drainingkiss: ["9L5"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mistball: ["9L1"],
			mysticalfire: ["9L55"],
			outrage: ["9M"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M", "9L65"],
			psyshock: ["9M"],
			razorwind: ["9M"],
			recover: ["9L10"],
			reflect: ["9M"],
			roar: ["9M"],
			safeguard: ["9M"],
			scaleshot: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M", "9L35"],
			whirlpool: ["9M"],
			wish: ["9L30"],
			zenheadbutt: ["9M", "9L40"],
		},
	},
	latios: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L65"],
			aurasphere: ["9L50"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			confusion: ["9L15"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragonbreath: ["9L25"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L45"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			fly: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			lusterpurge: ["9L1"],
			mysticalfire: ["9L55"],
			outrage: ["9M"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M", "9L60"],
			psyshock: ["9M"],
			razorwind: ["9M"],
			recover: ["9L10"],
			reflect: ["9M"],
			roar: ["9M"],
			safeguard: ["9M"],
			scaleshot: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			twister: ["9L5"],
			waterfall: ["9M"],
			waterpulse: ["9M", "9L35"],
			whirlpool: ["9M"],
			wish: ["9L30"],
			workup: ["9M", "9L1"],
			zenheadbutt: ["9M", "9L40"],
		},
	},
	kyogre: {
		inherit: true,
		learnset: {
			ancientpower: ["9M", "9L1"],
			aquaring: ["9L54"],
			blizzard: ["9M", "9L58"],
			bodyslam: ["9M", "9L1"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M", "9L18"],
			chillingwater: ["9M"],
			doubleedge: ["9M", "9L64"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			heavyslam: ["9L34"],
			hydropump: ["9M", "9L72"],
			hyperbeam: ["9M"],
			icebeam: ["9M", "9L36"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M"],
			originpulse: ["9L50"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			sheercold: ["9M", "9L45"],
			substitute: ["9M"],
			surf: ["9M", "9L42"],
			swagger: ["9M"],
			swift: ["9M"],
			takedown: ["9L15"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M", "9L1"],
			whirlpool: ["9M", "9L12"],
		},
	},
	groudon: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			ancientpower: ["9M", "9L1"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M", "9L18"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dynamicpunch: ["9L62"],
			earthpower: ["9M", "9L9"],
			earthquake: ["9M", "9L34"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M", "9L68"],
			firefang: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M", "9L30"],
			fissure: ["9M", "9L45"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			heatcrash: ["9L75"],
			heatwave: ["9M"],
			heavyslam: ["9L40"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lavaplume: ["9L1"],
			mudshot: ["9M", "9L1"],
			overheat: ["9M"],
			powergem: ["9M"],
			poweruppunch: ["9M"],
			precipiceblades: ["9L50"],
			protect: ["9M"],
			roar: ["9M"],
			rockblast: ["9L28"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			sandtomb: ["9L1"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M", "9L81"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L43"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	rayquaza: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			airslash: ["9L1"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L15"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L9"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragonascent: ["9L1"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L36"],
			dragonrush: ["9L58"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			extremespeed: ["9L27"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M", "9L63"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hurricane: ["9M", "9L72"],
			hydropump: ["9M"],
			hyperbeam: ["9M", "9L90"],
			hypervoice: ["9M", "9L45"],
			icebeam: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			meteorbeam: ["9M"],
			outrage: ["9M", "9L81"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			twister: ["9L1"],
			uturn: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			whirlwind: ["9M"],
			wildcharge: ["9M"],
		},
	},
	starly: {
		learnset: {
			aerialace: ["9M", "9L28"],
			agility: ["9M", "9L41"],
			bravebird: ["9L49"],
			doubleedge: ["9M"],
			doubleteam: ["9M", "9L16"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L19"],
			fly: ["9M"],
			growl: ["9L1"],
			gust: ["9L10"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			knockoff: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L8"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L33"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L23"],
			wingattack: ["9L12"],
			workup: ["9M"],
		},
	},
	staravia: {
		learnset: {
			aerialace: ["9M", "9L28"],
			agility: ["9M", "9L41"],
			bravebird: ["9L49"],
			doubleedge: ["9M"],
			doubleteam: ["9M", "9L16"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L19"],
			fly: ["9M"],
			growl: ["9L1"],
			gust: ["9L10"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			knockoff: ["9M"],
			ominouswind: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L8"],
			skullbash: ["9M"],
			skyattack: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L33"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			whirlwind: ["9M", "9L23"],
			wingattack: ["9L12"],
			workup: ["9M"],
		},
	},
	staraptor: {
		learnset: {
			aerialace: ["9M", "9L28"],
			agility: ["9M", "9L41"],
			airslash: ["9L44"],
			blazekick: ["9M"],
			bravebird: ["9L49"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			closecombat: ["9M", "9L0"],
			doubleedge: ["9M"],
			doubleteam: ["9M", "9L16"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L19"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gust: ["9L10"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			ominouswind: ["9M"],
			outrage: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L8"],
			razorwind: ["9M"],
			skullbash: ["9M"],
			skyattack: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L33"],
			torment: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			whirlwind: ["9M", "9L23"],
			wingattack: ["9L12"],
			workup: ["9M"],
		},
	},
	budew: {
		learnset: {
			absorb: ["9L1"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			charm: ["9L1"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			growth: ["9L1"],
			mudshot: ["9M"],
			protect: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			stunspore: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
		},
	},
	roserade: {
		learnset: {
			absorb: ["9L1"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			charm: ["9L1"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M", "9L30"],
			gigaimpact: ["9M"],
			growth: ["9L1"],
			hyperbeam: ["9M"],
			leafstorm: ["9L55"],
			leechseed: ["9L10"],
			magicalleaf: ["9L15"],
			mortalspin: ["9L0"],
			mudshot: ["9M"],
			petaldance: ["9M"],
			pinmissile: ["9L8"],
			poisonjab: ["9M", "9L34"],
			poisonsting: ["9L0"],
			protect: ["9M"],
			razorleaf: ["9L5"],
			razorwind: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sleeppowder: ["9L18"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			stunspore: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9L37"],
			toxic: ["9M", "9L44"],
			toxicspikes: ["9M", "9L22"],
		},
	},
	buneary: {
		learnset: {
			agility: ["9M", "9L20"],
			bounce: ["9L48"],
			brutalswing: ["9L28"],
			charm: ["9L24"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			cottonguard: ["9L42"],
			dig: ["9M"],
			doublehit: ["9M"],
			drainingkiss: ["9L14"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L52"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			headbutt: ["9M", "9L32"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lowsweep: ["9M"],
			playrough: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			quickattack: ["9L16"],
			shadowball: ["9M"],
			solarbeam: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			tripleaxel: ["9M"],
			workup: ["9M"],
		},
	},
	lopunny: {
		learnset: {
			agility: ["9M", "9L20"],
			blizzard: ["9M"],
			bounce: ["9L48"],
			brutalswing: ["9L28"],
			charm: ["9L24"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			cottonguard: ["9L42"],
			dig: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M", "9L12"],
			drainingkiss: ["9L14"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L52"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L32"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M", "9L36"],
			lowsweep: ["9M"],
			machpunch: ["9L9"],
			playrough: ["9M"],
			poweruppunch: ["9M", "9L6"],
			protect: ["9M"],
			quickattack: ["9L16"],
			shadowball: ["9M"],
			solarbeam: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			tripleaxel: ["9M"],
			uturn: ["9M"],
			workup: ["9M"],
		},
	},
	chingling: {
		learnset: {
			amnesia: ["9L23"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confusion: ["9L7"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L10"],
			doubleedge: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			futuresight: ["9M"],
			growl: ["9L1"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			metalsound: ["9L29"],
			protect: ["9M"],
			psychic: ["9M", "9L34"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			screech: ["9L18"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L12"],
			tackle: ["9L1"],
			takedown: ["9L15"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			waterpulse: ["9M"],
			wish: ["9L25"],
			zenheadbutt: ["9M"],
		},
	},
	mimejr: {
		learnset: {
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charm: ["9L8"],
			confuseray: ["9L1"],
			confusion: ["9L12"],
			dazzlinggleam: ["9M", "9L44"],
			drainpunch: ["9M"],
			dreameater: ["9M", "9L15"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firstimpression: ["9M"],
			futuresight: ["9M"],
			haze: ["9L0"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hypnosis: ["9L1"],
			icywind: ["9M"],
			infestation: ["9L17"],
			lightscreen: ["9M", "9L36"],
			mimic: ["9M", "9L32"],
			mist: ["9L0"],
			nastyplot: ["9M"],
			protect: ["9M", "9L20"],
			psybeam: ["9L28"],
			psychic: ["9M", "9L48"],
			psyshock: ["9M"],
			reflect: ["9M", "9L36"],
			safeguard: ["9M", "9L36"],
			shadowball: ["9M"],
			smokescreen: ["9L0"],
			solarbeam: ["9M"],
			stealthrock: ["9M", "9L24"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	gible: {
		learnset: {
			bite: ["9L25"],
			bodyslam: ["9M"],
			bulldoze: ["9M", "9L18"],
			dig: ["9M", "9L42"],
			dracometeor: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L36"],
			dragonpulse: ["9M"],
			dragonrush: ["9L60"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			ironhead: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L1"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L30"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L54"],
			thunderfang: ["9M"],
		},
	},
	gabite: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L25"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L18"],
			crunch: ["9M"],
			dig: ["9M", "9L42"],
			dracometeor: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L36"],
			dragonpulse: ["9M"],
			dragonrush: ["9L60"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			ironhead: ["9M"],
			outrage: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L1"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L30"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L54"],
			thunderfang: ["9M"],
		},
	},
	garchomp: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L25"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L18"],
			crunch: ["9M", "9L0"],
			dig: ["9M", "9L42"],
			dracometeor: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L36"],
			dragonpulse: ["9M"],
			dragonrush: ["9L60"],
			dualchop: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			poisonjab: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L1"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L30"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L54"],
			thunderfang: ["9M"],
			vacuumwave: ["9M"],
		},
	},
	riolu: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L28"],
			bulletpunch: ["9L1"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M"],
			detect: ["9L24"],
			dig: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M", "9L1"],
			facade: ["9M"],
			focusblast: ["9M"],
			icepunch: ["9M"],
			lowsweep: ["9M"],
			metalclaw: ["9L8"],
			nastyplot: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L20"],
			rocktomb: ["9M"],
			screech: ["9L24"],
			shadowclaw: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L35"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M", "9L16"],
			zenheadbutt: ["9M"],
		},
	},
	lucario: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			aurasphere: ["9L25"],
			blazekick: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L28"],
			bulletpunch: ["9L1"],
			calmmind: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L54"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			detect: ["9L0"],
			dig: ["9M"],
			dragonpulse: ["9M", "9L38"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			endure: ["9M", "9L1"],
			extremespeed: ["9L45"],
			facade: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			irontail: ["9M"],
			lowsweep: ["9M"],
			metalclaw: ["9L8"],
			metalsound: ["9L32"],
			metronome: ["9M"],
			nastyplot: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M", "9L1"],
			psychic: ["9M"],
			quickattack: ["9L1"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L20"],
			rocktomb: ["9M"],
			screech: ["9L24"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L35"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M", "9L16"],
			zenheadbutt: ["9M"],
		},
	},
	hippopotas: {
		learnset: {
			amnesia: ["9L24"],
			bite: ["9L4"],
			bodyslam: ["9M"],
			crunch: ["9M", "9L20"],
			curse: ["9M", "9L8"],
			dig: ["9M", "9L16"],
			doubleedge: ["9M", "9L44"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L40"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			icefang: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			roar: ["9M", "9L32"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L12"],
			scorchingsands: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L28"],
			thunderfang: ["9M"],
			whirlwind: ["9M"],
		},
	},
	hippowdon: {
		learnset: {
			amnesia: ["9L24"],
			bite: ["9L1"],
			bodyslam: ["9M"],
			crunch: ["9M", "9L20"],
			curse: ["9M"],
			dig: ["9M", "9L16"],
			doubleedge: ["9M", "9L44"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L40"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			gigaimpact: ["9M"],
			heavyslam: ["9L36"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			ironhead: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			roar: ["9M", "9L32"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L12"],
			scorchingsands: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L28"],
			thunderfang: ["9M"],
			whirlwind: ["9M"],
		},
	},
	snover: {
		learnset: {
			blizzard: ["9M", "9L45"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			chillingwater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growth: ["9L30"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9L15"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L25"],
			leafage: ["9L1"],
			leafstorm: ["9L53"],
			leechseed: ["9L35"],
			leer: ["9L1"],
			mist: ["9L10"],
			protect: ["9M"],
			razorleaf: ["9L20"],
			seedbomb: ["9M"],
			sheercold: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			woodhammer: ["9L41"],
		},
	},
	abomasnow: {
		learnset: {
			blizzard: ["9M", "9L45"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			focusblast: ["9M"],
			frostbreath: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			growth: ["9L30"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icehammer: ["9L0"],
			icepunch: ["9M", "9L0"],
			iceshard: ["9L15"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L25"],
			leafage: ["9L1"],
			leafstorm: ["9L53"],
			leechseed: ["9L35"],
			leer: ["9L1"],
			mist: ["9L10"],
			outrage: ["9M"],
			protect: ["9M"],
			razorleaf: ["9L20"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			seedbomb: ["9M"],
			sheercold: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			woodhammer: ["9L41"],
		},
	},
	leafeon: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L1"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			calmmind: ["9M"],
			charm: ["9L0"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M", "9L40"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			leafblade: ["9L35"],
			leafstorm: ["9L50"],
			leechseed: ["9L20"],
			magicalleaf: ["9L25"],
			mimic: ["9M"],
			petaldance: ["9M"],
			protect: ["9M"],
			quickattack: ["9L10"],
			razorleaf: ["9L0"],
			roar: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L0"],
			swordsdance: ["9M", "9L45"],
			synthesis: ["9L30"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			wish: ["9L0"],
			xscissor: ["9M"],
		},
	},
	glaceon: {
		learnset: {
			bite: ["9L1"],
			blizzard: ["9M", "9L50"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9L0"],
			chillingwater: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			endure: ["9M"],
			facade: ["9M"],
			freezedry: ["9L40"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M", "9L36"],
			icefang: ["9M", "9L27"],
			iceshard: ["9L23"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L0"],
			irontail: ["9M"],
			mimic: ["9M"],
			mist: ["9L18"],
			protect: ["9M"],
			quickattack: ["9L10"],
			roar: ["9M"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L0"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			wish: ["9L0"],
		},
	},
	porygonz: {
		learnset: {
			agility: ["9M", "9L30"],
			blizzard: ["9M"],
			charge: ["9L1"],
			chargebeam: ["9M"],
			confuseray: ["9L1"],
			conversion: ["9L1"],
			conversion2: ["9L25"],
			darkpulse: ["9M"],
			discharge: ["9M", "9L40"],
			doubleedge: ["9M"],
			eerieimpulse: ["9L10"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M", "9L60"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			magnetbomb: ["9M"],
			metalsound: ["9L45"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9L35"],
			reflect: ["9M"],
			selfdestruct: ["9M", "9L50"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thundershock: ["9L15"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			voltswitch: ["9M"],
			zapcannon: ["9L55"],
			zenheadbutt: ["9M"],
		},
	},
	gallade: {
		learnset: {
			aerialace: ["9M", "9L18"],
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			calmmind: ["9M", "9L0"],
			chargebeam: ["9M"],
			charm: ["9L0"],
			closecombat: ["9M", "9L58"],
			cometpunch: ["9M"],
			confuseray: ["9L0"],
			confusion: ["9L6"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L1"],
			doubleteam: ["9M", "9L30"],
			drainingkiss: ["9L0"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			firepunch: ["9M"],
			futuresight: ["9M", "9L0"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L1"],
			icepunch: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9L50"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			magicalleaf: ["9L0"],
			metronome: ["9M"],
			mysticalfire: ["9L0"],
			nightslash: ["9M", "9L0"],
			protect: ["9M", "9L28"],
			psybeam: ["9L1"],
			psychic: ["9M", "9L0"],
			psychocut: ["9L42"],
			psyshock: ["9M"],
			razorwind: ["9M"],
			reflect: ["9M"],
			rocktomb: ["9M"],
			sacredsword: ["9L0"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L0"],
			solarblade: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L35"],
			taunt: ["9M"],
			teleport: ["9L15"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			tripleaxel: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	froslass: {
		learnset: {
			bite: ["9L1"],
			blizzard: ["9M", "9L50"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9L15"],
			crunch: ["9M", "9L0"],
			curse: ["9M", "9L60"],
			doubleteam: ["9M", "9L1"],
			drainingkiss: ["9L0"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L25"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L30"],
			headbutt: ["9M", "9L1"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M", "9L35"],
			icefang: ["9M", "9L0"],
			icepunch: ["9M"],
			iceshard: ["9L10"],
			iciclecrash: ["9L0"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L20"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			nastyplot: ["9M"],
			petaldance: ["9M"],
			phantomforce: ["9L55"],
			protect: ["9M", "9L0"],
			psychic: ["9M"],
			reflect: ["9M"],
			shadowball: ["9M", "9L40"],
			sheercold: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			waterpulse: ["9M"],
			willowisp: ["9M", "9L45"],
		},
	},
	rotom: {
		learnset: {
			agility: ["9M"],
			charge: ["9L12"],
			chargebeam: ["9M"],
			confuseray: ["9L8"],
			curse: ["9M"],
			darkpulse: ["9M"],
			discharge: ["9M", "9L50"],
			doubleteam: ["9M", "9L1"],
			dreameater: ["9M"],
			eerieimpulse: ["9L25"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lightscreen: ["9M", "9L44"],
			magnetbomb: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			paraboliccharge: ["9L15"],
			partingshot: ["9L17"],
			protect: ["9M"],
			psybeam: ["9L23"],
			reflect: ["9M"],
			shadowball: ["9M", "9L30"],
			substitute: ["9M", "9L40"],
			swift: ["9M"],
			taunt: ["9M", "9L34"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L20"],
			voltswitch: ["9M"],
			willowisp: ["9M"],
		},
	},
	rotomheat: {
		learnset: {
			overheat: ["8R"],
		},
	},
	rotomwash: {
		learnset: {
			hydropump: ["8R"],
		},
	},
	rotomfrost: {
		learnset: {
			blizzard: ["8R"],
		},
	},
	rotomfan: {
		learnset: {
			airslash: ["8R"],
		},
	},
	rotommow: {
		learnset: {
			leafstorm: ["8R"],
		},
	},
	heatran: {
		inherit: true,
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L36"],
			darkpulse: ["9M"],
			dig: ["9M"],
			dragonpulse: ["9M"],
			earthpower: ["9M", "9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L18"],
			firespin: ["9M", "9L1"],
			firstimpression: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			heatcrash: ["9L1"],
			heatwave: ["9M", "9L64"],
			heavyslam: ["9L50"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M", "9L30"],
			lavaplume: ["9L42"],
			leer: ["9L1"],
			lunge: ["9L59"],
			magmastorm: ["9L72"],
			metalclaw: ["9L6"],
			metalsound: ["9L48"],
			overheat: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			rockblast: ["9L12"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M", "9L66"],
			substitute: ["9M"],
			takedown: ["9L24"],
			taunt: ["9M"],
			willowisp: ["9M"],
		},
	},
	darkrai: {
		inherit: true,
		learnset: {
			blizzard: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L10"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L1"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M", "9L93"],
			darkvoid: ["9L66"],
			doubleteam: ["9M", "9L47"],
			drainpunch: ["9M"],
			dreameater: ["9M", "9L84"],
			endure: ["9M"],
			facade: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L50"],
			gigaimpact: ["9M"],
			haze: ["9L57"],
			hyperbeam: ["9M"],
			hypnosis: ["9L20"],
			icebeam: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			nastyplot: ["9M", "9L75"],
			ominouswind: ["9M"],
			phantomforce: ["9L70"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psybeam: ["9L32"],
			psychic: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9L11"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			shadowsneak: ["9L1"],
			sludgebomb: ["9M"],
			snarl: ["9L16"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			xscissor: ["9M"],
		},
	},
	tepig: {
		learnset: {
			dig: ["9M"],
			doubleteam: ["9M"],
			ember: ["9L6"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L29"],
			flamewheel: ["9L15"],
			flareblitz: ["9M", "9L50"],
			focusenergy: ["9L24"],
			headbutt: ["9M"],
			headsmash: ["9L56"],
			heatwave: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rollout: ["9L10"],
			smokescreen: ["9L13"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L32"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
		},
	},
	pignite: {
		learnset: {
			brickbreak: ["9M"],
			bulkup: ["9M", "9L36"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			ember: ["9L6"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L29"],
			flamewheel: ["9L15"],
			flareblitz: ["9M", "9L50"],
			focusblast: ["9M"],
			focusenergy: ["9L24"],
			headbutt: ["9M"],
			headsmash: ["9L56"],
			heatwave: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			overheat: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L0"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L10"],
			smokescreen: ["9L13"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L32"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	emboar: {
		learnset: {
			blastburn: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M", "9L36"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L45"],
			cometpunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			ember: ["9L6"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L29"],
			flamewheel: ["9L15"],
			flareblitz: ["9M", "9L50"],
			focusblast: ["9M"],
			focusenergy: ["9L24"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			headsmash: ["9L56"],
			heatcrash: ["9L0"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			overheat: ["9M"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L0"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L10"],
			scald: ["9M"],
			smokescreen: ["9L13"],
			solarblade: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L32"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	patrat: {
		learnset: {
			bite: ["9L6"],
			bulletseed: ["9M"],
			crunch: ["9M", "9L16"],
			detect: ["9L11"],
			dig: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			focusenergy: ["9L26"],
			gunkshot: ["9M"],
			hypnosis: ["9L18"],
			leer: ["9L3"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L33"],
			protect: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			superfang: ["9L21"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			workup: ["9M", "9L28"],
			zenheadbutt: ["9M"],
		},
	},
	watchog: {
		learnset: {
			bite: ["9L6"],
			bulletseed: ["9M"],
			confuseray: ["9L0"],
			crunch: ["9M", "9L16"],
			detect: ["9L11"],
			dig: ["9M"],
			doubleedge: ["9M", "9L50"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusenergy: ["9L26"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L18"],
			icepunch: ["9M"],
			irontail: ["9M", "9L40"],
			leer: ["9L3"],
			lightscreen: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L33"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rocksmash: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			superfang: ["9L21"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L46"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			workup: ["9M", "9L28"],
			zenheadbutt: ["9M"],
		},
	},
	purrloin: {
		learnset: {
			agility: ["9M"],
			bite: ["9L12"],
			darkpulse: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M", "9L1"],
			faketears: ["9L19"],
			firstimpression: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lick: ["9L9"],
			mimic: ["9M", "9L1"],
			nastyplot: ["9M", "9L32"],
			nightslash: ["9M", "9L38"],
			partingshot: ["9L44"],
			payday: ["9M"],
			playrough: ["9M", "9L52"],
			protect: ["9M"],
			quickattack: ["9L1"],
			screech: ["9L26"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L24"],
			snarl: ["9L0"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M", "9L16"],
			uturn: ["9M"],
		},
	},
	liepard: {
		learnset: {
			agility: ["9M"],
			bite: ["9L12"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M", "9L1"],
			faketears: ["9L19"],
			firefang: ["9M"],
			firstimpression: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lick: ["9L9"],
			mimic: ["9M", "9L1"],
			nastyplot: ["9M", "9L32"],
			nightslash: ["9M", "9L38"],
			partingshot: ["9L44"],
			payday: ["9M"],
			playrough: ["9M", "9L52"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9L1"],
			screech: ["9L26"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L24"],
			snarl: ["9L0"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M", "9L16"],
			uturn: ["9M"],
			xscissor: ["9M"],
		},
	},
	pansage: {
		learnset: {
			bite: ["9L19"],
			brickbreak: ["9M"],
			bulletseed: ["9M", "9L16"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			focusblast: ["9M", "9L43"],
			gigadrain: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L28"],
			irontail: ["9M"],
			leafstorm: ["9L32"],
			leechseed: ["9L1"],
			leer: ["9L4"],
			lick: ["9L7"],
			lowsweep: ["9M"],
			magicalleaf: ["9L22"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L10"],
			workup: ["9M", "9L1"],
		},
	},
	simisage: {
		learnset: {
			bite: ["9L19"],
			brickbreak: ["9M"],
			bulletseed: ["9M", "9L16"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			focusblast: ["9M", "9L43"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L28"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			leafstorm: ["9L32"],
			leechseed: ["9L1"],
			leer: ["9L4"],
			lick: ["9L7"],
			lowsweep: ["9M"],
			magicalleaf: ["9L22"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L10"],
			workup: ["9M", "9L1"],
		},
	},
	pansear: {
		learnset: {
			amnesia: ["9L25"],
			bite: ["9L19"],
			brickbreak: ["9M"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			ember: ["9L10"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M", "9L32"],
			firepunch: ["9M"],
			firespin: ["9M", "9L1"],
			flamethrower: ["9M"],
			flamewheel: ["9L16"],
			flareblitz: ["9M"],
			focusblast: ["9M", "9L43"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L28"],
			heatwave: ["9M"],
			irontail: ["9M"],
			leer: ["9L4"],
			lick: ["9L7"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			overheat: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			willowisp: ["9M"],
			workup: ["9M", "9L1"],
		},
	},
	simisear: {
		learnset: {
			amnesia: ["9L25"],
			bite: ["9L19"],
			blazekick: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			ember: ["9L10"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fireblast: ["9M", "9L32"],
			firepunch: ["9M"],
			firespin: ["9M", "9L1"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flamewheel: ["9L16"],
			flareblitz: ["9M"],
			focusblast: ["9M", "9L43"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L28"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			leer: ["9L4"],
			lick: ["9L7"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			overheat: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			willowisp: ["9M"],
			workup: ["9M", "9L1"],
		},
	},
	panpour: {
		learnset: {
			aquaring: ["9L1"],
			bite: ["9L19"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L16"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M", "9L43"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L28"],
			hydropump: ["9M", "9L32"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			leer: ["9L4"],
			lick: ["9L7"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			shadowclaw: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L25"],
			waterfall: ["9M"],
			watergun: ["9L10"],
			workup: ["9M", "9L1"],
		},
	},
	simipour: {
		learnset: {
			aquaring: ["9L1"],
			bite: ["9L19"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L16"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M", "9L43"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M", "9L28"],
			hydropump: ["9M", "9L32"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			leer: ["9L4"],
			lick: ["9L7"],
			liquidation: ["9M"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			shadowclaw: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L25"],
			waterfall: ["9M"],
			watergun: ["9L10"],
			workup: ["9M", "9L1"],
		},
	},
	munna: {
		learnset: {
			amnesia: ["9L12"],
			calmmind: ["9M", "9L32"],
			charm: ["9L21"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			dreameater: ["9M", "9L28"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			futuresight: ["9M", "9L48"],
			healblock: ["9M"],
			hypnosis: ["9L1"],
			lightscreen: ["9M"],
			moonblast: ["9L40"],
			moonlight: ["9L16"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psybeam: ["9L8"],
			psychic: ["9M", "9L36"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			silverwind: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	musharna: {
		learnset: {
			amnesia: ["9L12"],
			calmmind: ["9M", "9L32"],
			chargebeam: ["9M"],
			charm: ["9L21"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			dreameater: ["9M", "9L28"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			futuresight: ["9M", "9L48"],
			gigaimpact: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L1"],
			lightscreen: ["9M"],
			moonblast: ["9L40"],
			moonlight: ["9L16"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psybeam: ["9L8"],
			psychic: ["9M", "9L36"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			silverwind: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			zenheadbutt: ["9M", "9L24"],
		},
	},
	drilbur: {
		learnset: {
			agility: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L18"],
			dig: ["9M", "9L28"],
			doubleedge: ["9M"],
			drillrun: ["9L40"],
			earthquake: ["9M", "9L46"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			irondefense: ["9M"],
			leer: ["9L1"],
			metalclaw: ["9L7"],
			mudshot: ["9M", "9L1"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rockslide: ["9M", "9L32"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L13"],
			scorchingsands: ["9M"],
			slash: ["9L24"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L36"],
			tackle: ["9L1"],
			xscissor: ["9M"],
		},
	},
	excadrill: {
		learnset: {
			agility: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L18"],
			dig: ["9M", "9L28"],
			doubleedge: ["9M"],
			drillrun: ["9L40"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L46"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			megahorn: ["9L50"],
			metalclaw: ["9L7"],
			metalsound: ["9L0"],
			mudshot: ["9M", "9L1"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rockblast: ["9L16"],
			rockslide: ["9M", "9L32"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L13"],
			scorchingsands: ["9M"],
			skullbash: ["9M"],
			slash: ["9L24"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L36"],
			tackle: ["9L1"],
			xscissor: ["9M", "9L26"],
		},
	},
	audino: {
		learnset: {
			amnesia: ["9L24"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L4"],
			doubleedge: ["9M", "9L48"],
			drainingkiss: ["9L16"],
			drainpunch: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M", "9L40"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M", "9L8"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L32"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			wildcharge: ["9M"],
			wish: ["9L36"],
			workup: ["9M"],
			zenheadbutt: ["9M", "9L20"],
		},
	},
	throh: {
		learnset: {
			amnesia: ["9L41"],
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L33"],
			brutalswing: ["9L10"],
			bulkup: ["9M", "9L25"],
			bulldoze: ["9M"],
			circlethrow: ["9M", "9L1"],
			closecombat: ["9M"],
			dig: ["9M"],
			dynamicpunch: ["9L58"],
			earthquake: ["9M"],
			endure: ["9M", "9L36"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L5"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M", "9L28"],
			outrage: ["9M", "9L43"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockblast: ["9L20"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L13"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M", "9L52"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sawk: {
		learnset: {
			blazekick: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L33"],
			bulkup: ["9M", "9L25"],
			bulldoze: ["9M"],
			closecombat: ["9M", "9L52"],
			cometpunch: ["9M"],
			detect: ["9L10"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L58"],
			earthquake: ["9M"],
			endure: ["9M", "9L36"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L5"],
			gigaimpact: ["9M"],
			icepunch: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M", "9L15"],
			leer: ["9L1"],
			lowsweep: ["9M", "9L20"],
			machpunch: ["9L12"],
			outrage: ["9M", "9L43"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L18"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L1"],
			rocktomb: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	venipede: {
		learnset: {
			agility: ["9M", "9L48"],
			doubleedge: ["9M", "9L52"],
			endure: ["9M"],
			facade: ["9M"],
			infestation: ["9L12"],
			irondefense: ["9M"],
			leer: ["9L1"],
			pinmissile: ["9L20"],
			poisonjab: ["9M", "9L28"],
			poisonsting: ["9L1"],
			protect: ["9M", "9L8"],
			rocktomb: ["9M"],
			rollout: ["9L4"],
			screech: ["9L16"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			takedown: ["9L24"],
			toxic: ["9M", "9L36"],
			toxicspikes: ["9M"],
		},
	},
	whirlipede: {
		learnset: {
			agility: ["9M", "9L48"],
			doubleedge: ["9M", "9L52"],
			endure: ["9M"],
			facade: ["9M"],
			infestation: ["9L12"],
			irondefense: ["9M"],
			leer: ["9L1"],
			mortalspin: ["9L0"],
			pinmissile: ["9L20"],
			poisonjab: ["9M", "9L28"],
			poisonsting: ["9L1"],
			protect: ["9M", "9L8"],
			rocktomb: ["9M"],
			rollout: ["9L4"],
			screech: ["9L16"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			takedown: ["9L24"],
			toxic: ["9M", "9L36"],
			toxicspikes: ["9M"],
		},
	},
	scolipede: {
		learnset: {
			acidspray: ["9M"],
			agility: ["9M", "9L48"],
			dig: ["9M"],
			doubleedge: ["9M", "9L52"],
			doublehit: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firstimpression: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			infestation: ["9L12"],
			irondefense: ["9M", "9L1"],
			irontail: ["9M", "9L40"],
			leer: ["9L1"],
			megahorn: ["9L56"],
			mortalspin: ["9L0"],
			pinmissile: ["9L20"],
			poisonjab: ["9M", "9L28"],
			poisonsting: ["9L1"],
			protect: ["9M", "9L8"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L4"],
			screech: ["9L16"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			takedown: ["9L24"],
			toxic: ["9M", "9L36"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			xscissor: ["9M", "9L44"],
		},
	},
	sandile: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L15"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L27"],
			darkpulse: ["9M"],
			dig: ["9M", "9L21"],
			doubleedge: ["9M", "9L50"],
			dragonclaw: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			irontail: ["9M", "9L36"],
			leer: ["9L1"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L9"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L24"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
		},
	},
	krokorok: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L15"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L27"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M", "9L21"],
			doubleedge: ["9M", "9L50"],
			dragonclaw: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			irontail: ["9M", "9L36"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L9"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L24"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
		},
	},
	krookodile: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L15"],
			bodyslam: ["9M"],
			breakingswipe: ["9L0"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M", "9L27"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M", "9L21"],
			doubleedge: ["9M", "9L50"],
			dragonclaw: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M", "9L36"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			outrage: ["9M", "9L58"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L9"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L24"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
		},
	},
	scraggy: {
		learnset: {
			acidspray: ["9M"],
			brickbreak: ["9M", "9L32"],
			bulkup: ["9M"],
			crunch: ["9M", "9L40"],
			curse: ["9M"],
			darkpulse: ["9M"],
			detect: ["9L35"],
			dig: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L48"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			headbutt: ["9M", "9L8"],
			headsmash: ["9L52"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M", "9L44"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			partingshot: ["9L26"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L12"],
			protect: ["9M", "9L20"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M", "9L16"],
			sludgebomb: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	scrafty: {
		learnset: {
			acidspray: ["9M"],
			brickbreak: ["9M", "9L32"],
			bulkup: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M", "9L40"],
			curse: ["9M"],
			darkpulse: ["9M"],
			detect: ["9L35"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L48"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L8"],
			headsmash: ["9L52"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M", "9L44"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			outrage: ["9M"],
			partingshot: ["9L26"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L12"],
			protect: ["9M", "9L20"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M", "9L16"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	yamask: {
		learnset: {
			calmmind: ["9M"],
			confuseray: ["9L8"],
			confusion: ["9L1"],
			curse: ["9M", "9L36"],
			darkpulse: ["9M", "9L44"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9L12"],
			haze: ["9L4"],
			healblock: ["9M"],
			infestation: ["9L22"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			partingshot: ["9L48"],
			phantomforce: ["9L46"],
			protect: ["9M", "9L1"],
			psychic: ["9M"],
			psyshock: ["9M", "9L30"],
			safeguard: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			willowisp: ["9M", "9L16"],
			zenheadbutt: ["9M"],
		},
	},
	yamaskgalar: {
		learnset: {
			brutalswing: ["9L16"],
			calmmind: ["9M"],
			confuseray: ["9L8"],
			confusion: ["9L1"],
			curse: ["9M", "9L36"],
			darkpulse: ["9M"],
			dreameater: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L44"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9L12"],
			haze: ["9L4"],
			healblock: ["9M"],
			infestation: ["9L22"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			partingshot: ["9L48"],
			phantomforce: ["9L46"],
			protect: ["9M", "9L1"],
			psychic: ["9M"],
			psyshock: ["9M", "9L30"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	cofagrigus: {
		learnset: {
			calmmind: ["9M"],
			confuseray: ["9L8"],
			confusion: ["9L1"],
			curse: ["9M", "9L36"],
			darkpulse: ["9M", "9L44"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9L12"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L4"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icywind: ["9M"],
			infestation: ["9L22"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			partingshot: ["9L48"],
			phantomforce: ["9L46"],
			protect: ["9M", "9L1"],
			psychic: ["9M"],
			psyshock: ["9M", "9L30"],
			safeguard: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowclaw: ["9M", "9L0"],
			shadowpunch: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			willowisp: ["9M", "9L16"],
			zenheadbutt: ["9M"],
		},
	},
	trubbish: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L9"],
			brutalswing: ["9L18"],
			bulletseed: ["9M"],
			darkpulse: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			explosion: ["9L53"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gunkshot: ["9M", "9L44"],
			headbutt: ["9M", "9L1"],
			mudshot: ["9M"],
			poisonjab: ["9M", "9L24"],
			protect: ["9M"],
			rollout: ["9L12"],
			seedbomb: ["9M"],
			selfdestruct: ["9M", "9L34"],
			sludgebomb: ["9M", "9L27"],
			sludgewave: ["9L39"],
			smokescreen: ["9L1"],
			spikes: ["9M"],
			substitute: ["9M"],
			takedown: ["9L20"],
			toxic: ["9M", "9L30"],
			toxicspikes: ["9M", "9L15"],
		},
	},
	garbodor: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9L9"],
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			brutalswing: ["9L18"],
			bulletseed: ["9M"],
			darkpulse: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			explosion: ["9L53"],
			facade: ["9M"],
			focusblast: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L44"],
			headbutt: ["9M", "9L1"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			magnetbomb: ["9M"],
			metalclaw: ["9L1"],
			mudshot: ["9M"],
			poisonjab: ["9M", "9L24"],
			protect: ["9M"],
			psychic: ["9M"],
			rollout: ["9L12"],
			seedbomb: ["9M"],
			selfdestruct: ["9M", "9L34"],
			sludgebomb: ["9M", "9L27"],
			sludgewave: ["9L39"],
			smokescreen: ["9L1"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			takedown: ["9L20"],
			thunderbolt: ["9M"],
			toxic: ["9M", "9L30"],
			toxicspikes: ["9M", "9L15"],
		},
	},
	vanillite: {
		learnset: {
			acidarmor: ["9L32"],
			blizzard: ["9M", "9L58"],
			endure: ["9M"],
			explosion: ["9L46"],
			facade: ["9M"],
			flashcannon: ["9M"],
			frostbreath: ["9M"],
			harden: ["9L1"],
			hypervoice: ["9M"],
			icebeam: ["9M", "9L35"],
			iciclecrash: ["9L24"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			mist: ["9L8"],
			protect: ["9M"],
			selfdestruct: ["9M", "9L20"],
			sheercold: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L4"],
		},
	},
	vanillish: {
		learnset: {
			acidarmor: ["9L32"],
			blizzard: ["9M", "9L58"],
			endure: ["9M"],
			explosion: ["9L46"],
			facade: ["9M"],
			flashcannon: ["9M"],
			frostbreath: ["9M"],
			harden: ["9L1"],
			hypervoice: ["9M"],
			icebeam: ["9M", "9L35"],
			iciclecrash: ["9L24"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			mist: ["9L8"],
			protect: ["9M"],
			selfdestruct: ["9M", "9L20"],
			sheercold: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L4"],
		},
	},
	vanilluxe: {
		learnset: {
			acidarmor: ["9L32"],
			blizzard: ["9M", "9L58"],
			chillingwater: ["9M"],
			endure: ["9M"],
			explosion: ["9L46"],
			facade: ["9M"],
			flashcannon: ["9M"],
			freezedry: ["9L1"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M", "9L35"],
			iciclecrash: ["9L24"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			mist: ["9L8"],
			protect: ["9M"],
			selfdestruct: ["9M", "9L20"],
			sheercold: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L4"],
		},
	},
	emolga: {
		learnset: {
			agility: ["9M"],
			airslash: ["9L35"],
			charge: ["9L20"],
			chargebeam: ["9M"],
			charm: ["9L7"],
			discharge: ["9M", "9L52"],
			doubleteam: ["9M", "9L5"],
			dualwingbeat: ["9M"],
			eerieimpulse: ["9L25"],
			electroweb: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L44"],
			nuzzle: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L10"],
			razorwind: ["9M"],
			solarbeam: ["9M"],
			spark: ["9L29"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thundershock: ["9L15"],
			thunderwave: ["9M"],
			uturn: ["9M"],
			voltswitch: ["9M", "9L40"],
			wildcharge: ["9M"],
			wingattack: ["9L22"],
		},
	},
	foongus: {
		learnset: {
			absorb: ["9L1"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firstimpression: ["9M"],
			gigadrain: ["9M", "9L28"],
			growth: ["9L1"],
			healblock: ["9M"],
			leafstorm: ["9L62"],
			magicalleaf: ["9L14"],
			mimic: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			rollout: ["9L10"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M", "9L48"],
			spore: ["9L54"],
			stunspore: ["9L1"],
			substitute: ["9M"],
			synthesis: ["9L16"],
			toxic: ["9M", "9L36"],
			toxicspikes: ["9M", "9L22"],
		},
	},
	amoonguss: {
		learnset: {
			absorb: ["9L1"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firstimpression: ["9M"],
			gigadrain: ["9M", "9L28"],
			gigaimpact: ["9M"],
			growth: ["9L1"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			leafstorm: ["9L62"],
			magicalleaf: ["9L14"],
			mimic: ["9M"],
			mudshot: ["9M"],
			protect: ["9M"],
			rollout: ["9L10"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M", "9L48"],
			spore: ["9L54"],
			stunspore: ["9L1"],
			substitute: ["9M"],
			swagger: ["9M"],
			synthesis: ["9L16"],
			torment: ["9M"],
			toxic: ["9M", "9L36"],
			toxicspikes: ["9M", "9L22"],
		},
	},
	tynamo: {
		learnset: {
			chargebeam: ["9M"],
			facade: ["9M"],
			protect: ["9M"],
			spark: ["9L1"],
			tackle: ["9L1"],
			thunderwave: ["9M", "9L1"],
		},
	},
	eelektrik: {
		learnset: {
			acidspray: ["9M"],
			bodyslam: ["9M"],
			charge: ["9L39"],
			chargebeam: ["9M"],
			crunch: ["9M", "9L0"],
			discharge: ["9M", "9L29"],
			eerieimpulse: ["9L33"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigadrain: ["9M"],
			headbutt: ["9M", "9L1"],
			lightscreen: ["9M"],
			protect: ["9M"],
			spark: ["9L1"],
			substitute: ["9M"],
			superfang: ["9L50"],
			tackle: ["9L1"],
			takedown: ["9L18"],
			thunder: ["9M"],
			thunderbolt: ["9M", "9L44"],
			thunderfang: ["9M"],
			thunderwave: ["9M", "9L1"],
			uturn: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M", "9L46"],
			zapcannon: ["9L48"],
		},
	},
	eelektross: {
		learnset: {
			acidspray: ["9M"],
			bodyslam: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			charge: ["9L39"],
			chargebeam: ["9M"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			confuseray: ["9L21"],
			crunch: ["9M", "9L1"],
			discharge: ["9M", "9L29"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			drainpunch: ["9M"],
			eerieimpulse: ["9L33"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L1"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M", "9L36"],
			muddywater: ["9M"],
			outrage: ["9M"],
			poisonfang: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			spark: ["9L1"],
			substitute: ["9M"],
			superfang: ["9L50"],
			tackle: ["9L1"],
			takedown: ["9L18"],
			thunder: ["9M"],
			thunderbolt: ["9M", "9L44"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			uturn: ["9M"],
			voltswitch: ["9M"],
			waterfall: ["9M"],
			wildcharge: ["9M", "9L46"],
			zapcannon: ["9L48"],
			zenheadbutt: ["9M"],
		},
	},
	litwick: {
		learnset: {
			acidarmor: ["9L16"],
			calmmind: ["9M"],
			confuseray: ["9L12"],
			curse: ["9M", "9L44"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L24"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L28"],
			flamewheel: ["9L38"],
			haze: ["9L10"],
			healblock: ["9M", "9L48"],
			heatwave: ["9M"],
			overheat: ["9M", "9L52"],
			protect: ["9M"],
			psychic: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M", "9L32"],
			smokescreen: ["9L1"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			willowisp: ["9M", "9L20"],
		},
	},
	lampent: {
		learnset: {
			acidarmor: ["9L16"],
			calmmind: ["9M"],
			confuseray: ["9L12"],
			curse: ["9M", "9L44"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L24"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L28"],
			flamewheel: ["9L38"],
			haze: ["9L10"],
			healblock: ["9M", "9L48"],
			heatwave: ["9M"],
			ominouswind: ["9M"],
			overheat: ["9M", "9L52"],
			protect: ["9M"],
			psychic: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M", "9L32"],
			smokescreen: ["9L1"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			willowisp: ["9M", "9L20"],
		},
	},
	chandelure: {
		learnset: {
			acidarmor: ["9L16"],
			acidspray: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9L12"],
			curse: ["9M", "9L44"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L24"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L28"],
			flamewheel: ["9L38"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L10"],
			healblock: ["9M", "9L48"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			ominouswind: ["9M"],
			overheat: ["9M", "9L52"],
			protect: ["9M"],
			psychic: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M", "9L32"],
			smokescreen: ["9L1"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M", "9L20"],
		},
	},
	cryogonal: {
		learnset: {
			acidarmor: ["9L52"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9L4"],
			endure: ["9M"],
			explosion: ["9L60"],
			facade: ["9M"],
			flashcannon: ["9M"],
			freezedry: ["9L36"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L16"],
			hyperbeam: ["9M"],
			icebeam: ["9M", "9L48"],
			iceshard: ["9L1"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M"],
			lightscreen: ["9M", "9L40"],
			mist: ["9L16"],
			nightslash: ["9M", "9L32"],
			poisonjab: ["9M"],
			protect: ["9M"],
			recover: ["9L44"],
			reflect: ["9M", "9L40"],
			selfdestruct: ["9M"],
			sheercold: ["9M", "9L65"],
			slash: ["9L28"],
			solarbeam: ["9M", "9L56"],
			substitute: ["9M"],
			tripleaxel: ["9M"],
			waterpulse: ["9M"],
		},
	},
	stunfisk: {
		learnset: {
			bounce: ["9L40"],
			bulldoze: ["9M"],
			charge: ["9L20"],
			curse: ["9M"],
			dig: ["9M"],
			discharge: ["9M", "9L35"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L30"],
			eerieimpulse: ["9L45"],
			electroweb: ["9M"],
			endure: ["9M", "9L5"],
			facade: ["9M"],
			fissure: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L10"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M", "9L15"],
			scald: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9L50"],
			spark: ["9L25"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M"],
			watergun: ["9L1"],
		},
	},
	stunfiskgalar: {
		learnset: {
			bounce: ["9L35"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L45"],
			curse: ["9M"],
			dig: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L30"],
			endure: ["9M", "9L5"],
			facade: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M", "9L25"],
			magnetbomb: ["9M"],
			metalclaw: ["9L1"],
			metalsound: ["9L20"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L10"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M", "9L15"],
			scald: ["9M"],
			screech: ["9L1"],
			sludgebomb: ["9M"],
			sludgewave: ["9L40"],
			stealthrock: ["9M", "9L50"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			watergun: ["9L1"],
		},
	},
	golett: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L22"],
			cometpunch: ["9M"],
			curse: ["9M", "9L16"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L65"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L55"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			harden: ["9L1"],
			heavyslam: ["9L42"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M", "9L28"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			magnetbomb: ["9M"],
			mudshot: ["9M"],
			phantomforce: ["9L48"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L18"],
			safeguard: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L36"],
			shadowpunch: ["9M", "9L12"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			thunderpunch: ["9M"],
		},
	},
	golurk: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L22"],
			chargebeam: ["9M"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			curse: ["9M", "9L16"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L65"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L55"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			heavyslam: ["9L42"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M", "9L28"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			magnetbomb: ["9M"],
			mudshot: ["9M"],
			phantomforce: ["9L48"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L18"],
			safeguard: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L36"],
			shadowpunch: ["9M", "9L12"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	cobalion: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			airslash: ["9L38"],
			aurasphere: ["9L30"],
			bodyslam: ["9M", "9L14"],
			bounce: ["9L26"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M", "9L70"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			heavyslam: ["9L34"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M", "9L63"],
			leer: ["9L1"],
			megahorn: ["9L42"],
			metalclaw: ["9L7"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			roar: ["9M"],
			sacredsword: ["9L49"],
			safeguard: ["9M"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L56"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			vacuumwave: ["9M"],
			voltswitch: ["9M"],
			workup: ["9M", "9L1"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	terrakion: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			aurasphere: ["9L30"],
			bodyslam: ["9M", "9L14"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M", "9L70"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			headsmash: ["9L78"],
			heavyslam: ["9L26"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			megahorn: ["9L42"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			roar: ["9M"],
			rockblast: ["9L34"],
			rockslide: ["9M", "9L38"],
			rockthrow: ["9L7"],
			rocktomb: ["9M"],
			sacredsword: ["9L49"],
			safeguard: ["9M"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L63"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L56"],
			takedown: ["9L20"],
			taunt: ["9M"],
			workup: ["9M", "9L1"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	virizion: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			airslash: ["9L38"],
			aurasphere: ["9L30"],
			bodyslam: ["9M", "9L14"],
			bounce: ["9L26"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M", "9L70"],
			doubleedge: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusblast: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hornleech: ["9L34"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			leafblade: ["9L63"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			magicalleaf: ["9L7"],
			megahorn: ["9L42"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			roar: ["9M"],
			sacredsword: ["9L49"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L56"],
			synthesis: ["9L1"],
			takedown: ["9L20"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M", "9L1"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	keldeo: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			airslash: ["9L38"],
			aquajet: ["9L1"],
			aurasphere: ["9L30"],
			bodyslam: ["9M", "9L14"],
			bounce: ["9L26"],
			brickbreak: ["9M"],
			bubblebeam: ["9L7"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M", "9L70"],
			doubleedge: ["9M"],
			earthpower: ["9M", "9L34"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			hydropump: ["9M", "9L63"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			megahorn: ["9L42"],
			muddywater: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			sacredsword: ["9L49"],
			safeguard: ["9M"],
			scald: ["9M"],
			secretsword: ["9L1"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L56"],
			takedown: ["9L20"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			vacuumwave: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M", "9L1"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	meloetta: {
		inherit: true,
		learnset: {
			agility: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			closecombat: ["9M", "9L78"],
			cometpunch: ["9M"],
			confusion: ["9L1"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L11"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9L14"],
			firepunch: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M", "9L64"],
			icepunch: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			mimic: ["9M"],
			perishsong: ["9L85"],
			petaldance: ["9M"],
			playrough: ["9M"],
			powergem: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			psybeam: ["9L31"],
			psychic: ["9M", "9L57"],
			psyshock: ["9M"],
			quickattack: ["9L1"],
			relicsong: ["9L50"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sing: ["9M", "9L1"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L22"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			tripleaxel: ["9M"],
			uturn: ["9M", "9L43"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	genesect: {
		inherit: true,
		learnset: {
			ancientpower: ["9M"],
			blazekick: ["9M"],
			blizzard: ["9M"],
			bugbuzz: ["9L56"],
			chargebeam: ["9M"],
			darkpulse: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			flamecharge: ["9M", "9L28"],
			flamethrower: ["9M"],
			flashcannon: ["9M", "9L45"],
			fly: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M", "9L62"],
			leechlife: ["9L49"],
			lightscreen: ["9M"],
			lunge: ["9L42"],
			magnetbomb: ["9M"],
			metalclaw: ["9L14"],
			metalsound: ["9L35"],
			protect: ["9M"],
			psychic: ["9M"],
			quickattack: ["9L1"],
			reflect: ["9M"],
			screech: ["9L7"],
			selfdestruct: ["9M", "9L91"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			technoblast: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			uturn: ["9M"],
			xscissor: ["9M", "9L21"],
			zapcannon: ["9L70"],
			zenheadbutt: ["9M"],
		},
	},
	chespin: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L11"],
			bodyslam: ["9M", "9L42"],
			brickbreak: ["9M", "9L35"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growl: ["9L1"],
			growth: ["9L5"],
			headbutt: ["9M"],
			ironhead: ["9M"],
			leechseed: ["9L15"],
			mudshot: ["9M"],
			pinmissile: ["9L18"],
			poisonjab: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L8"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			takedown: ["9L27"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			woodhammer: ["9L48"],
			zenheadbutt: ["9M"],
		},
	},
	quilladin: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L11"],
			bodyslam: ["9M", "9L42"],
			brickbreak: ["9M", "9L35"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growl: ["9L1"],
			growth: ["9L5"],
			headbutt: ["9M"],
			ironhead: ["9M"],
			leechseed: ["9L15"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			pinmissile: ["9L18"],
			poisonjab: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L8"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			takedown: ["9L27"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			woodhammer: ["9L48"],
			zenheadbutt: ["9M"],
		},
	},
	chesnaught: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L11"],
			bodyslam: ["9M", "9L42"],
			brickbreak: ["9M", "9L35"],
			bulkup: ["9M", "9L38"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			closecombat: ["9M", "9L45"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M", "9L55"],
			growl: ["9L1"],
			growth: ["9L5"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			leechseed: ["9L15"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			pinmissile: ["9L18"],
			poisonjab: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			rollout: ["9L8"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			spikes: ["9M"],
			spikyshield: ["9L0"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			takedown: ["9L27"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			woodhammer: ["9L48"],
			zenheadbutt: ["9M"],
		},
	},
	fennekin: {
		learnset: {
			agility: ["9M"],
			calmmind: ["9M"],
			charm: ["9L14"],
			ember: ["9L5"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M", "9L54"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L35"],
			flareblitz: ["9M"],
			lightscreen: ["9M", "9L25"],
			overheat: ["9M"],
			protect: ["9M"],
			psybeam: ["9L17"],
			psychic: ["9M", "9L41"],
			psyshock: ["9M", "9L31"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			willowisp: ["9M", "9L38"],
		},
	},
	braixen: {
		learnset: {
			agility: ["9M", "9L46"],
			calmmind: ["9M"],
			charm: ["9L14"],
			ember: ["9L5"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M", "9L54"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L35"],
			flareblitz: ["9M"],
			heatwave: ["9M"],
			lightscreen: ["9M", "9L25"],
			overheat: ["9M"],
			protect: ["9M"],
			psybeam: ["9L17"],
			psychic: ["9M", "9L41"],
			psyshock: ["9M", "9L31"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			thunderpunch: ["9M"],
			willowisp: ["9M", "9L38"],
		},
	},
	delphox: {
		learnset: {
			agility: ["9M", "9L46"],
			blastburn: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L14"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			dreameater: ["9M"],
			ember: ["9L5"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M", "9L54"],
			firepunch: ["9M"],
			firespin: ["9M", "9L20"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L35"],
			flareblitz: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M", "9L0"],
			healblock: ["9M"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lightscreen: ["9M", "9L25"],
			metronome: ["9M"],
			mysticalfire: ["9L0"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			psybeam: ["9L17"],
			psychic: ["9M", "9L41"],
			psyshock: ["9M", "9L31"],
			razorwind: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M", "9L0"],
			silverwind: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			thunderpunch: ["9M"],
			willowisp: ["9M", "9L38"],
			zenheadbutt: ["9M"],
		},
	},
	froakie: {
		learnset: {
			aerialace: ["9M"],
			blizzard: ["9M"],
			bounce: ["9L43"],
			bubblebeam: ["9L14"],
			chillingwater: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M", "9L51"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			growl: ["9L1"],
			hydropump: ["9M", "9L57"],
			icebeam: ["9M"],
			icywind: ["9M"],
			lick: ["9L10"],
			liquidation: ["9M"],
			nightslash: ["9M", "9L38"],
			protect: ["9M"],
			quickattack: ["9L8"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			smokescreen: ["9L18"],
			spikes: ["9M"],
			substitute: ["9M", "9L35"],
			surf: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M"],
		},
	},
	frogadier: {
		learnset: {
			aerialace: ["9M", "9L23"],
			blizzard: ["9M"],
			bounce: ["9L43"],
			brickbreak: ["9M"],
			bubblebeam: ["9L14"],
			chillingwater: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M", "9L51"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flipturn: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			hydropump: ["9M", "9L57"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			lick: ["9L10"],
			liquidation: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M", "9L38"],
			protect: ["9M"],
			quickattack: ["9L8"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowsneak: ["9L28"],
			smokescreen: ["9L18"],
			spikes: ["9M"],
			substitute: ["9M", "9L35"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M"],
		},
	},
	greninja: {
		learnset: {
			aerialace: ["9M", "9L23"],
			blizzard: ["9M"],
			bounce: ["9L43"],
			brickbreak: ["9M"],
			bubblebeam: ["9L14"],
			chillingwater: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M", "9L51"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M", "9L57"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			lick: ["9L10"],
			liquidation: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M", "9L38"],
			protect: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9L8"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowsneak: ["9L28"],
			smokescreen: ["9L18"],
			spikes: ["9M"],
			substitute: ["9M", "9L35"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M"],
			watershuriken: ["9L0"],
		},
	},
	greninjabond: {},
	bunnelby: {
		learnset: {
			agility: ["9M"],
			bounce: ["9L32"],
			brickbreak: ["9M"],
			brutalswing: ["9L24"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			dig: ["9M", "9L28"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L44"],
			endure: ["9M"],
			facade: ["9M"],
			headbutt: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			mudshot: ["9M", "9L7"],
			protect: ["9M"],
			quickattack: ["9L14"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			sludgebomb: ["9M"],
			spikes: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superfang: ["9L40"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
			uturn: ["9M"],
			wildcharge: ["9M"],
		},
	},
	diggersby: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9L32"],
			brickbreak: ["9M"],
			brutalswing: ["9L24"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L0"],
			circlethrow: ["9M"],
			cometpunch: ["9M"],
			dig: ["9M", "9L28"],
			drainpunch: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L44"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			ironhead: ["9M"],
			leer: ["9L1"],
			mudshot: ["9M", "9L7"],
			protect: ["9M"],
			quickattack: ["9L14"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			scorchingsands: ["9M"],
			skullbash: ["9M"],
			sludgebomb: ["9M"],
			spikes: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superfang: ["9L40"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
			thunderpunch: ["9M"],
			uturn: ["9M"],
			wildcharge: ["9M"],
		},
	},
	fletchling: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L40"],
			airslash: ["9L35"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			ember: ["9L12"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L16"],
			flamecharge: ["9M"],
			flamewheel: ["9L25"],
			flareblitz: ["9M", "9L45"],
			fly: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			overheat: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L8"],
			steelwing: ["9L30"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L20"],
			willowisp: ["9M"],
		},
	},
	fletchinder: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L40"],
			airslash: ["9L35"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			ember: ["9L12"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L16"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flamewheel: ["9L25"],
			flareblitz: ["9M", "9L45"],
			fly: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			overheat: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L8"],
			steelwing: ["9L30"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			whirlwind: ["9M", "9L20"],
			willowisp: ["9M"],
			wingattack: ["9L0"],
		},
	},
	talonflame: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L40"],
			airslash: ["9L35"],
			blazekick: ["9M"],
			bravebird: ["9L0"],
			bulkup: ["9M"],
			doubleedge: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			ember: ["9L12"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L16"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flamewheel: ["9L25"],
			flareblitz: ["9M", "9L45"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			overheat: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L8"],
			skyattack: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9L30"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			whirlwind: ["9M", "9L20"],
			willowisp: ["9M"],
			wingattack: ["9L1"],
		},
	},
	scatterbug: {
		learnset: {
			endure: ["9M"],
			facade: ["9M"],
			protect: ["9M"],
			stringshot: ["9L1"],
			stunspore: ["9L7"],
			tackle: ["9L1"],
		},
	},
	spewpa: {
		learnset: {
			endure: ["9M"],
			facade: ["9M"],
			harden: ["9L1"],
			infestation: ["9L10"],
			irondefense: ["9M"],
			poisonpowder: ["9L1"],
			protect: ["9M", "9L0"],
			stringshot: ["9L1"],
			stunspore: ["9L7"],
			tackle: ["9L1"],
		},
	},
	vivillon: {
		learnset: {
			airslash: ["9L28"],
			bugbuzz: ["9L35"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9L15"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gust: ["9L0"],
			harden: ["9L0"],
			hurricane: ["9M", "9L40"],
			hyperbeam: ["9M"],
			infestation: ["9L10"],
			irondefense: ["9M"],
			lightscreen: ["9M", "9L12"],
			ominouswind: ["9M"],
			petaldance: ["9M"],
			poisonpowder: ["9L1"],
			protect: ["9M", "9L0"],
			psybeam: ["9L21"],
			psychic: ["9M"],
			safeguard: ["9M", "9L40"],
			silverwind: ["9M"],
			sleeppowder: ["9L1"],
			solarbeam: ["9M"],
			stringshot: ["9L0"],
			stunspore: ["9L1"],
			substitute: ["9M"],
			supersonic: ["9L17"],
			swift: ["9M"],
			tackle: ["9L0"],
			uturn: ["9M", "9L25"],
			whirlwind: ["9M", "9L45"],
		},
	},
	vivillonfancy: {},
	vivillonpokeball: {},
	litleo: {
		learnset: {
			bodyslam: ["9M"],
			crunch: ["9M", "9L36"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M", "9L28"],
			ember: ["9L5"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L23"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L32"],
			flareblitz: ["9M"],
			headbutt: ["9M", "9L11"],
			heatwave: ["9M"],
			hypervoice: ["9M", "9L42"],
			leer: ["9L1"],
			overheat: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L6"],
			snarl: ["9L16"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			workup: ["9M", "9L8"],
		},
	},
	pyroar: {
		learnset: {
			bodyslam: ["9M"],
			crunch: ["9M", "9L36"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M", "9L28"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M", "9L23"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M", "9L32"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L11"],
			heatwave: ["9M"],
			hyperbeam: ["9M", "9L0"],
			hypervoice: ["9M", "9L42"],
			leer: ["9L1"],
			overheat: ["9M", "9L0"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L6"],
			snarl: ["9L16"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			workup: ["9M", "9L8"],
		},
	},
	flabebe: {
		learnset: {
			calmmind: ["9M"],
			charm: ["9L26"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L18"],
			endure: ["9M"],
			energyball: ["9M", "9L40"],
			facade: ["9M"],
			fairywind: ["9L6"],
			gigadrain: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L22"],
			petaldance: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			razorleaf: ["9L15"],
			safeguard: ["9M", "9L10"],
			seedbomb: ["9M"],
			solarbeam: ["9M", "9L54"],
			substitute: ["9M"],
			swift: ["9M"],
			synthesis: ["9L33"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			wish: ["9L20"],
		},
	},
	floette: {
		learnset: {
			calmmind: ["9M"],
			charm: ["9L26"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L18"],
			endure: ["9M"],
			energyball: ["9M", "9L40"],
			facade: ["9M"],
			fairywind: ["9L1"],
			gigadrain: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L22"],
			metronome: ["9M"],
			moonblast: ["9L0"],
			ominouswind: ["9M"],
			petaldance: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			razorleaf: ["9L15"],
			safeguard: ["9M", "9L10"],
			seedbomb: ["9M"],
			silverwind: ["9M"],
			solarbeam: ["9M", "9L54"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			synthesis: ["9L33"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			wish: ["9L20"],
		},
	},
	floetteeternal: {
		inherit: true,
		learnset: {
			calmmind: ["9M"],
			charm: ["9L26"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9L18"],
			endure: ["9M"],
			energyball: ["9M", "9L40", "9S0"],
			facade: ["9M"],
			fairywind: ["9L1"],
			gigadrain: ["9M", "9S0"],
			hyperbeam: ["9M"],
			lightofruin: ["9L50", "9S0"],
			lightscreen: ["9M"],
			magicalleaf: ["9L22"],
			metronome: ["9M"],
			moonblast: ["9L0"],
			ominouswind: ["9M"],
			petaldance: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			razorleaf: ["9L15"],
			safeguard: ["9M", "9L10"],
			seedbomb: ["9M"],
			silverwind: ["9M"],
			solarbeam: ["9M", "9L54"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			synthesis: ["9L33", "9S0"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			wish: ["9L20"],
		},
	},
	florges: {
		learnset: {
			calmmind: ["9M"],
			charm: ["9L26"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L0"],
			doubleteam: ["9M"],
			drainingkiss: ["9L18"],
			endure: ["9M"],
			energyball: ["9M", "9L40"],
			facade: ["9M"],
			fairywind: ["9L1"],
			gigadrain: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L22"],
			metronome: ["9M"],
			moonblast: ["9L1"],
			ominouswind: ["9M"],
			petaldance: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			razorleaf: ["9L15"],
			safeguard: ["9M", "9L10"],
			seedbomb: ["9M"],
			silverwind: ["9M"],
			solarbeam: ["9M", "9L54"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			synthesis: ["9L33"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			vinewhip: ["9L1"],
			wish: ["9L20"],
		},
	},
	skiddo: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M", "9L38"],
			bulldoze: ["9M", "9L26"],
			bulletseed: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L42"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growth: ["9L1"],
			hornleech: ["9L34"],
			leafblade: ["9L45"],
			leechseed: ["9L12"],
			megahorn: ["9L50"],
			mudshot: ["9M", "9L16"],
			playrough: ["9M"],
			protect: ["9M"],
			razorleaf: ["9L13"],
			roar: ["9M"],
			rockslide: ["9M"],
			seedbomb: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			synthesis: ["9L20"],
			tackle: ["9L1"],
			tailwhip: ["9L9"],
			takedown: ["9L22"],
			trailblaze: ["9M"],
			vinewhip: ["9L7"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	gogoat: {
		learnset: {
			aerialace: ["9M", "9L0"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M", "9L38"],
			bulldoze: ["9M", "9L26"],
			bulletseed: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L42"],
			earthquake: ["9M", "9L55"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			growth: ["9L1"],
			hornleech: ["9L34"],
			hyperbeam: ["9M"],
			leafblade: ["9L45"],
			leechseed: ["9L12"],
			megahorn: ["9L50"],
			mudshot: ["9M", "9L16"],
			playrough: ["9M"],
			protect: ["9M"],
			razorleaf: ["9L13"],
			roar: ["9M"],
			rockslide: ["9M"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			synthesis: ["9L20"],
			tackle: ["9L1"],
			tailwhip: ["9L9"],
			takedown: ["9L22"],
			trailblaze: ["9M"],
			vinewhip: ["9L7"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	pancham: {
		learnset: {
			bodyslam: ["9M", "9L44"],
			brickbreak: ["9M", "9L15"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			circlethrow: ["9M"],
			cometpunch: ["9M"],
			crunch: ["9M", "9L34"],
			detect: ["9L28"],
			dig: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			firepunch: ["9M"],
			hypervoice: ["9M"],
			icepunch: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			partingshot: ["9L30"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L24"],
			sludgebomb: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L8"],
			thunderpunch: ["9M"],
			workup: ["9M", "9L20"],
		},
	},
	pangoro: {
		learnset: {
			bodyslam: ["9M", "9L44"],
			brickbreak: ["9M", "9L15"],
			brutalswing: ["9L34"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletpunch: ["9L1"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L58"],
			cometpunch: ["9M"],
			crunch: ["9M", "9L34"],
			darkpulse: ["9M"],
			detect: ["9L28"],
			dig: ["9M"],
			dragonclaw: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L54"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icepunch: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lowsweep: ["9M"],
			nightslash: ["9M", "9L0"],
			outrage: ["9M", "9L50"],
			partingshot: ["9L30"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L24"],
			sludgebomb: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M", "9L1"],
			thunderpunch: ["9M"],
			workup: ["9M", "9L20"],
			zenheadbutt: ["9M"],
		},
	},
	furfrou: {
		learnset: {
			bite: ["9L13"],
			chargebeam: ["9M"],
			charm: ["9L25"],
			cottonguard: ["9L22"],
			crunch: ["9M", "9L28"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L36"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M", "9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M", "9L43"],
			icefang: ["9M"],
			irontail: ["9M"],
			mimic: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L20"],
			rocksmash: ["9M"],
			skullbash: ["9M"],
			snarl: ["9L30"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L8"],
			takedown: ["9L16"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			uturn: ["9M"],
			wildcharge: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	espurr: {
		learnset: {
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confusion: ["9L9"],
			darkpulse: ["9M"],
			disarmingvoice: ["9L6"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L13"],
			leer: ["9L1"],
			lightscreen: ["9M", "9L30"],
			nastyplot: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psybeam: ["9L21"],
			psychic: ["9M"],
			psyshock: ["9M", "9L36"],
			reflect: ["9M", "9L30"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L15"],
			tackle: ["9L1"],
			teleport: ["9L1"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	meowstic: {
		learnset: {
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L18"],
			confusion: ["9L9"],
			darkpulse: ["9M"],
			dig: ["9M"],
			disarmingvoice: ["9L6"],
			doubleteam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L13"],
			gigaimpact: ["9M"],
			healblock: ["9M", "9L46"],
			hyperbeam: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M", "9L30"],
			moonblast: ["9L0"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			payday: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psybeam: ["9L21"],
			psychic: ["9M", "9L44"],
			psyshock: ["9M", "9L36"],
			reflect: ["9M", "9L30"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L15"],
			tackle: ["9L1"],
			taunt: ["9M"],
			teleport: ["9L1"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			triattack: ["9M"],
			wish: ["9L50"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	meowsticf: {
		learnset: {
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confusion: ["9L9"],
			darkpulse: ["9M", "9L24"],
			dig: ["9M"],
			disarmingvoice: ["9L1"],
			earthpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L13"],
			futuresight: ["9M", "9L50"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M", "9L30"],
			magicalleaf: ["9L1"],
			moonblast: ["9L0"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			payday: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psybeam: ["9L21"],
			psychic: ["9M", "9L44"],
			psyshock: ["9M", "9L36"],
			reflect: ["9M", "9L30"],
			safeguard: ["9M"],
			shadowball: ["9M", "9L40"],
			substitute: ["9M"],
			swift: ["9M", "9L15"],
			tackle: ["9L1"],
			teleport: ["9L0"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			triattack: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	honedge: {
		learnset: {
			aerialace: ["9M", "9L12"],
			brickbreak: ["9M"],
			closecombat: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			headbutt: ["9M"],
			irondefense: ["9M", "9L32"],
			ironhead: ["9M", "9L38"],
			metalsound: ["9L16"],
			nightslash: ["9M"],
			protect: ["9M"],
			psychocut: ["9L22"],
			reflect: ["9M"],
			rockslide: ["9M"],
			sacredsword: ["9L0"],
			screech: ["9L1"],
			shadowclaw: ["9M", "9L24"],
			shadowsneak: ["9L4"],
			slash: ["9L20"],
			solarblade: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L44"],
			tackle: ["9L1"],
		},
	},
	doublade: {
		learnset: {
			aerialace: ["9M", "9L12"],
			brickbreak: ["9M"],
			closecombat: ["9M"],
			doublehit: ["9M"],
			dualchop: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			headbutt: ["9M"],
			irondefense: ["9M", "9L32"],
			ironhead: ["9M", "9L38"],
			metalsound: ["9L16"],
			nightslash: ["9M"],
			protect: ["9M"],
			psychocut: ["9L22"],
			razorwind: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			sacredsword: ["9L0"],
			screech: ["9L1"],
			shadowclaw: ["9M", "9L24"],
			shadowsneak: ["9L4"],
			slash: ["9L20"],
			solarblade: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L44"],
			tackle: ["9L1"],
			zenheadbutt: ["9M"],
		},
	},
	aegislash: {
		learnset: {
			aerialace: ["9M", "9L12"],
			brickbreak: ["9M"],
			closecombat: ["9M"],
			doublehit: ["9M"],
			dualchop: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			headsmash: ["9L50"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L32"],
			ironhead: ["9M", "9L38"],
			kingsshield: ["9L0"],
			metalsound: ["9L16"],
			nightslash: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psychocut: ["9L22"],
			razorwind: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			sacredsword: ["9L0"],
			screech: ["9L1"],
			shadowball: ["9M"],
			shadowclaw: ["9M", "9L24"],
			shadowsneak: ["9L4"],
			slash: ["9L20"],
			solarblade: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L44"],
			tackle: ["9L1"],
			zenheadbutt: ["9M"],
		},
	},
	spritzee: {
		learnset: {
			calmmind: ["9M", "9L33"],
			charm: ["9L30"],
			dazzlinggleam: ["9M", "9L27"],
			disarmingvoice: ["9L10"],
			drainingkiss: ["9L15"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fairywind: ["9L1"],
			faketears: ["9L8"],
			flashcannon: ["9M"],
			healblock: ["9M", "9L44"],
			hypnosis: ["9L48"],
			lightscreen: ["9M"],
			moonblast: ["9L36"],
			nastyplot: ["9M"],
			protect: ["9M"],
			psybeam: ["9L24"],
			psychic: ["9M", "9L40"],
			reflect: ["9M"],
			substitute: ["9M"],
			thunderbolt: ["9M"],
			wish: ["9L22"],
		},
	},
	aromatisse: {
		learnset: {
			calmmind: ["9M", "9L33"],
			chargebeam: ["9M"],
			charm: ["9L30"],
			dazzlinggleam: ["9M", "9L27"],
			disarmingvoice: ["9L10"],
			drainingkiss: ["9L15"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fairywind: ["9L1"],
			faketears: ["9L8"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			healblock: ["9M", "9L44"],
			hyperbeam: ["9M"],
			hypnosis: ["9L48"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			moonblast: ["9L36"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			psybeam: ["9L24"],
			psychic: ["9M", "9L40"],
			psyshock: ["9M"],
			reflect: ["9M"],
			silverwind: ["9M"],
			substitute: ["9M"],
			thunderbolt: ["9M"],
			wish: ["9L22"],
		},
	},
	swirlix: {
		learnset: {
			amnesia: ["9L18"],
			calmmind: ["9M"],
			charm: ["9L1"],
			cottonguard: ["9L24"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9L12"],
			endure: ["9M"],
			energyball: ["9M", "9L27"],
			facade: ["9M"],
			fairywind: ["9L6"],
			faketears: ["9L15"],
			flamethrower: ["9M"],
			lightscreen: ["9M"],
			playrough: ["9M", "9L36"],
			protect: ["9M"],
			psychic: ["9M"],
			safeguard: ["9M"],
			selfdestruct: ["9M"],
			stickyweb: ["9L40"],
			stringshot: ["9L21"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderbolt: ["9M"],
			wish: ["9L32"],
		},
	},
	slurpuff: {
		learnset: {
			amnesia: ["9L18"],
			calmmind: ["9M"],
			charm: ["9L1"],
			cottonguard: ["9L24"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9L12"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M", "9L27"],
			facade: ["9M"],
			fairywind: ["9L6"],
			faketears: ["9L15"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			ominouswind: ["9M"],
			playrough: ["9M", "9L36"],
			protect: ["9M"],
			psychic: ["9M"],
			safeguard: ["9M"],
			selfdestruct: ["9M"],
			silverwind: ["9M"],
			stickyweb: ["9L40"],
			stringshot: ["9L21"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderbolt: ["9M"],
			wish: ["9L32"],
		},
	},
	inkay: {
		learnset: {
			calmmind: ["9M"],
			closecombat: ["9M", "9L54"],
			darkpulse: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L6"],
			flamethrower: ["9M"],
			futuresight: ["9M"],
			headbutt: ["9M"],
			hypnosis: ["9L3"],
			knockoff: ["9M", "9L14"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mimic: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M", "9L24"],
			peck: ["9L1"],
			protect: ["9M"],
			psybeam: ["9L15"],
			psychic: ["9M"],
			psychocut: ["9L33"],
			psyshock: ["9M", "9L37"],
			reflect: ["9M"],
			rockslide: ["9M"],
			slash: ["9L21"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderbolt: ["9M"],
			topsyturvy: ["9L42"],
			zenheadbutt: ["9M"],
		},
	},
	malamar: {
		learnset: {
			bulkup: ["9M"],
			calmmind: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L54"],
			cometpunch: ["9M"],
			darkpulse: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L6"],
			flamethrower: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L3"],
			knockoff: ["9M", "9L14"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mimic: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M", "9L24"],
			octolock: ["9L0"],
			peck: ["9L1"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psybeam: ["9L15"],
			psychic: ["9M"],
			psychocut: ["9L33"],
			psyshock: ["9M", "9L37"],
			reflect: ["9M"],
			rockslide: ["9M"],
			slash: ["9L21"],
			stealthrock: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderbolt: ["9M"],
			topsyturvy: ["9L42"],
			torment: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	binacle: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			bubblebeam: ["9L14"],
			bulldoze: ["9M", "9L18"],
			dig: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			icebeam: ["9M"],
			infestation: ["9L9"],
			irondefense: ["9M", "9L35"],
			liquidation: ["9M", "9L45"],
			mudshot: ["9M"],
			nightslash: ["9M", "9L40"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockblast: ["9L16"],
			rockslide: ["9M"],
			rockthrow: ["9L12"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			screech: ["9L1"],
			shadowclaw: ["9M"],
			slash: ["9L23"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L50"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			xscissor: ["9M"],
		},
	},
	barbaracle: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M"],
			brickbreak: ["9M", "9L43"],
			bubblebeam: ["9L14"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L18"],
			closecombat: ["9M", "9L54"],
			cometpunch: ["9M"],
			dig: ["9M"],
			doublehit: ["9M"],
			dragonclaw: ["9M"],
			dualchop: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			infestation: ["9L9"],
			irondefense: ["9M", "9L35"],
			liquidation: ["9M", "9L45"],
			meteorbeam: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			nightslash: ["9M", "9L40"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			rockblast: ["9L16"],
			rockslide: ["9M"],
			rockthrow: ["9L12"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			screech: ["9L1"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			slash: ["9L23"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L50"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			xscissor: ["9M"],
		},
	},
	skrelp: {
		learnset: {
			acidspray: ["9M"],
			bubblebeam: ["9L15"],
			chillingwater: ["9M"],
			doubleteam: ["9M", "9L22"],
			dragonpulse: ["9M", "9L36"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gunkshot: ["9M"],
			hydropump: ["9M", "9L46"],
			liquidation: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L10"],
			outrage: ["9M"],
			playrough: ["9M"],
			poisonjab: ["9M", "9L32"],
			protect: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M", "9L40"],
			sludgewave: ["9L52"],
			smokescreen: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L5"],
			thunderbolt: ["9M"],
			toxic: ["9M", "9L25"],
			toxicspikes: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L30"],
		},
	},
	dragalge: {
		learnset: {
			acidspray: ["9M"],
			bubblebeam: ["9L15"],
			chillingwater: ["9M"],
			doubleteam: ["9M", "9L22"],
			dracometeor: ["9M"],
			dragonpulse: ["9M", "9L36"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gunkshot: ["9M"],
			hydropump: ["9M", "9L46"],
			hyperbeam: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L10"],
			outrage: ["9M"],
			playrough: ["9M"],
			poisonjab: ["9M", "9L32"],
			protect: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M", "9L40"],
			sludgewave: ["9L52"],
			smokescreen: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L5"],
			thunderbolt: ["9M"],
			toxic: ["9M", "9L25"],
			toxicspikes: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L30"],
		},
	},
	clauncher: {
		learnset: {
			aquajet: ["9L13"],
			aurasphere: ["9L34"],
			blizzard: ["9M"],
			bounce: ["9L45"],
			bubblebeam: ["9L10"],
			chillingwater: ["9M"],
			darkpulse: ["9M", "9L40"],
			dragonpulse: ["9M", "9L48"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			flipturn: ["9M"],
			hydropump: ["9M", "9L52"],
			icebeam: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L16"],
			protect: ["9M"],
			rockslide: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M", "9L30"],
			uturn: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L24"],
		},
	},
	clawitzer: {
		learnset: {
			acidspray: ["9M"],
			aquajet: ["9L13"],
			aurasphere: ["9L34"],
			blizzard: ["9M"],
			bounce: ["9L45"],
			bubblebeam: ["9L10"],
			chillingwater: ["9M"],
			darkpulse: ["9M", "9L40"],
			dragonpulse: ["9M", "9L48"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M", "9L55"],
			hydropump: ["9M", "9L52"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L16"],
			protect: ["9M"],
			rockslide: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M", "9L30"],
			uturn: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L24"],
		},
	},
	helioptile: {
		learnset: {
			agility: ["9M"],
			breakingswipe: ["9L30"],
			bulldoze: ["9M", "9L24"],
			charge: ["9L42"],
			darkpulse: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			morningsun: ["9L32"],
			paraboliccharge: ["9L20"],
			protect: ["9M"],
			quickattack: ["9L12"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			seedbomb: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M", "9L15"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L50"],
			thunderbolt: ["9M", "9L36"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L1"],
			uturn: ["9M"],
			voltswitch: ["9M", "9L28"],
			wildcharge: ["9M"],
		},
	},
	heliolisk: {
		learnset: {
			agility: ["9M"],
			breakingswipe: ["9L30"],
			bulldoze: ["9M", "9L24"],
			charge: ["9L42"],
			chargebeam: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			dragonpulse: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			morningsun: ["9L32"],
			paraboliccharge: ["9L20"],
			protect: ["9M"],
			quickattack: ["9L12"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			seedbomb: ["9M"],
			shedtail: ["9L0"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M", "9L15"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L50"],
			thunderbolt: ["9M", "9L36"],
			thunderpunch: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L1"],
			uturn: ["9M"],
			voltswitch: ["9M", "9L28"],
			wildcharge: ["9M"],
		},
	},
	tyrunt: {
		learnset: {
			ancientpower: ["9M"],
			bite: ["9L16"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			charm: ["9L12"],
			closecombat: ["9M"],
			crunch: ["9M", "9L32"],
			darkpulse: ["9M"],
			dig: ["9M"],
			dracometeor: ["9M"],
			dragonclaw: ["9M", "9L36"],
			dragonpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L44"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			meteorbeam: ["9M"],
			outrage: ["9M"],
			playrough: ["9M"],
			poisonfang: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L4"],
			rockblast: ["9L24"],
			rockslide: ["9M", "9L28"],
			rockthrow: ["9L8"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	tyrantrum: {
		learnset: {
			ancientpower: ["9M"],
			bite: ["9L16"],
			bodyslam: ["9M"],
			breakingswipe: ["9L1"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			charm: ["9L12"],
			closecombat: ["9M"],
			crunch: ["9M", "9L32"],
			darkpulse: ["9M"],
			dig: ["9M"],
			dracometeor: ["9M"],
			dragonclaw: ["9M", "9L36"],
			dragonpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L44"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M", "9L52"],
			headsmash: ["9L58"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			meteorbeam: ["9M"],
			outrage: ["9M"],
			playrough: ["9M"],
			poisonfang: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L4"],
			rockblast: ["9L24"],
			rockslide: ["9M", "9L28"],
			rockthrow: ["9L8"],
			rocktomb: ["9M"],
			scaleshot: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	amaura: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M", "9L52"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			darkpulse: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			freezedry: ["9L36"],
			growl: ["9L1"],
			hyperbeam: ["9M", "9L56"],
			hypervoice: ["9M"],
			icebeam: ["9M", "9L40"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M", "9L44"],
			meteorbeam: ["9M"],
			mist: ["9L20"],
			outrage: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rockblast: ["9L24"],
			rockslide: ["9M"],
			rockthrow: ["9L10"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L16"],
			thunderbolt: ["9M"],
			thunderwave: ["9M", "9L28"],
			zenheadbutt: ["9M"],
		},
	},
	aurorus: {
		learnset: {
			ancientpower: ["9M"],
			blizzard: ["9M", "9L52"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			darkpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			freezedry: ["9L36"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M", "9L56"],
			hypervoice: ["9M"],
			icebeam: ["9M", "9L40"],
			icehammer: ["9L0"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L44"],
			meteorbeam: ["9M"],
			mist: ["9L20"],
			outrage: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			rockblast: ["9L24"],
			rockslide: ["9M"],
			rockthrow: ["9L10"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			sheercold: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L16"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M", "9L28"],
			zenheadbutt: ["9M"],
		},
	},
	sylveon: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9L0"],
			curse: ["9M"],
			dazzlinggleam: ["9M", "9L35"],
			dig: ["9M"],
			disarmingvoice: ["9L15"],
			doubleedge: ["9M", "9L0"],
			drainingkiss: ["9L30"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L45"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			hypervoice: ["9M", "9L40"],
			irontail: ["9M"],
			lightscreen: ["9M", "9L25"],
			mimic: ["9M"],
			moonblast: ["9L50"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9L10"],
			reflect: ["9M"],
			roar: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			swift: ["9M", "9L0"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			takedown: ["9L0"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			wish: ["9L0"],
		},
	},
	hawlucha: {
		learnset: {
			aerialace: ["9M", "9L12"],
			agility: ["9M"],
			airslash: ["9L44"],
			bodyslam: ["9M"],
			bounce: ["9L28"],
			bravebird: ["9L52"],
			brickbreak: ["9M", "9L24"],
			bulkup: ["9M"],
			closecombat: ["9M"],
			cometpunch: ["9M"],
			detect: ["9L8"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			featherdance: ["9L20"],
			firepunch: ["9M"],
			fly: ["9M"],
			flyingpress: ["9L36"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			lowsweep: ["9M"],
			lunge: ["9L26"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			skullbash: ["9M"],
			skyattack: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L40"],
			tackle: ["9L1"],
			taunt: ["9M", "9L32"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			wingattack: ["9L4"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	dedenne: {
		learnset: {
			agility: ["9M"],
			charge: ["9L5"],
			chargebeam: ["9M"],
			charm: ["9L10"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			eerieimpulse: ["9L20"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			nuzzle: ["9L1"],
			paraboliccharge: ["9L15"],
			playrough: ["9M", "9L30"],
			protect: ["9M"],
			seedbomb: ["9M"],
			substitute: ["9M"],
			superfang: ["9L40"],
			swift: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			thunder: ["9M", "9L50"],
			thunderbolt: ["9M", "9L35"],
			thunderpunch: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			voltswitch: ["9M", "9L25"],
			wildcharge: ["9M"],
		},
	},
	carbink: {
		learnset: {
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			dazzlinggleam: ["9M", "9L23"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M", "9L32"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L25"],
			ironhead: ["9M"],
			lightscreen: ["9M", "9L30"],
			magnetbomb: ["9M"],
			meteorbeam: ["9M"],
			moonblast: ["9L45"],
			powergem: ["9M", "9L28"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M", "9L35"],
			rockthrow: ["9L12"],
			rocktomb: ["9M"],
			selfdestruct: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M", "9L38"],
			stoneedge: ["9M", "9L52"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L15"],
		},
	},
	goomy: {
		learnset: {
			absorb: ["9L1"],
			bodyslam: ["9M", "9L45"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			curse: ["9M", "9L41"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonpulse: ["9M", "9L30"],
			endure: ["9M"],
			facade: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L18"],
			outrage: ["9M"],
			protect: ["9M", "9L15"],
			rockslide: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L56"],
			tackle: ["9L1"],
			takedown: ["9L35"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M", "9L25"],
		},
	},
	sliggoo: {
		learnset: {
			absorb: ["9L1"],
			acidarmor: ["9L1"],
			acidspray: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M", "9L45"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			curse: ["9M", "9L41"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonpulse: ["9M", "9L30"],
			endure: ["9M"],
			facade: ["9M"],
			icebeam: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L18"],
			outrage: ["9M"],
			protect: ["9M", "9L15"],
			rockslide: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L56"],
			tackle: ["9L1"],
			takedown: ["9L35"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M", "9L25"],
		},
	},
	sliggoohisui: {
		learnset: {
			absorb: ["9L1"],
			acidarmor: ["9L1"],
			acidspray: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M", "9L45"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			curse: ["9M", "9L41"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonpulse: ["9M", "9L30"],
			endure: ["9M"],
			facade: ["9M"],
			icebeam: ["9M"],
			irondefense: ["9M", "9L0"],
			ironhead: ["9M"],
			magnetbomb: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L18"],
			outrage: ["9M"],
			protect: ["9M", "9L15"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sludgebomb: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L56"],
			tackle: ["9L1"],
			takedown: ["9L35"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M", "9L25"],
		},
	},
	goodra: {
		learnset: {
			absorb: ["9L1"],
			acidarmor: ["9L1"],
			acidspray: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M", "9L45"],
			breakingswipe: ["9L1"],
			bulldoze: ["9M"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			curse: ["9M", "9L41"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L30"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			knockoff: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L18"],
			outrage: ["9M"],
			powerwhip: ["9L58"],
			protect: ["9M", "9L15"],
			rockslide: ["9M"],
			scald: ["9M"],
			sludgebomb: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L56"],
			tackle: ["9L1"],
			takedown: ["9L35"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			toxic: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M", "9L25"],
		},
	},
	goodrahisui: {
		learnset: {
			absorb: ["9L1"],
			acidarmor: ["9L1"],
			acidspray: ["9M"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M", "9L45"],
			breakingswipe: ["9L0"],
			bulldoze: ["9M"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			curse: ["9M", "9L41"],
			dracometeor: ["9M"],
			dragonbreath: ["9L10"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L30"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			heavyslam: ["9L55"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			irondefense: ["9M", "9L1"],
			ironhead: ["9M"],
			irontail: ["9M", "9L44"],
			knockoff: ["9M"],
			magnetbomb: ["9M"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L18"],
			outrage: ["9M"],
			protect: ["9M", "9L15"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9L58"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M", "9L56"],
			tackle: ["9L1"],
			takedown: ["9L35"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			toxic: ["9M"],
			watergun: ["9L5"],
			waterpulse: ["9M", "9L25"],
		},
	},
	klefki: {
		learnset: {
			calmmind: ["9M"],
			dazzlinggleam: ["9M", "9L44"],
			doubleteam: ["9M"],
			drainingkiss: ["9L24"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L8"],
			flashcannon: ["9M", "9L36"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			healblock: ["9M", "9L52"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			metalclaw: ["9L13"],
			metalsound: ["9L20"],
			playrough: ["9M", "9L40"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			spikes: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			torment: ["9M"],
		},
	},
	phantump: {
		learnset: {
			confuseray: ["9L12"],
			curse: ["9M", "9L50"],
			darkpulse: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			forestscurse: ["9L32"],
			gigadrain: ["9M"],
			growth: ["9L24"],
			healblock: ["9M"],
			hornleech: ["9L28"],
			leechseed: ["9L8"],
			phantomforce: ["9L36"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			willowisp: ["9M", "9L16"],
			woodhammer: ["9L44"],
		},
	},
	trevenant: {
		learnset: {
			calmmind: ["9M"],
			confuseray: ["9L12"],
			curse: ["9M", "9L50"],
			darkpulse: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			focusblast: ["9M"],
			forestscurse: ["9L32"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			growth: ["9L24"],
			healblock: ["9M"],
			hornleech: ["9L28"],
			hyperbeam: ["9M"],
			leechseed: ["9L8"],
			phantomforce: ["9L36"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M", "9L30"],
			shadowpunch: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			willowisp: ["9M", "9L16"],
			woodhammer: ["9L44"],
			xscissor: ["9M"],
		},
	},
	pumpkaboo: {
		learnset: {
			brutalswing: ["9L24"],
			bulletseed: ["9M", "9L20"],
			confuseray: ["9L8"],
			curse: ["9M"],
			darkpulse: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			gigadrain: ["9M"],
			hypnosis: ["9L27"],
			leechseed: ["9L16"],
			lightscreen: ["9M"],
			mysticalfire: ["9L40"],
			powerwhip: ["9L46"],
			protect: ["9M"],
			psychic: ["9M"],
			razorleaf: ["9L12"],
			rockslide: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L36"],
			shadowsneak: ["9L4"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			trickortreat: ["9L1"],
			willowisp: ["9M"],
		},
	},
	pumpkaboosuper: {},
	gourgeist: {
		learnset: {
			brutalswing: ["9L24"],
			bulletseed: ["9M", "9L20"],
			confuseray: ["9L8"],
			curse: ["9M"],
			darkpulse: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			explosion: ["9L52"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L27"],
			leechseed: ["9L16"],
			lightscreen: ["9M"],
			moonblast: ["9L1"],
			mysticalfire: ["9L40"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			phantomforce: ["9L44"],
			powerwhip: ["9L46"],
			protect: ["9M"],
			psychic: ["9M"],
			razorleaf: ["9L12"],
			rockslide: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L36"],
			shadowclaw: ["9M"],
			shadowsneak: ["9L4"],
			silverwind: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			trickortreat: ["9L1"],
			willowisp: ["9M"],
		},
	},
	bergmite: {
		learnset: {
			bite: ["9L21"],
			blizzard: ["9M", "9L54"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L33"],
			curse: ["9M", "9L9"],
			doubleedge: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			harden: ["9L1"],
			icebeam: ["9M"],
			icefang: ["9M", "9L24"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M", "9L27"],
			protect: ["9M", "9L15"],
			recover: ["9L30"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			tackle: ["9L3"],
			takedown: ["9L36"],
		},
	},
	avalugg: {
		learnset: {
			bite: ["9L21"],
			blizzard: ["9M", "9L54"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L33"],
			curse: ["9M", "9L9"],
			doubleedge: ["9M", "9L42"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			heavyslam: ["9L1"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M", "9L24"],
			iciclecrash: ["9L39"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M", "9L27"],
			protect: ["9M", "9L15"],
			recover: ["9L30"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sheercold: ["9M"],
			skullbash: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L3"],
			takedown: ["9L36"],
		},
	},
	avalugghisui: {
		learnset: {
			ancientpower: ["9M"],
			bite: ["9L21"],
			blizzard: ["9M", "9L54"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L33"],
			curse: ["9M", "9L9"],
			dig: ["9M"],
			doubleedge: ["9M", "9L42"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			heavyslam: ["9L1"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M", "9L24"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L12"],
			irondefense: ["9M", "9L27"],
			ironhead: ["9M", "9L48"],
			meteorbeam: ["9M"],
			protect: ["9M", "9L15"],
			recover: ["9L30"],
			rockblast: ["9L39"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sheercold: ["9M"],
			skullbash: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M", "9L46"],
			substitute: ["9M"],
			surf: ["9M"],
			tackle: ["9L3"],
			takedown: ["9L36"],
		},
	},
	noibat: {
		learnset: {
			absorb: ["9L1"],
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L36"],
			bite: ["9L20"],
			brickbreak: ["9M"],
			darkpulse: ["9M"],
			doubleteam: ["9M", "9L12"],
			dracometeor: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			gust: ["9L4"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L44"],
			hypervoice: ["9M"],
			leechlife: ["9L24"],
			outrage: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			screech: ["9L40"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			superfang: ["9L32"],
			supersonic: ["9L8"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			uturn: ["9M"],
			whirlwind: ["9M", "9L28"],
			wildcharge: ["9M"],
			wingattack: ["9L16"],
		},
	},
	noivern: {
		learnset: {
			absorb: ["9L1"],
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L36"],
			bite: ["9L20"],
			bodyslam: ["9M"],
			boomburst: ["9L52"],
			brickbreak: ["9M"],
			darkpulse: ["9M"],
			doubleteam: ["9M", "9L12"],
			dracometeor: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L0"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			gust: ["9L4"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L44"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			leechlife: ["9L24"],
			moonlight: ["9L1"],
			outrage: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			razorwind: ["9M"],
			scaleshot: ["9M"],
			screech: ["9L40"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skyattack: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			superfang: ["9L32"],
			supersonic: ["9L8"],
			swift: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			torment: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			whirlwind: ["9M", "9L28"],
			wildcharge: ["9M"],
			wingattack: ["9L16"],
		},
	},
	xerneas: {
		inherit: true,
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M", "9L75"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			geomancy: ["9L55", "9S6"],
			gigaimpact: ["9M", "9L85"],
			hornleech: ["9L35", "9S6"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lightscreen: ["9M", "9L5"],
			megahorn: ["9L70", "9S6"],
			moonblast: ["9L60", "9S6"],
			nightslash: ["9M", "9L20"],
			outrage: ["9M", "9L80"],
			petaldance: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			seedbomb: ["9M"],
			silverwind: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L50"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	yveltal: {
		inherit: true,
		learnset: {
			airslash: ["9L35"],
			bodyslam: ["9M"],
			darkpulse: ["9M", "9L40", "9S6"],
			doubleteam: ["9M", "9L1"],
			dragonclaw: ["9M"],
			dragonrush: ["9L65"],
			dreameater: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			focusblast: ["9M", "9L75"],
			gigaimpact: ["9M"],
			gust: ["9L1"],
			healblock: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M", "9L70", "9S6"],
			hyperbeam: ["9M", "9L85"],
			hypervoice: ["9M"],
			oblivionwing: ["9L55", "9S6"],
			ominouswind: ["9M"],
			phantomforce: ["9L60"],
			protect: ["9M"],
			psychic: ["9M", "9L45", "9S6"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skyattack: ["9M"],
			snarl: ["9L10"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M", "9L5"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	zygarde: {
		inherit: true,
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9M"],
			breakingswipe: ["9L44"],
			brickbreak: ["9M"],
			bulldoze: ["9M", "9L1"],
			coreenforcer: ["9L1"],
			crunch: ["9M", "9L32"],
			dig: ["9M", "9L16"],
			dracometeor: ["9M"],
			dragonbreath: ["9L1"],
			dragonpulse: ["9M", "9L40"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L80"],
			endure: ["9M"],
			extremespeed: ["9L70"],
			facade: ["9M"],
			fissure: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9L56"],
			haze: ["9L8"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			ironhead: ["9M"],
			landswrath: ["9L1"],
			magnetbomb: ["9M"],
			outrage: ["9M", "9L88"],
			poisonfang: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rockslide: ["9M"],
			safeguard: ["9M", "9L24"],
			scaleshot: ["9M"],
			scorchingsands: ["9M"],
			sludgewave: ["9L60"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thousandarrows: ["9L1"],
			thousandwaves: ["9L1"],
			triattack: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	zygarde10: {
		inherit: true,
		learnset: {
			coreenforcer: ["9S6"],
			landswrath: ["9S6"],
			thousandarrows: ["9S6"],
			thousandwaves: ["9S6"],
		},
	},
	diancie: {
		inherit: true,
		learnset: {
			amnesia: ["9L7"],
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			dazzlinggleam: ["9M"],
			diamondstorm: ["9L1", "9S2"],
			drainingkiss: ["9L21", "9S2"],
			earthpower: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9L14"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M", "9L42"],
			magnetbomb: ["9M"],
			meteorbeam: ["9M"],
			metronome: ["9M"],
			moonblast: ["9L54", "9S2"],
			playrough: ["9M"],
			powergem: ["9M", "9L44"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M", "9L33"],
			rockthrow: ["9L1"],
			rocktomb: ["9M"],
			safeguard: ["9M"],
			scorchingsands: ["9M"],
			silverwind: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M", "9L46", "9S2"],
			stoneedge: ["9M", "9L50"],
			substitute: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
		},
	},
	hoopa: {
		inherit: true,
		learnset: {
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confusion: ["9L1"],
			darkpulse: ["9M"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hyperspacefury: ["9L60"],
			hyperspacehole: ["9L60"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L22"],
			lightscreen: ["9M", "9L15"],
			nastyplot: ["9M", "9L45"],
			ominouswind: ["9M"],
			phantomforce: ["9L35"],
			protect: ["9M"],
			psybeam: ["9L19"],
			psychic: ["9M", "9L52"],
			psychicfangs: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rocktomb: ["9M"],
			shadowball: ["9M", "9L42"],
			shadowpunch: ["9M"],
			silverwind: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			zenheadbutt: ["9M", "9L38"],
		},
	},
	volcanion: {
		inherit: true,
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			dig: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9L60"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M", "9L1"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M", "9L50"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L40"],
			heatcrash: ["9L30"],
			heatwave: ["9M"],
			heavyslam: ["9L42"],
			hydropump: ["9M", "9L46"],
			hyperbeam: ["9M"],
			leer: ["9L6"],
			liquidation: ["9M"],
			mist: ["9L40"],
			mudshot: ["9M", "9L18"],
			overheat: ["9M", "9L54"],
			protect: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scald: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			sludgebomb: ["9M"],
			solarbeam: ["9M"],
			steameruption: ["9L1"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			takedown: ["9L33"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L24"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
		},
	},
	crabrawler: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L22"],
			bubblebeam: ["9L13"],
			bulkup: ["9M", "9L25"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M", "9L49"],
			cometpunch: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L45"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firstimpression: ["9M"],
			focusblast: ["9M"],
			gunkshot: ["9M"],
			harden: ["9L1"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L42"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			leer: ["9L9"],
			liquidation: ["9M"],
			machpunch: ["9L30"],
			mudshot: ["9M"],
			protect: ["9M", "9L17"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L1"],
			rocktomb: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	crabominable: {
		learnset: {
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L22"],
			bubblebeam: ["9L13"],
			bulkup: ["9M", "9L25"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M", "9L49"],
			cometpunch: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L45"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firstimpression: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icehammer: ["9L34"],
			icepunch: ["9M", "9L0"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M", "9L42"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			leer: ["9L9"],
			liquidation: ["9M"],
			machpunch: ["9L30"],
			mudshot: ["9M"],
			protect: ["9M", "9L17"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L1"],
			rocktomb: ["9M"],
			sheercold: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			takedown: ["9L20"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	wimpod: {
		learnset: {
			endure: ["9M"],
			facade: ["9M"],
			harden: ["9L1"],
			mudshot: ["9M"],
			protect: ["9M"],
			rollout: ["9L1"],
			scald: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			waterfall: ["9M"],
		},
	},
	golisopod: {
		learnset: {
			agility: ["9M"],
			aquajet: ["9L16"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			closecombat: ["9M"],
			darkpulse: ["9M"],
			doublehit: ["9M"],
			drillrun: ["9L30"],
			dualchop: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			firstimpression: ["9M", "9L0"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M", "9L20"],
			ironhead: ["9M", "9L36"],
			leechlife: ["9L32"],
			liquidation: ["9M", "9L53"],
			metalclaw: ["9L22"],
			muddywater: ["9M"],
			mudshot: ["9M", "9L12"],
			nightslash: ["9M"],
			pinmissile: ["9L42"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L4"],
			rocktomb: ["9M"],
			rollout: ["9L1"],
			scald: ["9M"],
			screech: ["9L26"],
			shadowclaw: ["9M"],
			slash: ["9L28"],
			sludgebomb: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L48"],
			taunt: ["9M"],
			uturn: ["9M"],
			waterfall: ["9M"],
			xscissor: ["9M"],
		},
	},
	sandygast: {
		learnset: {
			absorb: ["9L1"],
			ancientpower: ["9M"],
			bulldoze: ["9M", "9L18"],
			chillingwater: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M", "9L46"],
			earthpower: ["9M", "9L50"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigadrain: ["9M", "9L35"],
			harden: ["9L1"],
			hypnosis: ["9L24"],
			infestation: ["9L13"],
			irondefense: ["9M", "9L30"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L10"],
			scorchingsands: ["9M"],
			shadowball: ["9M", "9L41"],
			shoreup: ["9L52"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
		},
	},
	palossand: {
		learnset: {
			absorb: ["9L1"],
			ancientpower: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M", "9L18"],
			chillingwater: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M", "9L46"],
			earthpower: ["9M", "9L50"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			gigadrain: ["9M", "9L35"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			hypnosis: ["9L24"],
			infestation: ["9L13"],
			irondefense: ["9M", "9L30"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9L10"],
			scorchingsands: ["9M"],
			shadowball: ["9M", "9L41"],
			shoreup: ["9L52"],
			sludgebomb: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			torment: ["9M"],
		},
	},
	mimikyu: {
		learnset: {
			bulkup: ["9M"],
			charm: ["9L48"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M", "9L12"],
			drainpunch: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			mimic: ["9M", "9L24"],
			nightslash: ["9M"],
			phantomforce: ["9L60"],
			playrough: ["9M", "9L54"],
			protect: ["9M"],
			psychic: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M", "9L34"],
			shadowsneak: ["9L6"],
			slash: ["9L28"],
			splash: ["9L1"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			woodhammer: ["9L42"],
			workup: ["9M"],
			xscissor: ["9M"],
		},
	},
	drampa: {
		learnset: {
			amnesia: ["9L32"],
			blizzard: ["9M"],
			bodyslam: ["9M", "9L28"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			dracometeor: ["9M"],
			dragonbreath: ["9L20"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M", "9L35"],
			dragonrush: ["9L56"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M", "9L44"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9L10"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M", "9L50"],
			icebeam: ["9M"],
			icywind: ["9M", "9L25"],
			leer: ["9L1"],
			lightscreen: ["9M", "9L40"],
			outrage: ["9M", "9L54"],
			playrough: ["9M"],
			protect: ["9M", "9L5"],
			razorwind: ["9M"],
			rockslide: ["9M"],
			safeguard: ["9M", "9L15"],
			scaleshot: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			twister: ["9L1"],
			whirlwind: ["9M"],
			workup: ["9M"],
		},
	},
	magearna: {
		inherit: true,
		learnset: {
			agility: ["9M"],
			aurasphere: ["9L66"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M", "9L24"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L1"],
			drainingkiss: ["9L14"],
			eerieimpulse: ["9L28"],
			electroweb: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M", "9L72"],
			fleurcannon: ["9L80"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			irondefense: ["9M", "9L18"],
			ironhead: ["9M", "9L60"],
			lightscreen: ["9M"],
			magnetbomb: ["9M", "9L42"],
			metalsound: ["9L1"],
			petaldance: ["9M"],
			playrough: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psybeam: ["9L30"],
			psychic: ["9M"],
			psyshock: ["9M", "9L50"],
			reflect: ["9M"],
			rollout: ["9L12"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			spikes: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M", "9L36"],
			vacuumwave: ["9M"],
			voltswitch: ["9M"],
			zapcannon: ["9L84"],
			zenheadbutt: ["9M"],
		},
	},
	magearnaoriginal: {
		inherit: true,
		learnset: {
			agility: ["9M"],
			aurasphere: ["9L66"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M", "9L24"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L1"],
			drainingkiss: ["9L14"],
			eerieimpulse: ["9L28"],
			electroweb: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M", "9L72"],
			fleurcannon: ["9L80"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			irondefense: ["9M", "9L18"],
			ironhead: ["9M", "9L60"],
			lightscreen: ["9M"],
			magnetbomb: ["9M", "9L42"],
			metalsound: ["9L1"],
			petaldance: ["9M"],
			playrough: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psybeam: ["9L30"],
			psychic: ["9M"],
			psyshock: ["9M", "9L50"],
			reflect: ["9M"],
			rollout: ["9L12"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			skullbash: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			spikes: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M", "9L36"],
			vacuumwave: ["9M"],
			voltswitch: ["9M"],
			zapcannon: ["9L84"],
			zenheadbutt: ["9M"],
		},
	},
	marshadow: {
		inherit: true,
		learnset: {
			agility: ["9M"],
			aurasphere: ["9L32"],
			blazekick: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L28"],
			bulkup: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M", "9L80"],
			cometpunch: ["9M"],
			drainpunch: ["9M", "9L54"],
			dualchop: ["9M", "9L40"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			firepunch: ["9M", "9L1"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M", "9L1"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			machpunch: ["9L24"],
			ominouswind: ["9M"],
			outrage: ["9M"],
			phantomforce: ["9L64"],
			poisonjab: ["9M"],
			poweruppunch: ["9M", "9L14"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M", "9L18"],
			shadowsneak: ["9L1"],
			spectralthief: ["9L72"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			thunderpunch: ["9M", "9L1"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	zeraora: {
		inherit: true,
		learnset: {
			aerialace: ["9M"],
			agility: ["9M", "9L80"],
			blazekick: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L18"],
			bulkup: ["9M"],
			calmmind: ["9M"],
			charge: ["9L40"],
			closecombat: ["9M", "9L96"],
			cometpunch: ["9M"],
			discharge: ["9M", "9L64"],
			drainpunch: ["9M"],
			dynamicpunch: ["9L56"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M", "9L1"],
			falseswipe: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			lowsweep: ["9M"],
			outrage: ["9M"],
			payday: ["9M"],
			plasmafists: ["9L84"],
			playrough: ["9M"],
			poweruppunch: ["9M", "9L15"],
			protect: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			slash: ["9L24"],
			snarl: ["9L10"],
			spark: ["9L1"],
			substitute: ["9M"],
			swift: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M", "9L48"],
			thunderwave: ["9M"],
			vacuumwave: ["9M"],
			voltswitch: ["9M", "9L32"],
			wildcharge: ["9M", "9L72"],
			workup: ["9M"],
		},
	},
	meltan: {
		learnset: {
			acidarmor: ["9L32"],
			brutalswing: ["9L11"],
			chargebeam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M", "9L40"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			magnetbomb: ["9M"],
			protect: ["9M"],
			selfdestruct: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			tailwhip: ["9L8"],
			thunderbolt: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L24"],
		},
	},
	melmetal: {
		learnset: {
			acidarmor: ["9L32"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L11"],
			chargebeam: ["9M"],
			discharge: ["9M", "9L64"],
			doubleironbash: ["9L80"],
			dynamicpunch: ["9L72"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M", "9L40"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			heavyslam: ["9L0"],
			hyperbeam: ["9M", "9L96"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			magnetbomb: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			selfdestruct: ["9M"],
			solarbeam: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			tailwhip: ["9L8"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M", "9L0"],
			thundershock: ["9L1"],
			thunderwave: ["9M", "9L24"],
		},
	},
	rookidee: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L24"],
			bravebird: ["9L47"],
			dualwingbeat: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L27"],
			fly: ["9M"],
			gust: ["9L10"],
			leer: ["9L1"],
			nastyplot: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			razorwind: ["9M"],
			rocksmash: ["9M"],
			skyattack: ["9M"],
			slash: ["9L36"],
			substitute: ["9M"],
			swagger: ["9M", "9L32"],
			swift: ["9M"],
			takedown: ["9L14"],
			taunt: ["9M", "9L20"],
			uturn: ["9M"],
			wingattack: ["9L18"],
		},
	},
	corvisquire: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L24"],
			bravebird: ["9L47"],
			dualwingbeat: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L27"],
			fly: ["9M"],
			gust: ["9L10"],
			hurricane: ["9M"],
			leer: ["9L1"],
			nastyplot: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			razorwind: ["9M"],
			rocksmash: ["9M"],
			skyattack: ["9M"],
			slash: ["9L36"],
			substitute: ["9M"],
			swagger: ["9M", "9L32"],
			swift: ["9M"],
			takedown: ["9L14"],
			taunt: ["9M", "9L20"],
			uturn: ["9M"],
			wingattack: ["9L18"],
			workup: ["9M"],
		},
	},
	corviknight: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L24"],
			bodyslam: ["9M"],
			bravebird: ["9L47"],
			bulkup: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M", "9L42"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L27"],
			flashcannon: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			gust: ["9L10"],
			heavyslam: ["9L53"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L1"],
			ironhead: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			metalclaw: ["9L0"],
			metalsound: ["9L0"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			peck: ["9L1"],
			protect: ["9M"],
			razorwind: ["9M"],
			reflect: ["9M"],
			rocksmash: ["9M"],
			screech: ["9L1"],
			skyattack: ["9M"],
			slash: ["9L36"],
			steelbeam: ["9M"],
			steelwing: ["9L0"],
			substitute: ["9M"],
			swagger: ["9M", "9L32"],
			swift: ["9M"],
			takedown: ["9L14"],
			taunt: ["9M", "9L20"],
			uturn: ["9M"],
			wingattack: ["9L18"],
			workup: ["9M"],
		},
	},
	nickit: {
		learnset: {
			agility: ["9M"],
			darkpulse: ["9M", "9L38"],
			dig: ["9M"],
			doubleteam: ["9M", "9L44"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L17"],
			firstimpression: ["9M"],
			healblock: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M", "9L15"],
			mimic: ["9M", "9L26"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L22"],
			nightslash: ["9M", "9L34"],
			partingshot: ["9L52"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			roar: ["9M", "9L10"],
			snarl: ["9L12"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			taunt: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
		},
	},
	thievul: {
		learnset: {
			agility: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M", "9L38"],
			dig: ["9M"],
			doubleteam: ["9M", "9L44"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L17"],
			firefang: ["9M"],
			firstimpression: ["9M"],
			gigaimpact: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M", "9L15"],
			mimic: ["9M", "9L26"],
			mudshot: ["9M"],
			nastyplot: ["9M", "9L22"],
			nightslash: ["9M", "9L34"],
			partingshot: ["9L52"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			roar: ["9M", "9L10"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			snarl: ["9L12"],
			substitute: ["9M"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			willowisp: ["9M"],
		},
	},
	toxel: {
		learnset: {
			endure: ["9M"],
			facade: ["9M"],
			growl: ["9L1"],
			nuzzle: ["9L1"],
			protect: ["9M"],
			substitute: ["9M"],
		},
	},
	toxtricity: {
		learnset: {
			acidspray: ["9M", "9L10"],
			boomburst: ["9L48"],
			brickbreak: ["9M"],
			charge: ["9L4"],
			chargebeam: ["9M"],
			discharge: ["9M", "9L30"],
			drainpunch: ["9M"],
			eerieimpulse: ["9L36"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			leer: ["9L1"],
			magnetbomb: ["9M"],
			metalsound: ["9L0"],
			metronome: ["9M"],
			nuzzle: ["9L1"],
			overdrive: ["9L44"],
			poisonjab: ["9M", "9L40"],
			protect: ["9M"],
			screech: ["9L24"],
			sludgebomb: ["9M"],
			sludgewave: ["9L0"],
			snarl: ["9L8"],
			spark: ["9L0"],
			substitute: ["9M"],
			swagger: ["9M", "9L28"],
			swift: ["9M"],
			taunt: ["9M", "9L16"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thundershock: ["9L0"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L32"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
			zapcannon: ["9L50"],
		},
	},
	toxtricitylowkey: {},
	clobbopus: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L24"],
			bulkup: ["9M", "9L28"],
			bulletpunch: ["9L12"],
			chillingwater: ["9M"],
			circlethrow: ["9M", "9L20"],
			closecombat: ["9M", "9L46"],
			cometpunch: ["9M"],
			detect: ["9L15"],
			doublehit: ["9M", "9L32"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			focusblast: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L30"],
			leer: ["9L1"],
			liquidation: ["9M"],
			machpunch: ["9L18"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			poweruppunch: ["9M", "9L10"],
			protect: ["9M"],
			rocksmash: ["9M", "9L1"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			taunt: ["9M", "9L35"],
			vacuumwave: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	grapploct: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L24"],
			bulkup: ["9M", "9L28"],
			bulletpunch: ["9L12"],
			chillingwater: ["9M"],
			circlethrow: ["9M", "9L20"],
			closecombat: ["9M", "9L46"],
			cometpunch: ["9M"],
			detect: ["9L15"],
			dig: ["9M"],
			doublehit: ["9M", "9L32"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L30"],
			leer: ["9L1"],
			liquidation: ["9M"],
			machpunch: ["9L18"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			octolock: ["9L0"],
			poweruppunch: ["9M", "9L10"],
			protect: ["9M"],
			rocksmash: ["9M", "9L1"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			taunt: ["9M", "9L35"],
			topsyturvy: ["9L53"],
			vacuumwave: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			workup: ["9M"],
		},
	},
	perrserker: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L10"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			charm: ["9L37"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dualchop: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			falseswipe: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9L30"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M", "9L0"],
			irontail: ["9M"],
			knockoff: ["9M"],
			liquidation: ["9M"],
			metalclaw: ["9L15"],
			metalsound: ["9L40"],
			metronome: ["9M"],
			mimic: ["9M", "9L44"],
			nastyplot: ["9M", "9L27"],
			nightslash: ["9M"],
			outrage: ["9M", "9L48"],
			payday: ["9M", "9L1"],
			playrough: ["9M"],
			protect: ["9M"],
			screech: ["9L17"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skullbash: ["9M"],
			slash: ["9L22"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tailwhip: ["9L6"],
			takedown: ["9L34"],
			taunt: ["9M", "9L13"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
			workup: ["9M"],
			xscissor: ["9M"],
		},
	},
	sirfetchd: {
		learnset: {
			aerialace: ["9M", "9L16"],
			agility: ["9M", "9L47"],
			bodyslam: ["9M"],
			bravebird: ["9L55"],
			brickbreak: ["9M", "9L40"],
			brutalswing: ["9L24"],
			closecombat: ["9M"],
			curse: ["9M"],
			detect: ["9L1"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M", "9L25"],
			featherdance: ["9L36"],
			firstimpression: ["9M"],
			fly: ["9M"],
			focusenergy: ["9L27"],
			irondefense: ["9M", "9L0"],
			irontail: ["9M"],
			knockoff: ["9M", "9L20"],
			leafblade: ["9L42"],
			leer: ["9L1"],
			meteorassault: ["9L60"],
			nightslash: ["9M"],
			peck: ["9L1"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9L22"],
			razorwind: ["9M"],
			rocksmash: ["9M", "9L10"],
			skullbash: ["9M"],
			skyattack: ["9M"],
			slash: ["9L30"],
			solarblade: ["9M"],
			steelwing: ["9L12"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L34"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
		},
	},
	mrrime: {
		learnset: {
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9L8"],
			chillingwater: ["9M"],
			cometpunch: ["9M"],
			confuseray: ["9L1"],
			confusion: ["9L12"],
			dazzlinggleam: ["9M", "9L44"],
			drainpunch: ["9M"],
			dreameater: ["9M", "9L15"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9L0"],
			firstimpression: ["9M"],
			focusblast: ["9M"],
			freezedry: ["9L40"],
			frostbreath: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L0"],
			headbutt: ["9M"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9L1"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9L1"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			infestation: ["9L17"],
			irondefense: ["9M"],
			lightscreen: ["9M", "9L36"],
			magnetbomb: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L32"],
			mist: ["9L0"],
			nastyplot: ["9M"],
			protect: ["9M", "9L20"],
			psybeam: ["9L28"],
			psychic: ["9M", "9L48"],
			psyshock: ["9M"],
			reflect: ["9M", "9L36"],
			safeguard: ["9M", "9L36"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			smokescreen: ["9L0"],
			solarbeam: ["9M"],
			stealthrock: ["9M", "9L24"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			tripleaxel: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	runerigus: {
		learnset: {
			brutalswing: ["9L16"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9L8"],
			confusion: ["9L1"],
			curse: ["9M", "9L36"],
			darkpulse: ["9M"],
			dragonpulse: ["9M"],
			dreameater: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L44"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9L12"],
			fissure: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9L4"],
			healblock: ["9M"],
			hyperbeam: ["9M"],
			icywind: ["9M"],
			infestation: ["9L22"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			ominouswind: ["9M"],
			partingshot: ["9L48"],
			phantomforce: ["9L46"],
			protect: ["9M", "9L1"],
			psychic: ["9M"],
			psyshock: ["9M", "9L30"],
			rockblast: ["9L20"],
			rockslide: ["9M"],
			rocktomb: ["9M", "9L10"],
			safeguard: ["9M"],
			sandtomb: ["9L1"],
			selfdestruct: ["9M"],
			shadowball: ["9M", "9L40"],
			shadowclaw: ["9M", "9L0"],
			shadowpunch: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	falinks: {
		learnset: {
			agility: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L36"],
			bulkup: ["9M", "9L20"],
			closecombat: ["9M", "9L48"],
			cometpunch: ["9M"],
			doublehit: ["9M"],
			endure: ["9M", "9L25"],
			facade: ["9M"],
			fakeout: ["9M"],
			falseswipe: ["9M"],
			firstimpression: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L10"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L15"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L43"],
			ironhead: ["9M", "9L32"],
			knockoff: ["9M"],
			lowsweep: ["9M"],
			megahorn: ["9L52"],
			noretreat: ["9L40"],
			poisonjab: ["9M"],
			protect: ["9M", "9L1"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L5"],
			rocktomb: ["9M"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	indeedee: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L42"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L10"],
			drainingkiss: ["9L1"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			futuresight: ["9M"],
			growl: ["9L1"],
			healblock: ["9M"],
			heatwave: ["9M"],
			hypervoice: ["9M"],
			magicalleaf: ["9L12"],
			metronome: ["9M"],
			mimic: ["9M"],
			moonblast: ["9L52"],
			moonlight: ["9L22"],
			playrough: ["9M"],
			protect: ["9M"],
			psybeam: ["9L15"],
			psychic: ["9M", "9L35"],
			psyshock: ["9M"],
			razorwind: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			triattack: ["9M", "9L28"],
			vacuumwave: ["9M"],
			wish: ["9L38"],
			zenheadbutt: ["9M"],
		},
	},
	indeedeef: {
		learnset: {
			bodyslam: ["9M"],
			calmmind: ["9M", "9L42"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			disarmingvoice: ["9L10"],
			doubleteam: ["9M"],
			drainingkiss: ["9L1"],
			drainpunch: ["9M"],
			dreameater: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			futuresight: ["9M"],
			growl: ["9L1"],
			healblock: ["9M"],
			hypervoice: ["9M"],
			lightscreen: ["9M"],
			magicalleaf: ["9L12"],
			metronome: ["9M"],
			moonblast: ["9L52"],
			moonlight: ["9L22"],
			playrough: ["9M"],
			protect: ["9M"],
			psybeam: ["9L15"],
			psychic: ["9M", "9L35"],
			psyshock: ["9M"],
			reflect: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			triattack: ["9M", "9L28"],
			wish: ["9L38"],
			zenheadbutt: ["9M"],
		},
	},
	morpeko: {
		learnset: {
			agility: ["9M", "9L44"],
			aurawheel: ["9L57"],
			bite: ["9L18"],
			brickbreak: ["9M"],
			bulletseed: ["9M", "9L48"],
			charge: ["9L25"],
			chargebeam: ["9M"],
			crunch: ["9M", "9L52"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			firefang: ["9M"],
			icefang: ["9M"],
			knockoff: ["9M"],
			leer: ["9L5"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			partingshot: ["9L33"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9L12"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			spark: ["9L30"],
			substitute: ["9M"],
			superfang: ["9L38"],
			swagger: ["9M", "9L7"],
			swift: ["9M"],
			tailwhip: ["9L1"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thundershock: ["9L1"],
			thunderwave: ["9M"],
			torment: ["9M", "9L40"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	kleavor: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L36"],
			ancientpower: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9L20"],
			bugbuzz: ["9L34"],
			closecombat: ["9M"],
			doubleedge: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M", "9L16"],
			dualchop: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusenergy: ["9L28"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lunge: ["9L46"],
			nightslash: ["9M"],
			ominouswind: ["9M"],
			protect: ["9M"],
			quickattack: ["9L1"],
			razorwind: ["9M"],
			rockblast: ["9L50"],
			rockslide: ["9M"],
			rocksmash: ["9M"],
			rocktomb: ["9M"],
			silverwind: ["9M"],
			slash: ["9L24"],
			stealthrock: ["9M"],
			stoneaxe: ["9L0"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M", "9L42"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			wingattack: ["9L12"],
			xscissor: ["9M", "9L32"],
		},
	},
	overqwil: {
		learnset: {
			acidspray: ["9M"],
			agility: ["9M"],
			aquajet: ["9L17"],
			barbbarrage: ["9L28"],
			bite: ["9L1"],
			blizzard: ["9M"],
			bubblebeam: ["9L12"],
			chillingwater: ["9M"],
			crunch: ["9M", "9L46"],
			curse: ["9M"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L50"],
			harden: ["9L4"],
			haze: ["9L15"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			mortalspin: ["9L53"],
			mudshot: ["9M"],
			pinmissile: ["9L32"],
			poisonjab: ["9M", "9L30"],
			poisonsting: ["9L1"],
			protect: ["9M"],
			scaleshot: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sludgebomb: ["9M"],
			spikes: ["9M", "9L20"],
			substitute: ["9M"],
			surf: ["9M"],
			swift: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M", "9L44"],
			toxicspikes: ["9M", "9L36"],
			waterfall: ["9M"],
			watergun: ["9L8"],
			waterpulse: ["9M"],
		},
	},
	fidough: {
		learnset: {
			agility: ["9M"],
			bite: ["9L11"],
			bodyslam: ["9M"],
			bounce: ["9L30"],
			charm: ["9L36"],
			crunch: ["9M", "9L44"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L33"],
			drainingkiss: ["9L14"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			flamecharge: ["9M"],
			growl: ["9L1"],
			icefang: ["9M"],
			lick: ["9L3"],
			mudshot: ["9M"],
			playrough: ["9M", "9L18"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L40"],
			snarl: ["9L26"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L6"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			wish: ["9L47"],
			workup: ["9M", "9L22"],
		},
	},
	dachsbun: {
		learnset: {
			agility: ["9M"],
			bite: ["9L11"],
			bodyslam: ["9M"],
			bounce: ["9L30"],
			charm: ["9L36"],
			crunch: ["9M", "9L44"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L33"],
			drainingkiss: ["9L14"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			flamecharge: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			lick: ["9L3"],
			mudshot: ["9M"],
			playrough: ["9M", "9L18"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L40"],
			seedbomb: ["9M"],
			snarl: ["9L26"],
			substitute: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L6"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			wish: ["9L47"],
			workup: ["9M", "9L22"],
		},
	},
	squawkabilly: {
		learnset: {
			aerialace: ["9M", "9L13"],
			airslash: ["9L46"],
			bravebird: ["9L42"],
			bulkup: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M", "9L34"],
			featherdance: ["9L24"],
			fly: ["9M", "9L30"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lunge: ["9L40"],
			mimic: ["9M", "9L27"],
			partingshot: ["9L52"],
			peck: ["9L1"],
			protect: ["9M"],
			quickattack: ["9L6"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			skyattack: ["9M"],
			substitute: ["9M"],
			swagger: ["9M", "9L38"],
			taunt: ["9M", "9L20"],
			torment: ["9M", "9L10"],
			uturn: ["9M"],
			workup: ["9M"],
		},
	},
	nacli: {
		learnset: {
			ancientpower: ["9M", "9L20"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L47"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			heavyslam: ["9L40"],
			irondefense: ["9M", "9L24"],
			ironhead: ["9M"],
			meteorbeam: ["9M"],
			mudshot: ["9M", "9L7"],
			powergem: ["9M"],
			protect: ["9M"],
			recover: ["9L28"],
			rockslide: ["9M", "9L35"],
			rockthrow: ["9L5"],
			rocktomb: ["9M"],
			skullbash: ["9M"],
			stealthrock: ["9M", "9L38"],
			stoneedge: ["9M", "9L54"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L12"],
			zenheadbutt: ["9M"],
		},
	},
	naclstack: {
		learnset: {
			ancientpower: ["9M", "9L20"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L47"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			heavyslam: ["9L40"],
			hyperbeam: ["9M"],
			irondefense: ["9M", "9L24"],
			ironhead: ["9M"],
			meteorbeam: ["9M"],
			mudshot: ["9M", "9L7"],
			powergem: ["9M"],
			protect: ["9M"],
			recover: ["9L28"],
			rockslide: ["9M", "9L35"],
			rockthrow: ["9L5"],
			rocktomb: ["9M"],
			saltcure: ["9L0"],
			skullbash: ["9M"],
			stealthrock: ["9M", "9L38"],
			stoneedge: ["9M", "9L54"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L12"],
			zenheadbutt: ["9M"],
		},
	},
	garganacl: {
		learnset: {
			ancientpower: ["9M", "9L20"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dynamicpunch: ["9L0"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L47"],
			endure: ["9M"],
			explosion: ["9L60"],
			facade: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L1"],
			headbutt: ["9M", "9L16"],
			heavyslam: ["9L40"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M", "9L24"],
			ironhead: ["9M"],
			meteorbeam: ["9M"],
			mudshot: ["9M", "9L7"],
			powergem: ["9M"],
			protect: ["9M"],
			recover: ["9L28"],
			rockblast: ["9L0"],
			rockslide: ["9M", "9L35"],
			rockthrow: ["9L5"],
			rocktomb: ["9M"],
			saltcure: ["9L0"],
			skullbash: ["9M"],
			stealthrock: ["9M", "9L38"],
			stoneedge: ["9M", "9L54"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L12"],
			thunderpunch: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	charcadet: {
		learnset: {
			confuseray: ["9L10"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L12"],
			flamecharge: ["9M", "9L24"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			heatwave: ["9M"],
			lavaplume: ["9L32"],
			leer: ["9L1"],
			ominouswind: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			smokescreen: ["9L8"],
			substitute: ["9M"],
			willowisp: ["9M", "9L16"],
		},
	},
	armarouge: {
		learnset: {
			acidspray: ["9M"],
			armorcannon: ["9L48"],
			aurasphere: ["9L62"],
			calmmind: ["9M", "9L37"],
			confuseray: ["9L10"],
			darkpulse: ["9M"],
			dragonpulse: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L12"],
			flamecharge: ["9M", "9L24"],
			flamethrower: ["9M", "9L54"],
			flareblitz: ["9M"],
			flashcannon: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M"],
			heatwave: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lavaplume: ["9L32"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			meteorbeam: ["9M"],
			mysticalfire: ["9L1"],
			ominouswind: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			psybeam: ["9L20"],
			psychic: ["9M"],
			psyshock: ["9M", "9L0"],
			reflect: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			smokescreen: ["9L8"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			willowisp: ["9M", "9L16"],
		},
	},
	ceruledge: {
		learnset: {
			bitterblade: ["9L48"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			closecombat: ["9M"],
			confuseray: ["9L10"],
			curse: ["9M"],
			dragonclaw: ["9M"],
			ember: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M", "9L12"],
			flamecharge: ["9M", "9L24"],
			flamethrower: ["9M"],
			flareblitz: ["9M", "9L62"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lavaplume: ["9L32"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			nightslash: ["9M"],
			ominouswind: ["9M"],
			overheat: ["9M"],
			phantomforce: ["9L58"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychocut: ["9L54"],
			razorwind: ["9M"],
			reflect: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M", "9L0"],
			shadowsneak: ["9L0"],
			smokescreen: ["9L8"],
			solarblade: ["9M", "9L44"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M", "9L37"],
			taunt: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M", "9L16"],
			xscissor: ["9M"],
		},
	},
	maschiff: {
		learnset: {
			bite: ["9L14"],
			bodyslam: ["9M"],
			bounce: ["9L38"],
			charm: ["9L12"],
			crunch: ["9M", "9L42"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L49"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			focusenergy: ["9L27"],
			headbutt: ["9M", "9L22"],
			icefang: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lick: ["9L4"],
			lunge: ["9L45"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L18"],
			rocksmash: ["9M"],
			seedbomb: ["9M"],
			snarl: ["9L7"],
			substitute: ["9M"],
			swagger: ["9M", "9L35"],
			tackle: ["9L1"],
			taunt: ["9M", "9L30"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
		},
	},
	mabosstiff: {
		learnset: {
			bite: ["9L14"],
			bodyslam: ["9M"],
			bounce: ["9L38"],
			charm: ["9L12"],
			crunch: ["9M", "9L42"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M", "9L49"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			focusenergy: ["9L27"],
			gigaimpact: ["9M"],
			headbutt: ["9M", "9L22"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			knockoff: ["9M"],
			leer: ["9L1"],
			lick: ["9L4"],
			lunge: ["9L45"],
			outrage: ["9M", "9L56"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L18"],
			rocksmash: ["9M"],
			seedbomb: ["9M"],
			skullbash: ["9M"],
			snarl: ["9L7"],
			substitute: ["9M"],
			swagger: ["9M", "9L35"],
			tackle: ["9L1"],
			taunt: ["9M", "9L30"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			wildcharge: ["9M"],
		},
	},
	shroodle: {
		learnset: {
			acidspray: ["9M", "9L5"],
			bite: ["9L1"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gunkshot: ["9M", "9L54"],
			healblock: ["9M"],
			knockoff: ["9M", "9L40"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L10"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			partingshot: ["9L23"],
			poisonfang: ["9M", "9L14"],
			poisonjab: ["9M", "9L29"],
			protect: ["9M"],
			reflect: ["9M"],
			slash: ["9L21"],
			sludgebomb: ["9M"],
			substitute: ["9M", "9L36"],
			superfang: ["9L18"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M", "9L33"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M", "9L25"],
		},
	},
	grafaiai: {
		learnset: {
			acidspray: ["9M", "9L5"],
			bite: ["9L1"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firstimpression: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M", "9L54"],
			healblock: ["9M"],
			knockoff: ["9M", "9L40"],
			leer: ["9L1"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			metronome: ["9M"],
			mimic: ["9M", "9L10"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			partingshot: ["9L23"],
			poisonfang: ["9M", "9L14"],
			poisonjab: ["9M", "9L29"],
			protect: ["9M"],
			razorwind: ["9M"],
			reflect: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			slash: ["9L21"],
			sludgebomb: ["9M"],
			substitute: ["9M", "9L36"],
			superfang: ["9L18"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M", "9L33"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			triattack: ["9M"],
			uturn: ["9M", "9L25"],
			xscissor: ["9M"],
		},
	},
	capsakid: {
		learnset: {
			bite: ["9L4"],
			bulletseed: ["9M", "9L21"],
			crunch: ["9M", "9L38"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			growth: ["9L10"],
			headbutt: ["9M", "9L24"],
			leafage: ["9L1"],
			leechseed: ["9L16"],
			leer: ["9L1"],
			magicalleaf: ["9L32"],
			protect: ["9M"],
			razorleaf: ["9L13"],
			rollout: ["9L8"],
			seedbomb: ["9M", "9L44"],
			solarbeam: ["9M", "9L48"],
			substitute: ["9M"],
			superfang: ["9L35"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M", "9L28"],
		},
	},
	scovillain: {
		learnset: {
			bite: ["9L4"],
			bulletseed: ["9M", "9L21"],
			crunch: ["9M", "9L38"],
			doublehit: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M", "9L0"],
			flareblitz: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			growth: ["9L10"],
			headbutt: ["9M", "9L24"],
			hyperbeam: ["9M"],
			leafage: ["9L1"],
			leechseed: ["9L16"],
			leer: ["9L1"],
			magicalleaf: ["9L32"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			overheat: ["9M", "9L48"],
			protect: ["9M"],
			razorleaf: ["9L13"],
			rollout: ["9L8"],
			seedbomb: ["9M", "9L44"],
			solarbeam: ["9M", "9L48"],
			spicyextract: ["9L0"],
			substitute: ["9M"],
			superfang: ["9L35"],
			swagger: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M", "9L28"],
		},
	},
	tinkatink: {
		learnset: {
			brickbreak: ["9M"],
			brutalswing: ["9L24"],
			bulldoze: ["9M"],
			drainingkiss: ["9L17"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L1"],
			fakeout: ["9M"],
			faketears: ["9L25"],
			falseswipe: ["9M"],
			flashcannon: ["9M", "9L31"],
			knockoff: ["9M", "9L40"],
			lightscreen: ["9M"],
			metalclaw: ["9L8"],
			metronome: ["9M"],
			playrough: ["9M", "9L35"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L14"],
			rockthrow: ["9L10"],
			rocktomb: ["9M"],
			screech: ["9L20"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
		},
	},
	tinkatuff: {
		learnset: {
			brickbreak: ["9M"],
			brutalswing: ["9L24"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			drainingkiss: ["9L17"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L1"],
			fakeout: ["9M"],
			faketears: ["9L25"],
			falseswipe: ["9M"],
			flashcannon: ["9M", "9L31"],
			knockoff: ["9M", "9L40"],
			lightscreen: ["9M"],
			metalclaw: ["9L8"],
			metronome: ["9M"],
			playrough: ["9M", "9L35"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L14"],
			rockthrow: ["9L10"],
			rocktomb: ["9M"],
			screech: ["9L20"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
		},
	},
	tinkaton: {
		learnset: {
			brickbreak: ["9M"],
			brutalswing: ["9L24"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			drainingkiss: ["9L17"],
			endure: ["9M"],
			facade: ["9M"],
			fairywind: ["9L1"],
			fakeout: ["9M"],
			faketears: ["9L25"],
			falseswipe: ["9M"],
			flashcannon: ["9M", "9L31"],
			gigatonhammer: ["9L0"],
			heavyslam: ["9L44"],
			hyperbeam: ["9M"],
			icehammer: ["9L0"],
			knockoff: ["9M", "9L40"],
			lightscreen: ["9M"],
			metalclaw: ["9L8"],
			metronome: ["9M"],
			playrough: ["9M", "9L35"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L14"],
			rockthrow: ["9L10"],
			rocktomb: ["9M"],
			screech: ["9L20"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			thunderwave: ["9M"],
			woodhammer: ["9L0"],
		},
	},
	cyclizar: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9L23"],
			bodyslam: ["9M"],
			breakingswipe: ["9L14"],
			crunch: ["9M"],
			doubleedge: ["9M", "9L51"],
			dracometeor: ["9M"],
			dragonclaw: ["9M", "9L36"],
			dragonpulse: ["9M", "9L45"],
			dragonrush: ["9L57"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			flamecharge: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M", "9L40"],
			knockoff: ["9M"],
			mudshot: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			powerwhip: ["9L55"],
			protect: ["9M"],
			quickattack: ["9L18"],
			scaleshot: ["9M"],
			shedtail: ["9L31"],
			skullbash: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L25"],
			taunt: ["9M", "9L11"],
			thunderbolt: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M", "9L27"],
			wildcharge: ["9M"],
		},
	},
	glimmet: {
		learnset: {
			acidarmor: ["9L41"],
			acidspray: ["9M", "9L7"],
			ancientpower: ["9M", "9L11"],
			confuseray: ["9L14"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			explosion: ["9L55"],
			facade: ["9M"],
			gunkshot: ["9M"],
			harden: ["9L1"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			meteorbeam: ["9M"],
			mudshot: ["9M"],
			powergem: ["9M", "9L37"],
			protect: ["9M"],
			reflect: ["9M"],
			rockblast: ["9L25"],
			rockslide: ["9M", "9L33"],
			rockthrow: ["9L1"],
			rocktomb: ["9M"],
			selfdestruct: ["9M", "9L29"],
			sludgebomb: ["9M"],
			sludgewave: ["9L46"],
			spikes: ["9M"],
			stealthrock: ["9M", "9L18"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
		},
	},
	glimmora: {
		learnset: {
			acidarmor: ["9L41"],
			acidspray: ["9M", "9L7"],
			ancientpower: ["9M", "9L11"],
			confuseray: ["9L14"],
			dazzlinggleam: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			explosion: ["9L55"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			harden: ["9L1"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			magnetbomb: ["9M"],
			meteorbeam: ["9M", "9L0"],
			mortalspin: ["9L0"],
			mudshot: ["9M"],
			powergem: ["9M", "9L37"],
			protect: ["9M"],
			reflect: ["9M"],
			rockblast: ["9L25"],
			rockslide: ["9M", "9L33"],
			rockthrow: ["9L1"],
			rocktomb: ["9M"],
			selfdestruct: ["9M", "9L29"],
			sludgebomb: ["9M"],
			sludgewave: ["9L46"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			spikyshield: ["9L1"],
			stealthrock: ["9M", "9L18"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M", "9L0"],
		},
	},
	greavard: {
		learnset: {
			bite: ["9L6"],
			bulldoze: ["9M"],
			charm: ["9L46"],
			crunch: ["9M", "9L28"],
			dig: ["9M", "9L16"],
			doubleedge: ["9M", "9L52"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M", "9L12"],
			icefang: ["9M"],
			lick: ["9L3"],
			mudshot: ["9M"],
			ominouswind: ["9M"],
			phantomforce: ["9L41"],
			playrough: ["9M", "9L32"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L9"],
			shadowball: ["9M"],
			shadowsneak: ["9L1"],
			smokescreen: ["9L1"],
			snarl: ["9L20"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L6"],
			thunderfang: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	houndstone: {
		learnset: {
			bite: ["9L6"],
			bulldoze: ["9M"],
			charm: ["9L46"],
			crunch: ["9M", "9L28"],
			dig: ["9M", "9L16"],
			doubleedge: ["9M", "9L52"],
			dreameater: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			growl: ["9L1"],
			headbutt: ["9M", "9L12"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			lastrespects: ["9L0"],
			lick: ["9L3"],
			mudshot: ["9M"],
			ominouswind: ["9M"],
			phantomforce: ["9L41"],
			playrough: ["9M", "9L32"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			roar: ["9M", "9L9"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9L1"],
			smokescreen: ["9L1"],
			snarl: ["9L20"],
			substitute: ["9M"],
			swagger: ["9M"],
			tackle: ["9L1"],
			tailwhip: ["9L6"],
			thunderfang: ["9M"],
			willowisp: ["9M"],
			workup: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	flamigo: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9L35"],
			bravebird: ["9L54"],
			brickbreak: ["9M", "9L42"],
			brutalswing: ["9L21"],
			bulkup: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			detect: ["9L9"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M", "9L26"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9L30"],
			fly: ["9M", "9L47"],
			focusenergy: ["9L15"],
			gigaimpact: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			liquidation: ["9M"],
			lowsweep: ["9M"],
			lunge: ["9L18"],
			mimic: ["9M", "9L1"],
			peck: ["9L1"],
			protect: ["9M"],
			rocksmash: ["9M"],
			skyattack: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			tripleaxel: ["9M"],
			uturn: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			whirlwind: ["9M"],
			wingattack: ["9L12"],
		},
	},
	dondozo: {
		learnset: {
			bodyslam: ["9M", "9L24"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			curse: ["9M", "9L12"],
			doubleedge: ["9M", "9L38"],
			earthquake: ["9M", "9L56"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M", "9L67"],
			gigaimpact: ["9M"],
			heavyslam: ["9L44"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			lick: ["9L8"],
			liquidation: ["9M", "9L32"],
			muddywater: ["9M"],
			mudshot: ["9M"],
			orderup: ["9L50"],
			outrage: ["9M"],
			protect: ["9M"],
			rockslide: ["9M"],
			substitute: ["9M"],
			supersonic: ["9L1"],
			surf: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L18"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	tatsugiri: {
		learnset: {
			ancientpower: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			darkpulse: ["9M"],
			dracometeor: ["9M"],
			dragonpulse: ["9M", "9L52"],
			dragonrush: ["9L47"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			harden: ["9L6"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			mimic: ["9M", "9L34"],
			muddywater: ["9M", "9L39"],
			mudshot: ["9M", "9L25"],
			nastyplot: ["9M", "9L43"],
			outrage: ["9M"],
			protect: ["9M"],
			razorwind: ["9M", "9L12"],
			scald: ["9M"],
			splash: ["9L1"],
			substitute: ["9M"],
			surf: ["9M"],
			taunt: ["9M", "9L28"],
			tripleaxel: ["9M"],
			waterfall: ["9M"],
			watergun: ["9L1"],
			waterpulse: ["9M", "9L17"],
			whirlpool: ["9M", "9L21"],
		},
	},
	tatsugiristretchy: {},
	annihilape: {
		learnset: {
			bodyslam: ["9M"],
			brickbreak: ["9M", "9L25"],
			bulkup: ["9M"],
			bulldoze: ["9M", "9L22"],
			circlethrow: ["9M"],
			closecombat: ["9M", "9L44"],
			cometpunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dualchop: ["9M"],
			dynamicpunch: ["9L54"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M", "9L28"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9L1"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			headbutt: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M", "9L18"],
			leer: ["9L1"],
			lowsweep: ["9M", "9L16"],
			metronome: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M", "9L50"],
			overheat: ["9M"],
			payday: ["9M"],
			phantomforce: ["9L0"],
			poisonjab: ["9M"],
			poweruppunch: ["9M"],
			protect: ["9M"],
			ragefist: ["9L35"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocksmash: ["9M", "9L10"],
			rockthrow: ["9L8"],
			rocktomb: ["9M"],
			screech: ["9L40"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M", "9L0"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swift: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L13"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			workup: ["9M"],
		},
	},
	frigibax: {
		learnset: {
			bite: ["9L24"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			crunch: ["9M", "9L44"],
			dig: ["9M"],
			dracometeor: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L32"],
			dragonpulse: ["9M"],
			dragonrush: ["9L60"],
			endure: ["9M"],
			facade: ["9M"],
			focusenergy: ["9L18"],
			freezedry: ["9L50"],
			icebeam: ["9M", "9L40"],
			icefang: ["9M", "9L29"],
			iciclecrash: ["9L54"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L6"],
			leer: ["9L1"],
			outrage: ["9M"],
			protect: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
		},
	},
	arctibax: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L24"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			crunch: ["9M", "9L44"],
			dig: ["9M"],
			dracometeor: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L32"],
			dragonpulse: ["9M"],
			dragonrush: ["9L60"],
			endure: ["9M"],
			facade: ["9M"],
			focusenergy: ["9L18"],
			freezedry: ["9L50"],
			frostbreath: ["9M"],
			icebeam: ["9M", "9L40"],
			icefang: ["9M", "9L29"],
			iciclecrash: ["9L54"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L6"],
			ironhead: ["9M"],
			leer: ["9L1"],
			outrage: ["9M"],
			protect: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
		},
	},
	baxcalibur: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9L24"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9L1"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M", "9L44"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragonbreath: ["9L12"],
			dragonclaw: ["9M", "9L32"],
			dragonpulse: ["9M"],
			dragonrush: ["9L60"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			falseswipe: ["9M"],
			focusenergy: ["9L18"],
			freezedry: ["9L50"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			glaiverush: ["9L0"],
			hyperbeam: ["9M"],
			icebeam: ["9M", "9L40"],
			icefang: ["9M", "9L29"],
			icehammer: ["9L65"],
			iceshard: ["9L0"],
			iciclecrash: ["9L54"],
			iciclespear: ["9M"],
			icywind: ["9M", "9L6"],
			ironhead: ["9M"],
			leer: ["9L1"],
			outrage: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			scaleshot: ["9M"],
			sheercold: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			tackle: ["9L1"],
			takedown: ["9L36"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	gimmighoul: {
		learnset: {
			confuseray: ["9L1"],
			endure: ["9M"],
			facade: ["9M"],
			lightscreen: ["9M"],
			nastyplot: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			shadowball: ["9M"],
			substitute: ["9M"],
			tackle: ["9L1"],
		},
	},
	gholdengo: {
		learnset: {
			chargebeam: ["9M"],
			cometpunch: ["9M"],
			confuseray: ["9L1"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M", "9L38"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M"],
			lowsweep: ["9M"],
			magnetbomb: ["9M"],
			makeitrain: ["9L56"],
			metalsound: ["9L23"],
			metronome: ["9M"],
			nastyplot: ["9M", "9L63"],
			ominouswind: ["9M", "9L27"],
			powergem: ["9M", "9L49"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9L42"],
			reflect: ["9M"],
			shadowball: ["9M", "9L33"],
			shadowpunch: ["9M", "9L12"],
			steelbeam: ["9M"],
			substitute: ["9M", "9L15"],
			surf: ["9M"],
			tackle: ["9L1"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
		},
	},
};
